/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 4846:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(4687);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js + 2 modules
var defineProperty = __webpack_require__(2167);
// EXTERNAL MODULE: ./node_modules/swiper/core/core.js + 61 modules
var core = __webpack_require__(5557);
;// CONCATENATED MODULE: ./src/js/utils/swiper.js

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var matcher = window.matchMedia("(pointer: fine)");
core/* default.extendDefaults */.Z.extendDefaults(_objectSpread({
  preventClicks: false,
  preventClicksPropagation: false
}, matcher.matches && {
  longSwipesMs: 100,
  longSwipesRatio: 0.2,
  shortSwipes: false
}));

// https://github.com/nolimits4web/swiper/blob/d68a71bea14361010ef201b15359ed6a64c37f4c/src/core/core.js#L91-L98
var BetterClickHandler = function BetterClickHandler(_ref) {
  var swiper = _ref.swiper,
    on = _ref.on,
    emit = _ref.emit;
  var allowClick = false;
  var onClick = function onClick(e) {
    if (allowClick) {
      emit('ppClick', e);
    } else {
      e.preventDefault();

      // https://github.com/nolimits4web/swiper/blob/d68a71bea14361010ef201b15359ed6a64c37f4c/src/core/events/onClick.js
      if (swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  };
  var onTouchStart = function onTouchStart() {
    allowClick = false;
  };
  var onTouchEnd = function onTouchEnd() {
    var data = swiper.touchEventsData;
    var touchEndTime = Date.now();
    var timeDiff = touchEndTime - data.touchStartTime;
    var moveDiff = data.isMoved ? Math.abs(data.currentTranslate - data.startTranslate) : 0;
    // console.log(`touch end details ${timeDiff} ${moveDiff}`);
    allowClick = timeDiff < 200 && moveDiff < 5;
  };
  var onInit = function onInit() {
    swiper.el.addEventListener('click', onClick);
  };
  var onDestroy = function onDestroy() {
    swiper.el.removeEventListener('click', onClick);
  };
  on('init', onInit);
  on('destroy', onDestroy);
  on('touchStart', onTouchStart);
  on('touchEnd', onTouchEnd);
};
core/* default.use */.Z.use(BetterClickHandler);
// EXTERNAL MODULE: ./node_modules/alpinejs/dist/module.esm.js
var module_esm = __webpack_require__(4306);
// EXTERNAL MODULE: ./node_modules/@alpinejs/focus/dist/module.esm.js
var dist_module_esm = __webpack_require__(8678);
;// CONCATENATED MODULE: ./src/styles/main.css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/styles/account.css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/js/bundles/snippets/navigation.js
var navStore = function navStore() {
  return {
    navData: [],
    init: function init() {
      this.setData();
    },
    setData: function setData() {
      var submenus = document.querySelectorAll('.nav-submenu-data');
      this.navData = Array.from(submenus).map(function (submenu) {
        return JSON.parse(submenu.textContent);
      });
    }
  };
};
var navDesktopComponent = function navDesktopComponent() {
  return {
    selectedSubmenuIdx: null,
    isHoveringSubmenu: false,
    hoveringSubmenuIdx: null,
    keyboardOpen: false,
    handleTopCategoryHover: function handleTopCategoryHover(idx) {
      this.selectedSubmenuIdx = idx;
    },
    handleTopCategoryLeave: function handleTopCategoryLeave(idx) {
      var _this = this;
      if (!this.isHoveringSubmenu || this.hoveringSubmenuIdx !== idx) {
        setTimeout(function () {
          _this.selectedSubmenuIdx = null;
        }, 10);
      }
    },
    handleSubmenuMouseEnter: function handleSubmenuMouseEnter(idx) {
      this.isHoveringSubmenu = true;
      this.hoveringSubmenuIdx = idx;
    },
    handleSubmenuMouseLeave: function handleSubmenuMouseLeave() {
      var _this2 = this;
      setTimeout(function () {
        _this2.isHoveringSubmenu = false;
        _this2.hoveringSubmenuIdx = null;
      }, 10);
    }
  };
};
var navMobileComponent = function navMobileComponent() {
  return {
    expandedSubmenuIndexes: [],
    handleExpandSubmenuClick: function handleExpandSubmenuClick(index) {
      this.expandedSubmenuIndexes = [index];
    },
    handleBackNavigation: function handleBackNavigation() {
      this.expandedSubmenuIndexes = [];
    }
  };
};
// EXTERNAL MODULE: ./src/js/utils/index.js
var utils = __webpack_require__(2575);
;// CONCATENATED MODULE: ./src/js/alpine-plugins/x-on-shopify.js
/**
 * A custom directive that allows Alpine components to subscribe to Shopify theme editor events.
 * `x-on-shopify` requires a modifier and a value.
 *
 * Example: x-on-shopify:block-select="onShopifyBlockSelect"
 *
 * Modifier:
 * The modifier should be the name of the Shopify event you want to subscribe to in kebab case
 * e.g. shopify:section:select => x-on-shopify:section-select
 * For a list of all events see:
 * https://shopify.dev/docs/themes/architecture/sections/integrate-sections-with-the-theme-editor#javascript-events
 *
 * Value:
 * The value should be the name of the callback function you want to run when the event is emitted.
 * This should be a method on your Alpine component.
 *
 *
 * IMPORTANT:
 * Ensure you add `data-section-id` and `data-block-id` attributes to your elements where appropriate.
 * These are needed to scope events to specific section instances.
 *
 * You should also add {{ block.shopify_attributes }} to any blocks used. This is required by Shopify's
 * theme editor to correctly identify the target when emitting block events.
 *
 * e.g:
 *  <div data-section-id="{{ section.id }}">
 *    ...
 *    {% for block in section.blocks %}
 *      <div data-block-id="{{ block.id }}" {{ block.shopify_attributes }}>
 *        ...
 *      </div>
 *    {% endfor %}
 *  </div>
 */

var eventNames = ['shopify:inspector:activate', 'shopify:inspector:deactivate', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'];

/**
 * Pub/sub implementation to allow Alpine components to subscribe to
 * scoped Shopify theme events.
 */
var shopifyThemeEvents = {
  events: {},
  subscribe: function subscribe(eventName, fn) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(fn);
  },
  unsubscribe: function unsubscribe(eventName, fn) {
    if (this.events[eventName]) {
      for (var i = 0; i < this.events[eventName].length; i++) {
        if (this.events[eventName][i] === fn) {
          this.events[eventName].splice(i, 1);
          break;
        }
      }
    }
  },
  publish: function publish(eventName, payload) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(function (fn) {
        fn(payload);
      });
    }
  },
  setEventListeners: function setEventListeners() {
    var _this = this;
    eventNames.forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        return _this.emitEvent(event);
      });
    });
  },
  emitEvent: function emitEvent(event) {
    var _this2 = this;
    var sectionId = event.detail.sectionId;
    var normalizedEventName = (0,utils/* convertToCamelCase */.yJ)(event.type);
    var container = document.querySelector("[data-section-id=\"".concat(sectionId, "\"]"));
    if (container !== null) {
      // Include the Shopify event object and the section container node in the payload
      var payload = {
        event: event,
        container: container
      };

      // After editing section content Shopify will re-render the entire section
      // setTimeout is needed to prevent the event from firing before this change
      setTimeout(function () {
        // Scope the event to the section id so we can subscribe to it
        // from each instance of a section
        _this2.publish("".concat(normalizedEventName, ":").concat(sectionId), payload);
      }, 0);
    }
  },
  init: function init() {
    // Only set event listeners in the theme editor
    if (window.Shopify.designMode) {
      this.setEventListeners();
    }
  }
};
/* harmony default export */ function x_on_shopify(Alpine) {
  shopifyThemeEvents.init();
  Alpine.directive('on-shopify', function (el, _ref, _ref2) {
    var _el$dataset;
    var value = _ref.value,
      expression = _ref.expression;
    var evaluate = _ref2.evaluate,
      cleanup = _ref2.cleanup;
    // Early return if not in the theme editor
    if (!window.Shopify.designMode) {
      return;
    }
    var sectionId = el === null || el === void 0 ? void 0 : (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.sectionId;
    var normalizedEventName = (0,utils/* convertToCamelCase */.yJ)("shopify-".concat(value));
    var scopedEventName = "".concat(normalizedEventName, ":").concat(sectionId);
    var callback = function callback() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return evaluate(expression, {
        params: [].concat(args)
      });
    };
    if (sectionId) {
      shopifyThemeEvents.subscribe(scopedEventName, callback);
      cleanup(function () {
        shopifyThemeEvents.unsubscribe('scopedEventName', callback);
      });
    }
  });
}
// EXTERNAL MODULE: ./src/js/utils/dom.js
var dom = __webpack_require__(2090);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/drawer-v2.js



var openDrawers = new Set();
var drawer = function drawer(name) {
  return {
    isClosing: false,
    isOpen: false,
    // Note: it's important to set up props here first b/c not doing and using
    // ...`this.mutationObserver = ...` for example would set mutationObserver for the parent component
    // ... and not necessarily this drawer component
    openDrawer: null,
    closeDrawer: null,
    animationEndHandler: null,
    mutationObserver: null,
    init: function init() {
      // bind 'this' so that openDrawers.delete works since it needs to reference 'this' in any instance of drawer-v2
      this.openDrawer = this._openDrawer.bind(this);
      this.closeDrawer = this._closeDrawer.bind(this);
      this.animationEndHandler = this._animationEndHandler.bind(this);
      this.mutationObserver = new MutationObserver(this.handleMutation.bind(this));
      this.mutationObserver.observe(this.$el, {
        attributes: true,
        attributeFilter: ['open']
      });
    },
    _openDrawer: function _openDrawer() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$dispatch('drawer-open', {
                drawer: _this
              });
              _this.$el.showModal();
              _this.isOpen = true;

              // Immediately blur any focused element inside the dialog
              _this.$nextTick(function () {
                var activeEl = document.activeElement;
                if (activeEl && _this.$el.contains(activeEl)) {
                  activeEl.blur();
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    _animationEndHandler: function _animationEndHandler() {
      openDrawers["delete"](this);
      this.$dispatch('drawer-close', {
        drawer: this
      });
      this.$el.close();
      this.isClosing = false;
      this.isOpen = false;
      this.$el.removeEventListener('transitionend', this.animationEndHandler);
    },
    _closeDrawer: function _closeDrawer() {
      var _this2 = this;
      this.$el.addEventListener('transitionend', this.animationEndHandler);
      this.$nextTick(function () {
        _this2.isClosing = true;
      });
    },
    handleOpenDrawer: function handleOpenDrawer(evt) {
      if (evt.detail.drawerName === name) {
        this._openDrawer();
      }
    },
    handleCloseDrawer: function handleCloseDrawer(evt) {
      if (evt.detail.drawerName === name) {
        this._closeDrawer();
      }
    },
    destroy: function destroy() {
      openDrawers["delete"](this);
    },
    closeOpenDrawers: function closeOpenDrawers() {
      openDrawers.forEach(function (drawer) {
        drawer.closeDrawer();
      });
    },
    handleMutation: function handleMutation() {
      if (this.isClosing) return;
      var newOpen = this.$el.open;
      if (newOpen) {
        openDrawers.add(this);
        document.body.classList.add('scroll-lock');
        window.isMobile && (0,dom/* disableScrollForInputDrawer */.pn)();
      } else {
        openDrawers["delete"](this);
        if (openDrawers.size === 0) {
          document.body.classList.remove('scroll-lock');
          window.isMobile && (0,dom/* enableScrollForInputDrawer */.ye)();
        }
      }
      this.$dispatch(newOpen ? 'drawer-open' : 'drawer-close', {
        drawer: this
      });
    }
  };
};
/* harmony default export */ const drawer_v2 = (drawer);
;// CONCATENATED MODULE: ./src/js/utils/responsive-image-v2.js

var imageWidths = [100, 116, 134, 156, 182, 210, 244, 282, 328, 380, 442, 512, 594, 688, 798, 926, 1074, 1246, 1446, 1678, 1946, 2258, 2618, 3038, 3524, 4088, 4742, 5500];

// NOTE: if in a for loop, use 'x-bind:key' so that the image is updated
/* harmony default export */ const responsive_image_v2 = (function (_ref) {
  var imageUrl = _ref.imageUrl;
  return {
    get srcset() {
      if (!imageUrl) return false;
      var url = new URL(imageUrl.startsWith('//') ? "https:".concat(imageUrl) : imageUrl);
      return imageWidths.map(function (width) {
        url.searchParams.set('width', width);
        return "".concat(url.toString(), " ").concat(width, "w");
      }).join(', ');
    },
    imgAttributes: function imgAttributes(config) {
      var _ref2;
      return _ref2 = {
        "class": config.cover ? 'h-full object-cover' : 'h-full object-contain',
        loading: config.isLazy ? 'lazy' : 'eager'
      }, (0,defineProperty/* default */.Z)(_ref2, 'x-bind:srcset', function xBindSrcset() {
        return this.srcset;
      }), (0,defineProperty/* default */.Z)(_ref2, 'x-bind:src', function xBindSrc() {
        return imageUrl;
      }), (0,defineProperty/* default */.Z)(_ref2, "alt", config.alt || ''), _ref2;
    }
  };
});
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.js
var navigation = __webpack_require__(6739);
// EXTERNAL MODULE: ./node_modules/swiper/modules/keyboard/keyboard.js
var keyboard = __webpack_require__(376);
// EXTERNAL MODULE: ./node_modules/swiper/modules/a11y/a11y.js
var a11y = __webpack_require__(2799);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.js
var pagination = __webpack_require__(9224);
;// CONCATENATED MODULE: ./src/js/bundles/sections/header.js

function header_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function header_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? header_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : header_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var swiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchSlidesProgress: true,
  modules: [navigation/* default */.Z, keyboard/* default */.Z, a11y/* default */.Z],
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  a11y: {
    enabled: true,
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide',
    firstSlideMessage: 'This is the first slide',
    lastSlideMessage: 'This is the last slide'
  },
  breakpoints: {
    640: {
      spaceBetween: 16
    },
    1024: {
      spaceBetween: 20
    },
    1280: {
      spaceBetween: 24
    }
  }
};
var mobileSwiperConfig = {
  slidesPerView: 2.5,
  spaceBetween: 16,
  watchSlidesProgress: true,
  modules: [navigation/* default */.Z, keyboard/* default */.Z, a11y/* default */.Z, pagination/* default */.Z],
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  a11y: {
    enabled: true,
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide',
    firstSlideMessage: 'This is the first slide',
    lastSlideMessage: 'This is the last slide'
  },
  pagination: {
    clickable: true,
    type: 'bullets'
  }
};
var initializedSwipers = new Set();
function initDesktopMegaMenuSwipers() {
  var sliders = document.querySelectorAll('[data-swiper-id^="most-popular-"]');
  sliders.forEach(function (slider) {
    var swiperId = slider.getAttribute('data-swiper-id');
    if (!swiperId) return;

    // Skip if already initialized.
    if (initializedSwipers.has(swiperId) || slider.swiper) return;
    var slides = slider.querySelectorAll('.swiper-slide');
    if (!slides.length) return;
    var container = slider.closest('.relative');
    var nextButton = container ? container.querySelector('.swiper-button-next') : null;
    var prevButton = container ? container.querySelector('.swiper-button-prev') : null;
    var swiperOptions = header_objectSpread(header_objectSpread({}, swiperConfig), {}, {
      navigation: nextButton && prevButton ? {
        nextEl: nextButton,
        prevEl: prevButton,
        disabledClass: 'swiper-button-disabled'
      } : false
    });
    try {
      var swiperInstance = new core/* default */.Z(slider, swiperOptions);
      initializedSwipers.add(swiperId);
      setTimeout(function () {
        return swiperInstance.update();
      }, 100);
    } catch (_) {
      // Keep header stable even if one slider fails.
    }
  });
}
function initMobileMegaMenuSwipers() {
  var sliders = document.querySelectorAll('[data-swiper-mobile-id^="mobile-most-popular-"]');
  sliders.forEach(function (slider) {
    var swiperId = slider.getAttribute('data-swiper-mobile-id');
    if (!swiperId) return;

    // Skip if already initialized.
    if (initializedSwipers.has(swiperId) || slider.swiper) return;
    var slides = slider.querySelectorAll('.swiper-slide');
    if (!slides.length) return;
    var blockId = swiperId.replace('mobile-most-popular-', '');
    var nextButton = document.querySelector(".swiper-button-next-mobile-".concat(blockId));
    var prevButton = document.querySelector(".swiper-button-prev-mobile-".concat(blockId));
    var pagination = document.querySelector(".swiper-pagination-mobile-".concat(blockId));
    var swiperOptions = header_objectSpread(header_objectSpread({}, mobileSwiperConfig), {}, {
      navigation: nextButton && prevButton ? {
        nextEl: nextButton,
        prevEl: prevButton,
        disabledClass: 'opacity-50 cursor-not-allowed'
      } : false,
      pagination: pagination ? {
        el: pagination,
        clickable: true,
        type: 'bullets'
      } : false
    });
    try {
      var swiperInstance = new core/* default */.Z(slider, swiperOptions);
      initializedSwipers.add(swiperId);
      setTimeout(function () {
        return swiperInstance.update();
      }, 100);
    } catch (_) {
      // Keep header stable even if one slider fails.
    }
  });
}
function initMegaMenuSwiper() {
  var initAll = function initAll() {
    initDesktopMegaMenuSwipers();
    initMobileMegaMenuSwipers();
  };

  // Init quickly after first paint.
  setTimeout(initAll, 100);
  document.addEventListener('alpine:initialized', function () {
    setTimeout(initAll, 200);
    var megaMenu = document.getElementById('mega-menu');
    if (megaMenu) {
      var observer = new MutationObserver(function () {
        if (megaMenu.style.display !== 'none') {
          setTimeout(initAll, 150);
        }
      });
      observer.observe(megaMenu, {
        attributes: true,
        attributeFilter: ['style']
      });
    }
  });
  document.addEventListener('click', function (event) {
    var menuButton = event.target.closest('button[aria-controls="mega-menu"]');
    if (menuButton) {
      setTimeout(initAll, 300);
    }
  });
}

// Sticky Header
function stickyHeader() {
  initMegaMenuSwiper();
  document.addEventListener('DOMContentLoaded', function () {
    var headerSection = document.getElementById('shopify-section-header');
    if (headerSection) {
      var headerHeight = headerSection.getBoundingClientRect().bottom;
      document.body.style.setProperty('--header-height', "".concat(headerHeight, "px"));
      window.addEventListener('resize', function () {
        headerHeight = headerSection.getBoundingClientRect().bottom;
        document.body.style.setProperty('--header-height', "".concat(headerHeight, "px"));
      });
      if (window.stickyHeaderEnabled) {
        document.body.classList.add('header-is-sticky');
        headerSection.classList.add('sticky', 'top-0', 'z-30', 'shadow-sm');
        var scrollOffset = 150;
        window.addEventListener('scroll', function () {
          var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
          var stickyHeaderHeight = headerSection.getBoundingClientRect().bottom;
          if (currentScroll > 0) {
            document.body.classList.add('is-scrolled');
          } else {
            document.body.classList.remove('is-scrolled');
            stickyHeaderHeight = headerHeight;
          }
          if (currentScroll > scrollOffset) {
            document.body.classList.add('is-scrolled-offset');
          } else {
            document.body.classList.remove('is-scrolled-offset');
          }
          document.body.style.setProperty('--header-height', "".concat(stickyHeaderHeight, "px"));
        });
      }
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(2982);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(1002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(168);
;// CONCATENATED MODULE: ./src/js/utils/helpers.js
function debouncePromise(fn, time) {
  var timerId = undefined;
  return function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timerId) {
      clearTimeout(timerId);
    }
    return new Promise(function (resolve) {
      timerId = setTimeout(function () {
        return resolve(fn.apply(void 0, args));
      }, time);
    });
  };
}
function evaluateScreenSize() {
  window.isMobile = window.innerWidth <= 1023;
  function handleResize() {
    window.isMobile = window.innerWidth <= 1023;
  }
  window.addEventListener('resize', handleResize);
}
;// CONCATENATED MODULE: ./src/js/bundles/snippets/algolia-search.js





var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41;

function algolia_search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function algolia_search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? algolia_search_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : algolia_search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable */


var TRADEMARK_SPLIT_RE = /([®™©])/;

/**
 * Wrap ®, ™, © in a Preact-safe <sup class="trademark"> vnode.
 * Works with Algolia's tagged-template `html` so the result is part of the
 * virtual DOM and survives Preact reconciliation (no duplicate text on re-render).
 */
function trademarkHtml(text, html) {
  if (!text || typeof text !== 'string') return text;
  var parts = text.split(TRADEMARK_SPLIT_RE);
  if (parts.length === 1) return text;
  return parts.map(function (part) {
    return TRADEMARK_SPLIT_RE.test(part) ? html(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["<sup class=\"trademark\">", "</sup>"])), part) : part;
  });
}

/**
 * Replacement for components.Highlight that also wraps trademark symbols.
 * Reads the pre-built highlight HTML from Algolia's _highlightResult,
 * splits each text run on ®|™|© and inserts <sup class="trademark">.
 */
function highlightWithTrademarks(hit, attribute, html) {
  var _hit$_highlightResult, _hit$_highlightResult2;
  var raw = (_hit$_highlightResult = hit._highlightResult) === null || _hit$_highlightResult === void 0 ? void 0 : (_hit$_highlightResult2 = _hit$_highlightResult[attribute]) === null || _hit$_highlightResult2 === void 0 ? void 0 : _hit$_highlightResult2.value;
  if (!raw) return trademarkHtml(hit[attribute] || '', html);

  // Shopify stores titles HTML-encoded (& → &amp;, ' → &#039;). Algolia
  // encodes again, so we can end up with &amp;amp;, &amp;amp;#39; etc.
  // Fully unwind all &amp; layers before rendering as raw HTML.
  var decoded = raw;
  while (decoded.includes('&amp;')) decoded = decoded.replace(/&amp;/g, '&');

  // Normalise highlight markers: InstantSearch uses <mark>, Autocomplete uses
  // __aa-highlight__...__/aa-highlight__. Convert both to a styled <mark>.
  var processed = decoded.replace(/__aa-highlight__/g, '<mark class="ais-Highlight-highlighted">').replace(/__\/aa-highlight__/g, '</mark>').replace(/<mark>/g, '<mark class="ais-Highlight-highlighted">').replace(/([®™©])/g, '<sup class="trademark">$1</sup>');
  return html(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["<span class=\"ais-Highlight\" dangerouslySetInnerHTML=", "></span>"])), {
    __html: processed
  });
}
function triggerAutoCompleteHooksCustomEvent(eventName) {
  var event = new Event(eventName);
  window.dispatchEvent(event);
}
function setHeaderSearchState(isSearching) {
  var header = document.querySelector('header[data-search]');
  if (header) {
    header.setAttribute('data-search', isSearching ? 'true' : 'false');
  }
  var isMobile = window.innerWidth <= 1023;
  if (isMobile || document.body.classList.contains('aa-Detached')) {
    return;
  }
  document.body.classList.toggle('overflow-hidden', isSearching);
}

// Helper function to get theme settings
function getThemeSettings() {
  try {
    var themeSettingsScript = document.querySelector('script[json-script="theme-settings"]');
    if (themeSettingsScript) {
      return JSON.parse(themeSettingsScript.textContent);
    }
  } catch (error) {
    console.warn('Could not parse theme settings:', error);
  }
  return {
    enablePlpCompare: true,
    enablePdpCompare: true
  }; // Default fallback
}

var algoliaHandler = function algoliaHandler() {
  return {
    init: function init() {
      this.algoliaAutocompleteEnhance();
      this.algoliaInstantSearchEnhance();
    },
    algoliaAutocompleteEnhance: function algoliaAutocompleteEnhance() {
      var closeHeaderSearch = function closeHeaderSearch() {
        var input = document.querySelector('.aa-Input');
        if (input !== null && input !== void 0 && input.value) {
          input.value = '';
          input.dispatchEvent(new Event('input', {
            bubbles: true
          }));
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        setHeaderSearchState(false);
      };

      // Header search click handling:
      // 1) click on opener -> data-search="true" and focus input
      // 2) click outside .aa-Form/.aa-Panel while open -> clear input and data-search="false"
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-search-bar-open]')) {
          setHeaderSearchState(true);
          triggerAutoCompleteHooksCustomEvent('open-search-suggestions');
          var focusInput = function focusInput() {
            var input = document.querySelector('.aa-Input');
            if (input) input.focus();
          };
          focusInput();
          setTimeout(focusInput, 100);
          return;
        }
        var header = document.querySelector('header[data-search]');
        if (!header || header.getAttribute('data-search') !== 'true') return;
        if (e.target.closest('.aa-Form')) return;
        if (e.target.closest('#algolia-autocomplete-panel') || e.target.closest('.aa-Panel')) return;
        closeHeaderSearch();
      });
      window.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        var header = document.querySelector('header[data-search]');
        if (!header || header.getAttribute('data-search') !== 'true') return;
        closeHeaderSearch();
      }, true);
      document.addEventListener('DOMContentLoaded', function () {
        // Reset Algolia Search input on cancel button click in Mobile Search drawer.
        var autocompleteInput = document.getElementById('algolia-autocomplete-input-id');
        if (autocompleteInput) {
          var listenerAdded = false;
          autocompleteInput.addEventListener('click', function (event) {
            if (!listenerAdded) {
              if (event.target.matches('.aa-DetachedSearchButton') || event.target.closest('.aa-DetachedSearchButton')) {
                var detachedContainer = document.querySelector('.aa-DetachedContainer');
                var cancelButton = document.querySelector('.aa-DetachedFormContainer .aa-DetachedCancelButton');
                var SearchInputForm = document.querySelector('.aa-DetachedFormContainer .aa-Form');
                if (detachedContainer && SearchInputForm) {
                  setTimeout(function () {
                    triggerAutoCompleteHooksCustomEvent('append-suggestions-mobile');
                  }, 0);
                  setTimeout(setSearchFormFocusOrder, 300);
                }
                if (cancelButton && SearchInputForm) {
                  cancelButton.addEventListener('click', function () {
                    SearchInputForm.reset();
                    triggerAutoCompleteHooksCustomEvent('empty-mobile-search');
                    listenerAdded = true;
                  });
                }
              }
            }
          });
        }
      });

      // Detect Algolia Mobile Search drawer is opened or closed to disable body scroll handling for iPhones

      var wasDetached = document.body.classList.contains('aa-Detached');
      var searchOpenScrollPosition = 0;
      function updateOverflow() {
        var isDetached = document.body.classList.contains('aa-Detached');
        if (isDetached && !wasDetached) {
          // Save scroll position and scroll to top before locking body.
          // The detached overlay is full-screen, so the jump is invisible.
          // This prevents iOS from misinterpreting the negative body offset
          // if the keyboard is ever triggered.
          searchOpenScrollPosition = window.scrollY;
          window.scrollTo(0, 0);
          (0,dom/* disableScrollForInputDrawer */.pn)();
          requestAnimationFrame(function () {
            // Blur the input that Algolia's library auto-focuses internally.
            // This prevents the virtual keyboard from opening immediately,
            // letting the user see the full overlay (input + popular terms)
            // and tap the input when they are ready to type.
            var input = document.querySelector('.aa-DetachedContainer .aa-Input');
            if (input) input.blur();

            // Move focus to the container so screen readers announce
            // the search context without triggering the keyboard.
            var container = document.querySelector('.aa-DetachedContainer');
            if (container) {
              container.setAttribute('tabindex', '-1');
              container.focus({
                preventScroll: true
              });
            }
            setTimeout(setSearchFormFocusOrder, 300);
          });
        } else if (!isDetached && wasDetached) {
          (0,dom/* enableScrollForInputDrawer */.ye)();
          window.scrollTo(0, searchOpenScrollPosition);
        }
        wasDetached = isDetached;
      }
      var observer = new MutationObserver(function (mutations) {
        // MutationObserver to monitor changes to the body class
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class') {
            updateOverflow();
          }
        });
      });
      observer.observe(document.body, {
        attributes: true
      }); // Start observing the body element for attribute changes

      // Accessibility Fix: Add aria-label="Search" to Algolia input
      var addAriaLabelToInput = function addAriaLabelToInput() {
        var input = document.querySelector('.aa-Input');
        if (input && !input.hasAttribute('aria-label')) {
          input.setAttribute('aria-label', 'Search');
          return true;
        }
        return false;
      };

      // Accessibility Fix: Update aria-label="Submit" to aria-label="Search" for Algolia submit button
      var updateAriaLabelOnSubmitButton = function updateAriaLabelOnSubmitButton() {
        var label = document.querySelector('.aa-InputWrapperPrefix .aa-Label');
        if (label && label.getAttribute('aria-label') === 'Submit') {
          label.setAttribute('aria-label', 'Search');
          return true;
        }
        return false;
      };

      // Accessibility Fix: Ensure DOM order is Input → Submit → Clear (aa-InputWrapper, aa-InputWrapperPrefix, aa-InputWrapperSuffix)
      var setSearchFormFocusOrder = function setSearchFormFocusOrder() {
        var reordered = false;
        document.querySelectorAll('.aa-Form').forEach(function (form) {
          var inputWrapper = form.querySelector('.aa-InputWrapper');
          var prefix = form.querySelector('.aa-InputWrapperPrefix');
          var suffix = form.querySelector('.aa-InputWrapperSuffix');
          if (!inputWrapper || !prefix) return;
          var desiredOrder = [inputWrapper, prefix, suffix].filter(Boolean);
          var alreadyOrdered = desiredOrder.length <= 1 || form.children[0] === inputWrapper && form.children[1] === prefix && (desiredOrder.length < 3 || form.children[2] === suffix);
          if (alreadyOrdered) return;
          // Insert in reverse order so first node ends up first: insert before "ref", then use inserted node as next ref
          var ref = form.firstChild;
          for (var i = desiredOrder.length - 1; i >= 0; i--) {
            form.insertBefore(desiredOrder[i], ref);
            ref = desiredOrder[i];
          }
          reordered = true;
        });
        return reordered;
      };

      // Utility: Run all accessibility fixes together
      var fixAlgoliaAriaLabels = function fixAlgoliaAriaLabels() {
        var inputFixed = addAriaLabelToInput();
        var labelFixed = updateAriaLabelOnSubmitButton();
        setSearchFormFocusOrder();
        return inputFixed || labelFixed;
      };

      // Try immediately
      fixAlgoliaAriaLabels();

      // MutationObserver to handle dynamically added elements
      var inputLabelObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                var _node$classList, _node$classList2, _node$classList3, _node$querySelector;
                // 1. Set aria-label="Search" on .aa-Input if missing
                var input = (_node$classList = node.classList) !== null && _node$classList !== void 0 && _node$classList.contains('aa-Input') ? node : node.querySelector('.aa-Input');
                if (input && !input.hasAttribute('aria-label')) {
                  input.setAttribute('aria-label', 'Search');
                }

                // 2. Update aria-label="Submit" to "Search" on .aa-Label (submit button wrapper)
                var label = (_node$classList2 = node.classList) !== null && _node$classList2 !== void 0 && _node$classList2.contains('aa-Label') ? node : node.querySelector('.aa-Label');
                if (label && label.getAttribute('aria-label') === 'Submit') {
                  label.setAttribute('aria-label', 'Search');
                }

                // 3. Reorder form so tab order is Input → Submit → Clear
                if ((_node$classList3 = node.classList) !== null && _node$classList3 !== void 0 && _node$classList3.contains('aa-Form') || (_node$querySelector = node.querySelector) !== null && _node$querySelector !== void 0 && _node$querySelector.call(node, '.aa-Form')) {
                  requestAnimationFrame(function () {
                    return setSearchFormFocusOrder();
                  });
                }
              }
            });
          }
        });
      });
      inputLabelObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Fallback: Check periodically for the first few seconds
      var attempts = 0;
      var maxAttempts = 10;
      var fallbackInterval = setInterval(function () {
        attempts++;
        if (fixAlgoliaAriaLabels() || attempts >= maxAttempts) {
          clearInterval(fallbackInterval);
        }
      }, 100);

      // Also try when Algolia hooks initialize
      document.addEventListener('algolia.hooks.initialize', function () {
        setTimeout(fixAlgoliaAriaLabels, 0);
        setTimeout(setSearchFormFocusOrder, 400);
      });

      // Algolia Search Autocomplete custom hooks
      document.addEventListener('algolia.hooks.initialize', function () {
        // Add debounce delay to the Algolia search query for Products, Collections, Articles, and Pages.
        algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
          var searchQueryDelay = 1000;
          if (Array.isArray(options.plugins) && options.plugins.length > 0) {
            var _loop = function _loop() {
              if (typeof options.plugins[i].getSources === 'function') {
                var originalGetSources = options.plugins[i].getSources;
                var debouncedGetSourcesFunction = debouncePromise(function () {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  return originalGetSources.apply(this, args);
                }, searchQueryDelay);
                options.plugins[i].getSources = function () {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }
                  return debouncedGetSourcesFunction.apply(this, args);
                };
              }
            };
            for (var i = 0; i <= Math.min(3, options.plugins.length); i++) {
              _loop();
            }
          }
          return options;
        });

        // Main Search Panel Customization.
        algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          return html(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div id=\"algolia-autocomplete-panel\" class=\"aa-PanelLayout aa-Panel--scrollable\">\n              <div class=\"aa-PanelSections\">\n                <div class=\"aa-PanelSection--left\">\n                  ", "\n                  <div class=\"aa-SourceHeader aa-RelatedListings\">\n                    <span class=\"aa-SourceHeaderTitle\">Related</span>\n                  </div>\n                  ", "", "", "", "\n                </div>\n                <div class=\"aa-PanelSection--right\">\n                  ", "\n                  ", "\n                </div>\n              </div>\n            </div>\n          "])), displaySuggestions && html(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-SourceHeader\">\n                      <span class=\"aa-SourceHeaderTitle\">", "</span>\n                      <div class=\"aa-SourceHeaderLine\"></div>\n                    </div>\n                    ", "\n                  "])), algoliaShopify.translations.suggestions, elements.querySuggestionsPlugin), elements.collections, elements.articles, elements.pages, elements.redirectUrlPlugin, elements.products, html(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-ViewAllBtnWrapper\">\n                      <a href=\"/search?q=", "\" class=\"component-btn aa-ViewAllBtn\">VIEW ALL SEARCH RESULTS</a>\n                    </div>\n                  "])), state.query));
        });

        // Main Products template - this comes when there are no other results except products and beforeAutocompleteMainTemplate doesn't work.
        algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function (_defaultTemplate, templateOptions, elements) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          return html(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div id=\"algolia-autocomplete-panel\" class=\"aa-PanelLayout aa-Panel--scrollable\">\n              <div class=\"aa-PanelSection\">\n                ", "\n                ", "\n              </div>\n            </div>\n          "])), elements.products, html(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"aa-ViewAllBtnWrapper\">\n                    <a href=\"/search?q=", "\" class=\"component-btn aa-ViewAllBtn\">VIEW ALL SEARCH RESULTS</a>\n                  </div>\n                "])), state.query));
        });

        // Main Search Panel - No results
        algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function (_defaultTemplate, templateOptions) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;

          // Don't show the "No results for ''" panel when the query is empty
          // (e.g. after the user erases their keyword) — popular terms show instead.
          if (!state.query || !state.query.trim()) {
            return html(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["<div id=\"algolia-autocomplete-panel\"></div>"])));
          }
          return html(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div id=\"algolia-autocomplete-panel\" class=\"aa-PanelLayout aa-Panel--scrollable\">\n              <p class=\"aa-NoResultsHeader\">", "</p>\n              <a class=\"aa-NoResultsLink\" href=\"", "search?q=\">\n                ", "\n              </a>\n            </div>\n          "])), algoliaShopify.translation_helpers.no_result_for(state.query), window.Shopify.routes.root, algoliaShopify.translations.allProducts);
        });

        // Set and remove title for Products, Pages and Articles sections.
        algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function (_defaultTemplate, templateOptions, resource) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            state = templateOptions.state;
          var customHtml = '';
          if (resource === 'Products') {
            customHtml = html(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["<span class=\"aa-SourceHeaderTitle aa-ProductsListTitle\">Top Products</span>"])));
          } else if (resource === 'Pages' || resource === 'Articles') {
            customHtml = '';
          } else {
            return _defaultTemplate;
          }
          return customHtml;
        });

        // Single Product Customization.
        algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function (_defaultTemplate, templateOptions, distinct, itemLink) {
          var _item$body_html_safe, _item$meta, _item$meta$okendo, _item$meta$okendo$Sta, _item$meta2, _item$meta2$okendo;
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          var html = templateOptions.html,
            item = templateOptions.item,
            components = templateOptions.components;
          var productId = item.id;
          var productDescription = (_item$body_html_safe = item.body_html_safe) === null || _item$body_html_safe === void 0 ? void 0 : _item$body_html_safe.replace(/&amp;/g, '&');
          var isXlScreen = window.innerWidth <= 1279;
          var okendoReviewSnippet = isXlScreen ? (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : (_item$meta$okendo = _item$meta.okendo) === null || _item$meta$okendo === void 0 ? void 0 : (_item$meta$okendo$Sta = _item$meta$okendo.StarRatingSnippet) === null || _item$meta$okendo$Sta === void 0 ? void 0 : _item$meta$okendo$Sta.replace(/<span class="oke-sr-total-text">\s*\((\d+)\s*Review(s?)\)\s*<\/span>/, '<span class="oke-sr-total-text"> ($1)</span>') : (_item$meta2 = item.meta) === null || _item$meta2 === void 0 ? void 0 : (_item$meta2$okendo = _item$meta2.okendo) === null || _item$meta2$okendo === void 0 ? void 0 : _item$meta2$okendo.StarRatingSnippet;
          return html(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <a href=\"", "\" class=\"aa-ItemLink aa-ProductItem\">\n              <div class=\"aa-ItemContent\">\n                <div class=\"aa-ItemPicture aa-ItemPicture--loaded\">\n                  <img src=\"", "\" alt=\"", "\" />\n                </div>\n                <div class=\"aa-ItemContentBody\">\n                  ", "\n                  <div class=\"aa-ItemContentTitleWrapper\">\n                    <div class=\"aa-ItemContentTitle\">\n                      ", "\n                      <span class=\"algolia-variant\">\n                        ", "\n                      </span>\n                    </div>\n                  </div>\n                  ", "\n                </div>\n                <div class=\"aa-ItemContentPrice\">\n                  <div class=\"aa-ItemContentPriceCurrent\">", "</div>\n                </div>\n              </div>\n            </a>\n          "])), itemLink, algoliaShopify.helpers.largeImage(item), item.title, productId && okendoReviewSnippet && html(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-ItemReview oke-medium-size\">\n                      <div data-oke-star-rating data-oke-reviews-product-id=\"shopify-", "\">\n                        ", "\n                      </div>\n                    </div>\n                  "])), productId, html([okendoReviewSnippet])), highlightWithTrademarks(item, 'title', html), algoliaShopify.helpers.variantTitleAddition(item, distinct), productDescription && html(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"aa-ItemDescription\">\n                      ", "\n                    </div>\n                  "])), trademarkHtml(productDescription.length > 70 ? productDescription.substring(0, 67) + '...' : productDescription, html)), algoliaShopify.helpers.displayPrice(item, distinct));
        });
      });
    },
    algoliaInstantSearchEnhance: function algoliaInstantSearchEnhance() {
      var body = document.body;

      // ✅ Enhance all filter labels (Menu + Price RefinementList)
      function enhanceAlgoliaMenuFacets() {
        // Enhance "Filter by Form" style filters
        document.querySelectorAll('.ais-Menu-label').forEach(function (label) {
          var _label$querySelector;
          if (label.hasAttribute('tabindex')) {
            return; // Skip if already enhanced
          }

          var icon = label.querySelector('.ais-facet--custom-icon');
          var count = (_label$querySelector = label.querySelector('.ais-Menu-count')) === null || _label$querySelector === void 0 ? void 0 : _label$querySelector.textContent.trim();
          var labelText = label.textContent.trim().replace(/\s+\d+$/, '');
          var isChecked = (icon === null || icon === void 0 ? void 0 : icon.querySelector('span:not(.hidden)')) !== null;
          label.setAttribute('role', 'checkbox');
          label.setAttribute('tabindex', '0');
          label.setAttribute('aria-checked', isChecked ? 'true' : 'false');
          label.setAttribute('aria-label', "Filter by ".concat(labelText).concat(count ? " (".concat(count, " items)") : ''));
          label.addEventListener('keydown', function (e) {
            if (e.key === 'Space' || e.key === ' ') {
              e.preventDefault();
              label.click();
            }
          });
        });
      }
      function enhanceFacetToggleHeaders() {
        document.querySelectorAll('.ais-facet--header').forEach(function (label) {
          var wrapper = label.closest('.ais-facet-dropdown-wrapper');
          var forId = label.getAttribute('for');
          var input = forId && document.getElementById(forId);
          var container = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('.ais-facet-dropdown-container');
          var labelText = label.textContent.trim().replace(/\s+/g, ' ');
          var containerId = forId && "".concat(forId, "-container");
          function isFacetExpanded() {
            if (!container) return input === null || input === void 0 ? void 0 : input.checked;
            var style = window.getComputedStyle(container);
            var isHidden = container.hidden || container.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden' || container.scrollHeight > 0 && container.getBoundingClientRect().height === 0 && style.overflow !== 'visible';
            return !isHidden;
          }
          function syncExpandedState() {
            label.setAttribute('aria-expanded', isFacetExpanded() ? 'true' : 'false');
          }
          label.setAttribute('tabindex', '0');
          label.setAttribute('role', 'button');
          syncExpandedState();
          if (containerId) {
            label.setAttribute('aria-controls', containerId);
          }
          label.setAttribute('aria-label', labelText);
          if (!label.dataset.facetToggleEnhanced) {
            label.dataset.facetToggleEnhanced = 'true';
            label.addEventListener('click', function () {
              window.requestAnimationFrame(syncExpandedState);
              setTimeout(syncExpandedState, 100);
            });
            label.addEventListener('keydown', function (e) {
              if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
                e.preventDefault();
                label.click();
              }
            });
            input === null || input === void 0 ? void 0 : input.addEventListener('change', syncExpandedState);
          }

          // Optionally mark the container with matching ID for accessibility
          if (container && containerId) {
            container.setAttribute('id', containerId);
          }
        });
      }
      function enhanceFacetGroupsAccessibility() {
        document.querySelectorAll('.ais-facet-dropdown-wrapper').forEach(function (wrapper, index) {
          var header = wrapper.querySelector('.ais-facet--header');
          var container = wrapper.querySelector('.ais-facet-dropdown-container');
          if (!header || !container) return;
          var headerId = header.id || "ais-facet-group-label-".concat(index);
          header.setAttribute('id', headerId);
          var list = container.querySelector('.ais-RefinementList-list, .ais-Menu-list');
          if (list) {
            list.setAttribute('role', 'group');
            list.setAttribute('aria-labelledby', headerId);
          }
        });
      }
      function enhanceAlgoliaPriceFilters() {
        document.querySelectorAll('.ais-RefinementList-label').forEach(function (label) {
          var _label$querySelector2, _label$childNodes$;
          var input = label.querySelector('input[type="checkbox"]');
          var count = (_label$querySelector2 = label.querySelector('.ais-RefinementList-count')) === null || _label$querySelector2 === void 0 ? void 0 : _label$querySelector2.textContent.trim();
          var labelText = (_label$childNodes$ = label.childNodes[2]) === null || _label$childNodes$ === void 0 ? void 0 : _label$childNodes$.textContent.trim();
          label.setAttribute('role', 'checkbox');
          label.setAttribute('tabindex', '0');
          label.setAttribute('aria-label', "Filter by price: ".concat(labelText).concat(count ? " (".concat(count, " items)") : ''));
          label.setAttribute('aria-checked', input !== null && input !== void 0 && input.checked ? 'true' : 'false');

          // ✅ Add Enter/Space keydown support
          label.addEventListener('keydown', function (e) {
            if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) {
              e.preventDefault();
              e.stopPropagation();

              // ✅ Only trigger click on the label itself (NOT input)
              label.click();

              // ✅ Let Algolia re-render, then reapply aria-checked
              setTimeout(function () {
                var refreshedInput = label.querySelector('input[type="checkbox"]');
                if (refreshedInput) {
                  label.setAttribute('aria-checked', refreshedInput.checked ? 'true' : 'false');
                }
              }, 200);
            }
          });
        });
      }

      // ✅ Enhance selected filters (refinements)
      function enhanceSelectedFiltersAccessibility() {
        document.querySelectorAll('.ais-current-refined-values--link').forEach(function (link) {
          if (link.hasAttribute('tabindex')) {
            return; // Skip if already enhanced
          }

          link.setAttribute('role', 'button');
          link.setAttribute('tabindex', '0');
          var labelEl = link.querySelector('.ais-current-refined-values--label');
          var valueText = link.textContent.trim().replace(/\s+/g, ' ').replace(':', '').trim();
          link.setAttribute('aria-label', "Remove filter: ".concat(valueText));
          link.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              link.click();
            }
          });
        });
      }

      // 🔁 Observe DOM updates
      function startObservingFacets() {
        var observer = new MutationObserver(function () {
          enhanceAlgoliaMenuFacets();
          enhanceFacetToggleHeaders();
          enhanceAlgoliaPriceFilters();
          enhanceSelectedFiltersAccessibility();
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      // Helper function to extract text from rich text metafield objects
      function extractTextFromRichText(richTextData) {
        if (!richTextData) return '';
        var richTextObj = richTextData;

        // If it's a string, try to parse it as JSON
        if (typeof richTextData === 'string') {
          try {
            richTextObj = JSON.parse(richTextData);
          } catch (e) {
            return richTextData; // If parsing fails, return the string as-is
          }
        }

        // If it's not an object after parsing, return empty
        if (!richTextObj || (0,esm_typeof/* default */.Z)(richTextObj) !== 'object') return '';
        var text = '';
        function traverse(node) {
          if (node.type === 'text') {
            text += node.value || '';
          } else if (node.children && Array.isArray(node.children)) {
            node.children.forEach(traverse);
          }
        }
        traverse(richTextObj);
        return text.trim();
      }
      function aisQuickBuyModal(event) {
        var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        event.stopPropagation();
        event.preventDefault();
        if (handle && Alpine.store('quickBuyModal')) {
          Alpine.store('quickBuyModal').loadModal(handle, event);
        } else {
          alert("Sorry, we couldn't load the Quick Buy feature");
        }
      }
      function aisToggleCompareFromCheckbox(event) {
        event.stopPropagation();
        var checkbox = event.target;
        var compareComponent = window.plpCompareComponent;
        if (!compareComponent) {
          console.warn('Compare component not available');
          return;
        }
        var productData = {
          id: parseInt(checkbox.dataset.productId),
          title: checkbox.dataset.productTitle,
          image: checkbox.dataset.productImage,
          url: checkbox.dataset.productUrl,
          price: checkbox.dataset.productPrice,
          priceMin: checkbox.dataset.productPriceMin,
          priceMax: checkbox.dataset.productPriceMax,
          variantsCount: parseInt(checkbox.dataset.productVariantsCount) || 1,
          handle: checkbox.dataset.productHandle,
          form: checkbox.dataset.productForm,
          suggestedUse: checkbox.dataset.productSuggestedUse,
          supplyPerBottle: checkbox.dataset.productSupplyPerBottle,
          keyIngredients: checkbox.dataset.productKeyIngredients,
          certifications: checkbox.dataset.productCertifications,
          allergenInfo: checkbox.dataset.productAllergenInfo,
          pricePerServing: checkbox.dataset.productPricePerServing,
          benefits: checkbox.dataset.productBenefits,
          starRating: checkbox.dataset.productStarRating,
          reviewCount: parseInt(checkbox.dataset.productReviewCount) || 0
        };
        compareComponent.toggleProduct(productData);
      }
      function aisToggleCompare(event, hit) {
        var _hit$meta, _hit$meta$custom, _hit$meta$custom$comp, _hit$meta2, _hit$meta2$custom, _hit$metafields, _hit$metafields$custo, _hit$metafields$custo2, _hit$meta3, _hit$meta3$custom, _hit$meta3$custom$com, _hit$meta4, _hit$meta4$custom, _hit$metafields2, _hit$metafields2$cust, _hit$metafields2$cust2, _hit$meta5, _hit$meta5$custom, _hit$meta5$custom$com, _hit$meta6, _hit$meta6$custom, _hit$metafields3, _hit$metafields3$cust, _hit$metafields3$cust2, _hit$meta7, _hit$meta7$custom, _hit$meta7$custom$com, _hit$meta8, _hit$meta8$custom, _hit$metafields4, _hit$metafields4$cust, _hit$metafields4$cust2, _hit$meta9, _hit$meta9$custom, _hit$meta9$custom$com, _hit$meta10, _hit$meta10$custom, _hit$metafields5, _hit$metafields5$cust, _hit$metafields5$cust2, _hit$meta11, _hit$meta11$custom, _hit$meta11$custom$co, _hit$meta12, _hit$meta12$custom, _hit$metafields6, _hit$metafields6$cust, _hit$metafields6$cust2, _hit$meta13, _hit$meta13$custom, _hit$meta13$custom$co, _hit$meta14, _hit$meta14$custom, _hit$metafields7, _hit$metafields7$cust, _hit$metafields7$cust2, _hit$meta15, _hit$meta15$custom, _hit$meta15$custom$co, _hit$meta16, _hit$meta16$custom, _hit$metafields8, _hit$metafields8$cust, _hit$metafields8$cust2, _hit$meta17, _hit$meta17$okendo, _hit$meta17$okendo$St, _hit$meta18, _hit$meta18$okendo, _hit$metafields9, _hit$metafields9$oken, _hit$metafields9$oken2, _hit$meta19, _hit$meta19$okendo, _hit$meta19$okendo$su, _hit$metafields10, _hit$metafields10$oke, _hit$metafields10$oke2;
        event.stopPropagation();
        event.preventDefault();

        // Find the PLP compare component instance
        var compareComponent = window.plpCompareComponent;
        if (!compareComponent) {
          console.warn('Compare component not available');
          return;
        }
        var productData = {
          id: hit.id,
          title: hit.title,
          image: algoliaShopify.helpers.largeImage(hit),
          url: algoliaShopify.helpers.instantsearchLink(hit),
          price: algoliaShopify.helpers.displayPrice(hit, hit._distinct),
          priceMin: hit.price_min ? algoliaShopify.helpers.formatMoney(hit.price_min) : '',
          priceMax: hit.price_max ? algoliaShopify.helpers.formatMoney(hit.price_max) : '',
          variantsCount: hit.variants ? hit.variants.length : 1,
          handle: hit.handle,
          // Try different possible paths for metafield data
          form: ((_hit$meta = hit.meta) === null || _hit$meta === void 0 ? void 0 : (_hit$meta$custom = _hit$meta.custom) === null || _hit$meta$custom === void 0 ? void 0 : (_hit$meta$custom$comp = _hit$meta$custom.compare_product_form) === null || _hit$meta$custom$comp === void 0 ? void 0 : _hit$meta$custom$comp.value) || ((_hit$meta2 = hit.meta) === null || _hit$meta2 === void 0 ? void 0 : (_hit$meta2$custom = _hit$meta2.custom) === null || _hit$meta2$custom === void 0 ? void 0 : _hit$meta2$custom.compare_product_form) || ((_hit$metafields = hit.metafields) === null || _hit$metafields === void 0 ? void 0 : (_hit$metafields$custo = _hit$metafields.custom) === null || _hit$metafields$custo === void 0 ? void 0 : (_hit$metafields$custo2 = _hit$metafields$custo.compare_product_form) === null || _hit$metafields$custo2 === void 0 ? void 0 : _hit$metafields$custo2.value) || 'N/A',
          suggestedUse: ((_hit$meta3 = hit.meta) === null || _hit$meta3 === void 0 ? void 0 : (_hit$meta3$custom = _hit$meta3.custom) === null || _hit$meta3$custom === void 0 ? void 0 : (_hit$meta3$custom$com = _hit$meta3$custom.compare_product_suggested_use) === null || _hit$meta3$custom$com === void 0 ? void 0 : _hit$meta3$custom$com.value) || ((_hit$meta4 = hit.meta) === null || _hit$meta4 === void 0 ? void 0 : (_hit$meta4$custom = _hit$meta4.custom) === null || _hit$meta4$custom === void 0 ? void 0 : _hit$meta4$custom.compare_product_suggested_use) || ((_hit$metafields2 = hit.metafields) === null || _hit$metafields2 === void 0 ? void 0 : (_hit$metafields2$cust = _hit$metafields2.custom) === null || _hit$metafields2$cust === void 0 ? void 0 : (_hit$metafields2$cust2 = _hit$metafields2$cust.compare_product_suggested_use) === null || _hit$metafields2$cust2 === void 0 ? void 0 : _hit$metafields2$cust2.value) || 'N/A',
          supplyPerBottle: ((_hit$meta5 = hit.meta) === null || _hit$meta5 === void 0 ? void 0 : (_hit$meta5$custom = _hit$meta5.custom) === null || _hit$meta5$custom === void 0 ? void 0 : (_hit$meta5$custom$com = _hit$meta5$custom.compare_product_supply_per_bottle) === null || _hit$meta5$custom$com === void 0 ? void 0 : _hit$meta5$custom$com.value) || ((_hit$meta6 = hit.meta) === null || _hit$meta6 === void 0 ? void 0 : (_hit$meta6$custom = _hit$meta6.custom) === null || _hit$meta6$custom === void 0 ? void 0 : _hit$meta6$custom.compare_product_supply_per_bottle) || ((_hit$metafields3 = hit.metafields) === null || _hit$metafields3 === void 0 ? void 0 : (_hit$metafields3$cust = _hit$metafields3.custom) === null || _hit$metafields3$cust === void 0 ? void 0 : (_hit$metafields3$cust2 = _hit$metafields3$cust.compare_product_supply_per_bottle) === null || _hit$metafields3$cust2 === void 0 ? void 0 : _hit$metafields3$cust2.value) || 'N/A',
          keyIngredients: ((_hit$meta7 = hit.meta) === null || _hit$meta7 === void 0 ? void 0 : (_hit$meta7$custom = _hit$meta7.custom) === null || _hit$meta7$custom === void 0 ? void 0 : (_hit$meta7$custom$com = _hit$meta7$custom.compare_product_key_ingredients) === null || _hit$meta7$custom$com === void 0 ? void 0 : _hit$meta7$custom$com.value) || ((_hit$meta8 = hit.meta) === null || _hit$meta8 === void 0 ? void 0 : (_hit$meta8$custom = _hit$meta8.custom) === null || _hit$meta8$custom === void 0 ? void 0 : _hit$meta8$custom.compare_product_key_ingredients) || ((_hit$metafields4 = hit.metafields) === null || _hit$metafields4 === void 0 ? void 0 : (_hit$metafields4$cust = _hit$metafields4.custom) === null || _hit$metafields4$cust === void 0 ? void 0 : (_hit$metafields4$cust2 = _hit$metafields4$cust.compare_product_key_ingredients) === null || _hit$metafields4$cust2 === void 0 ? void 0 : _hit$metafields4$cust2.value) || 'N/A',
          certifications: ((_hit$meta9 = hit.meta) === null || _hit$meta9 === void 0 ? void 0 : (_hit$meta9$custom = _hit$meta9.custom) === null || _hit$meta9$custom === void 0 ? void 0 : (_hit$meta9$custom$com = _hit$meta9$custom.compare_product_certifications) === null || _hit$meta9$custom$com === void 0 ? void 0 : _hit$meta9$custom$com.value) || ((_hit$meta10 = hit.meta) === null || _hit$meta10 === void 0 ? void 0 : (_hit$meta10$custom = _hit$meta10.custom) === null || _hit$meta10$custom === void 0 ? void 0 : _hit$meta10$custom.compare_product_certifications) || ((_hit$metafields5 = hit.metafields) === null || _hit$metafields5 === void 0 ? void 0 : (_hit$metafields5$cust = _hit$metafields5.custom) === null || _hit$metafields5$cust === void 0 ? void 0 : (_hit$metafields5$cust2 = _hit$metafields5$cust.compare_product_certifications) === null || _hit$metafields5$cust2 === void 0 ? void 0 : _hit$metafields5$cust2.value) || 'N/A',
          allergenInfo: ((_hit$meta11 = hit.meta) === null || _hit$meta11 === void 0 ? void 0 : (_hit$meta11$custom = _hit$meta11.custom) === null || _hit$meta11$custom === void 0 ? void 0 : (_hit$meta11$custom$co = _hit$meta11$custom.compare_product_allergen_info) === null || _hit$meta11$custom$co === void 0 ? void 0 : _hit$meta11$custom$co.value) || ((_hit$meta12 = hit.meta) === null || _hit$meta12 === void 0 ? void 0 : (_hit$meta12$custom = _hit$meta12.custom) === null || _hit$meta12$custom === void 0 ? void 0 : _hit$meta12$custom.compare_product_allergen_info) || ((_hit$metafields6 = hit.metafields) === null || _hit$metafields6 === void 0 ? void 0 : (_hit$metafields6$cust = _hit$metafields6.custom) === null || _hit$metafields6$cust === void 0 ? void 0 : (_hit$metafields6$cust2 = _hit$metafields6$cust.compare_product_allergen_info) === null || _hit$metafields6$cust2 === void 0 ? void 0 : _hit$metafields6$cust2.value) || 'N/A',
          pricePerServing: ((_hit$meta13 = hit.meta) === null || _hit$meta13 === void 0 ? void 0 : (_hit$meta13$custom = _hit$meta13.custom) === null || _hit$meta13$custom === void 0 ? void 0 : (_hit$meta13$custom$co = _hit$meta13$custom.compare_product_price_per_serving) === null || _hit$meta13$custom$co === void 0 ? void 0 : _hit$meta13$custom$co.value) || ((_hit$meta14 = hit.meta) === null || _hit$meta14 === void 0 ? void 0 : (_hit$meta14$custom = _hit$meta14.custom) === null || _hit$meta14$custom === void 0 ? void 0 : _hit$meta14$custom.compare_product_price_per_serving) || ((_hit$metafields7 = hit.metafields) === null || _hit$metafields7 === void 0 ? void 0 : (_hit$metafields7$cust = _hit$metafields7.custom) === null || _hit$metafields7$cust === void 0 ? void 0 : (_hit$metafields7$cust2 = _hit$metafields7$cust.compare_product_price_per_serving) === null || _hit$metafields7$cust2 === void 0 ? void 0 : _hit$metafields7$cust2.value) || 'N/A',
          benefits: extractTextFromRichText(((_hit$meta15 = hit.meta) === null || _hit$meta15 === void 0 ? void 0 : (_hit$meta15$custom = _hit$meta15.custom) === null || _hit$meta15$custom === void 0 ? void 0 : (_hit$meta15$custom$co = _hit$meta15$custom.compare_product_benefits) === null || _hit$meta15$custom$co === void 0 ? void 0 : _hit$meta15$custom$co.value) || ((_hit$meta16 = hit.meta) === null || _hit$meta16 === void 0 ? void 0 : (_hit$meta16$custom = _hit$meta16.custom) === null || _hit$meta16$custom === void 0 ? void 0 : _hit$meta16$custom.compare_product_benefits) || ((_hit$metafields8 = hit.metafields) === null || _hit$metafields8 === void 0 ? void 0 : (_hit$metafields8$cust = _hit$metafields8.custom) === null || _hit$metafields8$cust === void 0 ? void 0 : (_hit$metafields8$cust2 = _hit$metafields8$cust.compare_product_benefits) === null || _hit$metafields8$cust2 === void 0 ? void 0 : _hit$metafields8$cust2.value)) || 'N/A',
          starRating: ((_hit$meta17 = hit.meta) === null || _hit$meta17 === void 0 ? void 0 : (_hit$meta17$okendo = _hit$meta17.okendo) === null || _hit$meta17$okendo === void 0 ? void 0 : (_hit$meta17$okendo$St = _hit$meta17$okendo.StarRatingSnippet) === null || _hit$meta17$okendo$St === void 0 ? void 0 : _hit$meta17$okendo$St.value) || ((_hit$meta18 = hit.meta) === null || _hit$meta18 === void 0 ? void 0 : (_hit$meta18$okendo = _hit$meta18.okendo) === null || _hit$meta18$okendo === void 0 ? void 0 : _hit$meta18$okendo.StarRatingSnippet) || ((_hit$metafields9 = hit.metafields) === null || _hit$metafields9 === void 0 ? void 0 : (_hit$metafields9$oken = _hit$metafields9.okendo) === null || _hit$metafields9$oken === void 0 ? void 0 : (_hit$metafields9$oken2 = _hit$metafields9$oken.StarRatingSnippet) === null || _hit$metafields9$oken2 === void 0 ? void 0 : _hit$metafields9$oken2.value) || '',
          reviewCount: ((_hit$meta19 = hit.meta) === null || _hit$meta19 === void 0 ? void 0 : (_hit$meta19$okendo = _hit$meta19.okendo) === null || _hit$meta19$okendo === void 0 ? void 0 : (_hit$meta19$okendo$su = _hit$meta19$okendo.summaryData) === null || _hit$meta19$okendo$su === void 0 ? void 0 : _hit$meta19$okendo$su.reviewCount) || ((_hit$metafields10 = hit.metafields) === null || _hit$metafields10 === void 0 ? void 0 : (_hit$metafields10$oke = _hit$metafields10.okendo) === null || _hit$metafields10$oke === void 0 ? void 0 : (_hit$metafields10$oke2 = _hit$metafields10$oke.summaryData) === null || _hit$metafields10$oke2 === void 0 ? void 0 : _hit$metafields10$oke2.reviewCount) || 0
        };
        compareComponent.toggleProduct(productData);
      }
      function aisOpenFacetsDrawer(event) {
        event.preventDefault();
        body.classList.add('scroll-lock');
        body.classList.add('ais-show-facets-drawer');
        (0,dom/* disableScrollForInputDrawer */.pn)();
      }
      function aisCloseFacetsDrawer(event) {
        event.preventDefault();
        body.classList.remove('scroll-lock');
        body.classList.remove('ais-show-facets-drawer');
        (0,dom/* enableScrollForInputDrawer */.ye)();
      }

      // Track previous state for filter change announcements
      var previousResultsCount = null;
      var previousActiveFilters = 0;
      var isInitialRender = true;
      document.addEventListener('algolia.instantSearch.onRender', function () {
        enhanceAlgoliaMenuFacets();
        enhanceFacetToggleHeaders();
        enhanceSelectedFiltersAccessibility();
        enhanceFacetGroupsAccessibility();

        // Announce filter changes to screen readers
        var statsContainer = document.querySelector('.ais-stats-container');
        var statusMessage = document.getElementById('algolia-status-message');
        if (statsContainer && statusMessage) {
          // Extract the number of results from the stats text
          var statsText = statsContainer.textContent.trim();
          var resultsMatch = statsText.match(/(\d+(?:,\d+)*)\s+(?:of\s+)?(\d+(?:,\d+)*)\s+items?/i) || statsText.match(/(\d+)\s+items?/i);
          if (resultsMatch) {
            var currentResultsCount = parseInt(resultsMatch[resultsMatch.length - 1].replace(/,/g, ''), 10);

            // Count active filters
            var activeFilters = document.querySelectorAll('.ais-current-refined-values--link').length;

            // Only announce if filters changed (not on initial load or load more)
            if (!isInitialRender && !window.algoliaIsLoadingMore && (activeFilters !== previousActiveFilters || previousResultsCount !== currentResultsCount)) {
              if (currentResultsCount === 0) {
                statusMessage.textContent = 'No results found with current filters.';
              } else if (currentResultsCount === 1) {
                statusMessage.textContent = '1 result found.';
              } else {
                statusMessage.textContent = "".concat(currentResultsCount.toLocaleString(), " results found.");
              }
            }
            previousResultsCount = currentResultsCount;
            previousActiveFilters = activeFilters;
          }
        }
        if (isInitialRender) {
          isInitialRender = false;
        }
      });
      document.addEventListener('algolia.instantSearch.afterInit', function () {
        // Set up Load More button click tracking for ARIA announcements
        var instantSearchWrapper = document.getElementById('algolia-shopify-instantsearch');

        // Use event delegation to handle Load More button clicks
        if (instantSearchWrapper) {
          instantSearchWrapper.addEventListener('click', function (event) {
            var loadMoreButton = event.target.closest('.ais-InfiniteHits-loadMore');
            if (loadMoreButton && !loadMoreButton.disabled) {
              // Set flag to track that we're loading more
              window.algoliaIsLoadingMore = true;

              // Announce loading state
              var statusMessage = document.getElementById('algolia-status-message');
              if (statusMessage) {
                statusMessage.textContent = 'Loading more products...';
              }
            }
          });
        }
        if (!window.collectionBannerConfig) return; // Only run when we have the collectionBannerConfig

        var hitsContainer = instantSearchWrapper === null || instantSearchWrapper === void 0 ? void 0 : instantSearchWrapper.querySelector('.ais-hits-container');
        if (hitsContainer) {
          var banner = document.createElement('li');
          banner.className = 'ais-Hits-collection-banner';
          banner.innerHTML = "\n          <div class=\"relative bg-cover bg-center h-full w-full\" style=\"".concat(window.collectionBannerConfig.background_image ? "background-image: url(".concat(window.collectionBannerConfig.background_image, ");") : 'background-color: #F7F2DB;', "\">\n\n            <div class=\"collection-banner-content h-full flex flex-col justify-between gap-5 text-center\">\n              <div class=\"top-content\">\n                <h2 class=\"text-white font-serif text-lg lg:text-xl xl:text-3xl tracking-s-wide xl:mb-2\">\n                  ").concat(window.collectionBannerConfig.title, "\n                </h2>\n                <h3 class=\"text-white uppercase text-[8px] leading-3 lg:text-xxs xl:text-sm xl:font-bold tracking-x-widest\">\n                  ").concat(window.collectionBannerConfig.subtitle, "\n                </h3>\n              </div>\n              <div class=\"cta-wrapper\">\n                <a href=\"").concat(window.collectionBannerConfig.cta_link, "\" class=\"inline-block rounded-full uppercase tracking-x-widest text-white border-0\"\n                  style=\"background-color: ").concat(window.collectionBannerConfig.cta_background_color, "; color: ").concat(window.collectionBannerConfig.cta_color, ";\">\n                  ").concat(window.collectionBannerConfig.cta_title, "\n                </a>\n              </div>\n            </div>\n          </div>\n        ");
          var observer = new MutationObserver(function () {
            var hitsList = hitsContainer.querySelector('.ais-InfiniteHits-list');
            if (hitsList) {
              observer.disconnect();
              hitsList.classList.add('has-collection-banner');
              if (hitsList.firstChild) {
                hitsList.insertBefore(banner, hitsList.firstChild);
              } else {
                hitsList.appendChild(banner);
              }
            }
          });
          observer.observe(hitsContainer, {
            childList: true,
            subtree: true
          });
        }
      });
      document.addEventListener('algolia.hooks.initialize', function () {
        var _window$instantsearch, _window$instantsearch2;
        var infiniteHits = (_window$instantsearch = window.instantsearch) === null || _window$instantsearch === void 0 ? void 0 : (_window$instantsearch2 = _window$instantsearch.widgets) === null || _window$instantsearch2 === void 0 ? void 0 : _window$instantsearch2.infiniteHits;
        var isCollectionPage = window.location.pathname.includes('/collections/');
        if (infiniteHits) {
          // Remove ais.hits, ais.pagination and ais.searchBox widgets
          algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function (defaultWidgets) {
            var hitsWidget = defaultWidgets.find(function (widget) {
              return widget.$$widgetType === 'ais.hits';
            });
            var paginationWidget = defaultWidgets.find(function (widget) {
              return widget.$$widgetType === 'ais.pagination';
            });
            if (isCollectionPage) {
              var searchBoxWidget = defaultWidgets.find(function (widget) {
                return widget.$$widgetType === 'ais.searchBox';
              });
              return [hitsWidget, paginationWidget, searchBoxWidget];
            }
            return [hitsWidget, paginationWidget];
          });

          // Add infiniteHits widget
          algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
            var _window$algoliaShopif, _window$algoliaShopif2, _window$algoliaShopif3;
            var previousHitsCount = 0;
            var infiniteHitsWidget = infiniteHits({
              container: '.ais-hits-container',
              templates: {
                item: function item(hit, _ref) {
                  var html = _ref.html,
                    components = _ref.components;
                  return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(hit, html, components, window.algoliaShopify);
                },
                empty: function empty(results, _ref2) {
                  var html = _ref2.html;
                  return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(html, window.algoliaShopify);
                },
                showMoreText: function showMoreText(data, _ref3) {
                  var html = _ref3.html;
                  return html(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["Load more"])));
                }
              },
              transformItems: function transformItems(items) {
                var transformedItems = items.map(function (item) {
                  return algolia_search_objectSpread(algolia_search_objectSpread({}, item), {}, {
                    _distinct: window.algoliaShopify.instantsearch.distinct,
                    can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
                    queryID: item.__queryID,
                    productPosition: item.__position,
                    index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName()
                  });
                });

                // Announce status when more products are loaded
                if (window.algoliaIsLoadingMore && transformedItems.length > previousHitsCount) {
                  var newItemsCount = transformedItems.length - previousHitsCount;
                  var statusMessage = document.getElementById('algolia-status-message');
                  if (statusMessage) {
                    statusMessage.textContent = "".concat(newItemsCount, " more products loaded. Total ").concat(transformedItems.length, " products displayed.");
                  }
                  window.algoliaIsLoadingMore = false;
                }
                previousHitsCount = transformedItems.length;
                return transformedItems;
              }
            });
            var configure = (_window$algoliaShopif = window.algoliaShopify) === null || _window$algoliaShopif === void 0 ? void 0 : (_window$algoliaShopif2 = _window$algoliaShopif.externals) === null || _window$algoliaShopif2 === void 0 ? void 0 : (_window$algoliaShopif3 = _window$algoliaShopif2.widgets) === null || _window$algoliaShopif3 === void 0 ? void 0 : _window$algoliaShopif3.configure;
            if (configure) {
              var configureWidget = configure({
                facetingAfterDistinct: false // Set facetingAfterDistinct to false so that proper filters are available on sorting
              });

              return [infiniteHitsWidget, configureWidget];
            }
            return [infiniteHitsWidget];
          });
        }
        algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
          var isMdlargeScreen = window.innerWidth <= 799;
          return html(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n          <div class=\"ais-page\">\n            <div class=\"ais-h2\">Search Results</div>\n            <div class=\"ais-input\">\n              <div class=\"ais-search-box-container\"></div>\n              <div class=\"ais-input-button\">\n                <div class=\"ais-clear-input-icon\"></div>\n              </div>\n            </div>\n            <div class=\"ais-facets-and-blocks\">\n              <div\n                class=\"ais-facets-backdrop fixed inset-0 z-40 hidden bg-p-bark/70\"\n                onClick=\"", "\"\n              ></div>\n              <div class=\"ais-facets\">\n                <div class=\"ais-facets--content\">\n                  <h2 class=\"ais-facets--title flex items-center justify-between\">\n                    Filters\n                    <button\n                      class=\"ais-facets-drawer-close hidden\"\n                      type=\"button\"\n                      onClick=\"", "\"\n                      aria-label=\"Close panel\"\n                    >\n                      <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M18 6L6 18\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M6 6L18 18\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </button>\n                  </h2>\n                  ", "\n                  ", "\n                </div>\n              </div>\n              <div class=\"ais-block\">\n                <div class=\"ais-search-header hidden\">\n                  <div class=\"ais-change-display\">\n                    <span class=\"ais-change-display-block ais-change-display-selected\">\n                      <i class=\"fa fa-th-large\"></i>\n                    </span>\n                    <span class=\"ais-change-display-list\">\n                      <i class=\"fa fa-th-list\"></i>\n                    </span>\n                  </div>\n                </div>\n                <div class=\"ais-block-header\">\n                  <div class=\"ais-stats-container\"></div>\n                  <button\n                    class=\"ais-facets-drawer-button flex shrink-0 items-center gap-x-1 border-b border-p-bark pb-0.5 text-sm font-bold text-p-bark mdl:hidden\"\n                    type=\"button\"\n                    onClick=\"", "\"\n                  >\n                    <span>\n                      <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M5 15.625V11.25\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M5 8.75V4.375\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M10 15.625V10\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M10 7.5V4.375\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M15 15.625V12.5\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M15 10V4.375\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M3.125 11.25H6.875\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M8.125 7.5H11.875\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M13.125 12.5H16.875\"\n                          stroke=\"#47483B\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </span>\n                    Filter & Sort\n                  </button>\n                  <div class=\"ais-facets-button hidden\">Show filters</div>\n                  ", "\n                </div>\n                <div class=\"ais-refined-values-wrapper\">\n                  <div class=\"ais-current-refined-values-container scrollbar-hide overflow-x-auto\"></div>\n                  <div class=\"ais-clear-refinements-container\"></div>\n                </div>\n                <div\n                  role=\"status\"\n                  aria-live=\"polite\"\n                  aria-atomic=\"true\"\n                  class=\"sr-only\"\n                  id=\"algolia-status-message\"\n                ></div>\n                <div class=\"ais-hits-container ais-results-as-block\"></div>\n              </div>\n            </div>\n            <div class=\"ais-pagination-container\"></div>\n          </div>\n        "])), function (event) {
            return aisCloseFacetsDrawer(event);
          }, function (event) {
            return aisCloseFacetsDrawer(event);
          }, isMdlargeScreen && html(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"ais-sort mdl:hidden\">\n                      ", "\n                    </div>\n                  "])), data.multipleSortOrders ? html(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n                            <span class=\"ais-sort-text\">Sort by</span>\n                            <span class=\"ais-sort-orders-container\"></span>\n                          "]))) : html(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)([" <span class=\"ais-sort-text\">Sorted by</span> ", " "])), algoliaShopify.translations.relevance)), data.facets.map(function (facet) {
            return html(_templateObject19 || (_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n                      <div class=\"ais-facet-dropdown-wrapper ais-facet-", " ais-facet-", "\">\n                        <input\n                          class=\"ais-dropdown-checkbox\"\n                          type=\"checkbox\"\n                          id=\"", "\"\n                          name=\"dropdown\"\n                        />\n                        <label\n                          for=\"", "\"\n                          class=\"ais-range-slider--header ais-facet--header ais-header select-none\"\n                        >\n                          ", "\n                          <span class=\"ais-facet--header-icon transition-transform duration-300\">\n                            <svg\n                              width=\"20\"\n                              height=\"20\"\n                              viewBox=\"0 0 20 20\"\n                              fill=\"none\"\n                              xmlns=\"http://www.w3.org/2000/svg\"\n                            >\n                              <path\n                                d=\"M16.3725 13.125L10.3268 6.875L4.28101 13.125\"\n                                stroke=\"#47483B\"\n                                stroke-width=\"1.5\"\n                                stroke-linecap=\"round\"\n                                stroke-linejoin=\"round\"\n                              />\n                            </svg>\n                          </span>\n                        </label>\n                        <div\n                          class=\"ais-facet-", "-container ais-facet-dropdown-container animate-fade-in\"\n                        ></div>\n                      </div>\n                    "])), facet.type, facet.escapedName, facet.escapedName, facet.escapedName, facet.title, facet.escapedName);
          }), function (event) {
            return aisOpenFacetsDrawer(event);
          }, !isMdlargeScreen && html(_templateObject20 || (_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <div class=\"ais-sort max-mdl:hidden\">\n                      ", "\n                    </div>\n                  "])), data.multipleSortOrders ? html(_templateObject21 || (_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n                            <span class=\"ais-sort-text\">Sort by</span>\n                            <span class=\"ais-sort-orders-container\"></span>\n                          "]))) : html(_templateObject22 || (_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)([" <span class=\"ais-sort-text\">Sorted by</span> ", " "])), algoliaShopify.translations.relevance)));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function (_defaultTemplate, item, html) {
          return html(_templateObject23 || (_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <label\n              class=\"", " ", "\"\n            >\n              ", "\n              ", "\n              ", "\n              <span class=\"", "\"> ", " </span>\n            </label>\n          "])), item.cssClasses.label, item.type === 'disjunctive' ? 'outline-2 outline-offset-2 outline-blue-600 focus:outline-none has-[input:focus-visible]:outline' : '', item.type === 'disjunctive' && (item.isRefined ? html(_templateObject24 || (_templateObject24 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <input type=\"checkbox\" class=\"", " sr-only\" checked />\n                    <span class=\"ais-facet--custom-icon\">\n                      <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z\"\n                          fill=\"#47483B\"\n                          stroke=\"#47483B\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                        <path\n                          d=\"M14 5.5L7.125 12.5L4 9.31818\"\n                          stroke=\"white\"\n                          stroke-width=\"1.5\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </span>\n                  "])), item.cssClasses.checkbox) : html(_templateObject25 || (_templateObject25 = (0,taggedTemplateLiteral/* default */.Z)(["\n                    <input type=\"checkbox\" class=\"", " sr-only\" />\n                    <span class=\"ais-facet--custom-icon\">\n                      <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <path\n                          d=\"M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z\"\n                          stroke=\"#47483B\"\n                          stroke-linecap=\"round\"\n                          stroke-linejoin=\"round\"\n                        />\n                      </svg>\n                    </span>\n                  "])), item.cssClasses.checkbox)), item.type === 'menu' && html(_templateObject26 || (_templateObject26 = (0,taggedTemplateLiteral/* default */.Z)(["\n                <span\n                  class=\"ais-facet--custom-icon flex h-4 w-4 items-center justify-center rounded-full border border-black\"\n                >\n                  <span class=\"", " h-2 w-2 rounded-full bg-p-bark\"></span>\n                </span>\n              "])), item.isRefined ? '' : 'hidden'), trademarkHtml(item.label, html), item.cssClasses.count, algoliaShopify.helpers.formatNumber(item.count));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
          return html(_templateObject27 || (_templateObject27 = (0,taggedTemplateLiteral/* default */.Z)(["\n          ", "\n          ", "\n        "])), data.hasOneResult && html(_templateObject28 || (_templateObject28 = (0,taggedTemplateLiteral/* default */.Z)(["Showing ", " <span class=\"font-bold\"> 1 </span> item "])), ' '), data.hasManyResults && html(_templateObject29 || (_templateObject29 = (0,taggedTemplateLiteral/* default */.Z)(["\n            Showing ", "\n            <span class=\"font-bold\"> ", " </span>\n            ", " of ", "\n            <span class=\"font-bold\"> ", " </span>\n            ", " items\n          "])), ' ', Math.min((data.page + 1) * data.hitsPerPage, data.nbHits), ' ', ' ', algoliaShopify.helpers.formatNumber(data.nbHits), ' '));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
          return html(_templateObject30 || (_templateObject30 = (0,taggedTemplateLiteral/* default */.Z)(["\n          <div class=\"ais-hit-empty\">\n            <div class=\"ais-hit-empty--title\">", "</div>\n            <div class=\"ais-hit-empty--clears\">\n              ", " ", "\n              <a class=\"ais-hit-empty--clear-filters ais-link\"> ", " ", " </a>\n              ", "\n            </div>\n          </div>\n        "])), algoliaShopify.translations.noResultFound, algoliaShopify.translations["try"], ' ', algoliaShopify.translations.clearFilters, ' ', !isCollectionPage && html(_templateObject31 || (_templateObject31 = (0,taggedTemplateLiteral/* default */.Z)(["\n                ", " ", "\n                <a class=\"ais-hit-empty--clear-input ais-link\"> ", " </a>\n              "])), algoliaShopify.translations.or, ' ', algoliaShopify.translations.changeInput));
        });
        algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, handleItemClick) {
          var _hit$body_html_safe, _hit$meta20, _hit$meta20$okendo, _hit$meta21, _hit$meta21$custom, _hit$meta23, _hit$meta23$custom, _hit$meta23$custom$co, _hit$meta24, _hit$meta24$custom, _hit$metafields11, _hit$metafields11$cus, _hit$metafields11$cus2, _hit$meta25, _hit$meta25$custom, _hit$meta25$custom$co, _hit$meta26, _hit$meta26$custom, _hit$metafields12, _hit$metafields12$cus, _hit$metafields12$cus2, _hit$meta27, _hit$meta27$custom, _hit$meta27$custom$co, _hit$meta28, _hit$meta28$custom, _hit$metafields13, _hit$metafields13$cus, _hit$metafields13$cus2, _hit$meta29, _hit$meta29$custom, _hit$meta29$custom$co, _hit$meta30, _hit$meta30$custom, _hit$metafields14, _hit$metafields14$cus, _hit$metafields14$cus2, _hit$meta31, _hit$meta31$custom, _hit$meta31$custom$co, _hit$meta32, _hit$meta32$custom, _hit$metafields15, _hit$metafields15$cus, _hit$metafields15$cus2, _hit$meta33, _hit$meta33$custom, _hit$meta33$custom$co, _hit$meta34, _hit$meta34$custom, _hit$metafields16, _hit$metafields16$cus, _hit$metafields16$cus2, _hit$meta35, _hit$meta35$custom, _hit$meta35$custom$co, _hit$meta36, _hit$meta36$custom, _hit$metafields17, _hit$metafields17$cus, _hit$metafields17$cus2, _hit$meta37, _hit$meta37$custom, _hit$meta37$custom$co, _hit$meta38, _hit$meta38$custom, _hit$metafields18, _hit$metafields18$cus, _hit$metafields18$cus2, _hit$meta39, _hit$meta39$okendo, _hit$meta39$okendo$St, _hit$meta40, _hit$meta40$okendo, _hit$metafields19, _hit$metafields19$oke, _hit$metafields19$oke2, _hit$meta41, _hit$meta41$okendo, _hit$meta41$okendo$su, _hit$metafields20, _hit$metafields20$oke, _hit$metafields20$oke2;
          var productId = hit.id;
          var productDescription = (_hit$body_html_safe = hit.body_html_safe) === null || _hit$body_html_safe === void 0 ? void 0 : _hit$body_html_safe.replace(/&amp;/g, '&');
          var okendoReviewSnippet = (_hit$meta20 = hit.meta) === null || _hit$meta20 === void 0 ? void 0 : (_hit$meta20$okendo = _hit$meta20.okendo) === null || _hit$meta20$okendo === void 0 ? void 0 : _hit$meta20$okendo.StarRatingSnippet;
          var productAltObj = {
            showImage: false,
            showBadge: false
          };
          if ((_hit$meta21 = hit.meta) !== null && _hit$meta21 !== void 0 && (_hit$meta21$custom = _hit$meta21.custom) !== null && _hit$meta21$custom !== void 0 && _hit$meta21$custom.algolia_alt_image_url) {
            var _hit$meta22, _hit$meta22$custom;
            productAltObj.showImage = true;
            productAltObj.image = (_hit$meta22 = hit.meta) === null || _hit$meta22 === void 0 ? void 0 : (_hit$meta22$custom = _hit$meta22.custom) === null || _hit$meta22$custom === void 0 ? void 0 : _hit$meta22$custom.algolia_alt_image_url;
          }
          if (hit.tags && window.productBadgesConfigs) {
            if (Array.isArray(hit.tags)) {
              var badgeTag = hit.tags.find(function (tag) {
                return tag.includes('badge-');
              });
              if (badgeTag) {
                var badgeHandle = badgeTag.replace('badge-', '');
                if (window.productBadgesConfigs[badgeHandle]) {
                  productAltObj.showBadge = true;
                  productAltObj.badgeConfig = window.productBadgesConfigs[badgeHandle];
                }
              }
            }
          }

          // Get theme settings to check if compare is enabled
          var themeSettings = getThemeSettings();
          var isCompareEnabled = themeSettings.enablePlpCompare;
          return html(_templateObject32 || (_templateObject32 = (0,taggedTemplateLiteral/* default */.Z)(["\n            <div\n              class=\"ais-hit ais-product\"\n              data-algolia-index=\"", "\"\n              data-algolia-position=\"", "\"\n              data-algolia-queryid=\"", "\"\n              data-algolia-objectid=\"", "\"\n              data-handle=\"", "\"\n              data-variant-id=\"", "\"\n              data-distinct=\"", "\"\n              data-product-id=\"", "\"\n              onClick=\"", "\"\n            >\n              <div class=\"ais-hit--picture-wrapper ", "\">\n                <img\n                  class=\"ais-hit--picture\"\n                  src=\"", "\"\n                  alt=\"", "\"\n                  loading=\"lazy\"\n                />\n                ", "\n                ", "\n              </div>\n\n              <div class=\"ais-hit--content\">\n                ", "\n                <div class=\"ais-hit--title\">\n                  <a\n                    data-algolia-index=\"", "\"\n                    data-algolia-position=\"", "\"\n                    data-algolia-queryid=\"", "\"\n                    data-algolia-objectid=\"", "\"\n                    href=\"", "\"\n                    onclick=\"void(0)\"\n                    title=\"", "\"\n                  >\n                    ", "\n                    ", "\n                  </a>\n                </div>\n                ", "\n              </div>\n              <div class=\"ais-hit--price\">\n                ", "\n                ", "\n                ", "\n              </div>\n              <div\n                class=\"ais-hit--buttons-section ", " !mt-3 flex xl:!mt-5\"\n                onClick=\"", "\"\n              >\n                <button\n                  type=\"button\"\n                  class=\" flex w-full items-center justify-center rounded-full border border-[--atc-btn-bg-color] bg-[--atc-btn-bg-color] px-3 py-2 text-xxs font-bold uppercase tracking-x-widest text-[--atc-btn-text-color] outline-offset-4 lg:text-xs  xl:px-5 xl:py-[13px] xl:text-sm\"\n                  onClick=\"", "\"\n                >\n                  ", "\n                </button>\n\n                <!-- Compare Checkbox (conditionally rendered) -->\n                ", "\n              </div>\n            </div>\n          "])), hit.index, hit.productPosition, hit.queryID, hit.objectID, hit.handle, hit.objectID, hit._distinct, hit.id, function (event) {
            return handleItemClick(event, hit);
          }, productAltObj.showImage ? 'has-alt-picture' : '', algoliaShopify.helpers.largeImage(hit), hit.title, productAltObj.showImage && html(_templateObject33 || (_templateObject33 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <img\n                    class=\"ais-hit--alt-picture\"\n                    src=\"", "\"\n                    alt=\"", "\"\n                    loading=\"lazy\"\n                  />\n                "])), algoliaShopify.helpers.largeImage(productAltObj), hit.title), productAltObj.showBadge && html(_templateObject34 || (_templateObject34 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"ais-hit--badge-container\">\n                    ", "\n                  </div>\n                "])), productAltObj.badgeConfig.image ? html(_templateObject35 || (_templateObject35 = (0,taggedTemplateLiteral/* default */.Z)(["\n                          <img\n                            class=\"ais-hit--badge-image\"\n                            src=\"", "\"\n                            alt=\"", "\"\n                            loading=\"lazy\"\n                          />\n                        "])), productAltObj.badgeConfig.image, productAltObj.badgeConfig.imageAlt || hit.title) : html(_templateObject36 || (_templateObject36 = (0,taggedTemplateLiteral/* default */.Z)(["\n                          <span\n                            style=\"background-color: ", "; color: ", ";\"\n                            class=\"ais-hit--badge\"\n                          >\n                            ", "\n                          </span>\n                        "])), productAltObj.badgeConfig.backgroundColor, productAltObj.badgeConfig.textColor, productAltObj.badgeConfig.text)), productId && okendoReviewSnippet && html(_templateObject37 || (_templateObject37 = (0,taggedTemplateLiteral/* default */.Z)([" <div class=\"ais-hit--review oke-small-size\">", "</div> "])), html([okendoReviewSnippet])), hit.index, hit.productPosition, hit.queryID, hit.objectID, algoliaShopify.helpers.instantsearchLink(hit), algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title), highlightWithTrademarks(hit, 'title', html), algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct), productDescription && html(_templateObject38 || (_templateObject38 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <div class=\"ais-hit--description\">\n                    ", "\n                  </div>\n                "])), trademarkHtml(productDescription.length > 70 ? productDescription.substring(0, 67) + '...' : productDescription, html)), algoliaShopify.helpers.displayPrice(hit, hit._distinct), !hit._distinct && html(_templateObject39 || (_templateObject39 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <span class=\"ais-hit--price-striked\">\n                    <span>", "</span>\n                  </span>\n                "])), algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)), !hit._distinct && html(_templateObject40 || (_templateObject40 = (0,taggedTemplateLiteral/* default */.Z)(["\n                  <span class=\"ais-hit--price-discount\">\n                    ", "\n                  </span>\n                "])), algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)), isCompareEnabled ? 'flex-col items-center justify-between gap-2 md:flex-row md:gap-4' : 'flex-row items-center justify-center', function (event) {
            return event.stopPropagation();
          }, function (event) {
            var isLowStock = hit.variants_inventory_count < 100;
            var isBackInStock = hit.tags.includes('back_in_stock');
            var isInStock = hit.variants_inventory_count !== 0;
            if (isLowStock && isBackInStock || isInStock) {
              aisQuickBuyModal(event, hit.handle);
            }
          }, hit.tags.includes('back_in_stock') ? 'Quick Buy' : hit.variants_inventory_count === 0 ? 'Coming Soon' : 'ADD TO BAG', isCompareEnabled ? html(_templateObject41 || (_templateObject41 = (0,taggedTemplateLiteral/* default */.Z)(["\n                      <div class=\"flex items-center justify-center gap-1\">\n                        <input\n                          type=\"checkbox\"\n                          id=\"compare-", "\"\n                          class=\"compare-checkbox border-1 text-p-bark focus:ring-0 focus:ring-p-bark disabled:cursor-not-allowed disabled:opacity-50\"\n                          data-product-id=\"", "\"\n                          data-product-title=\"", "\"\n                          data-product-image=\"", "\"\n                          data-product-url=\"", "\"\n                          data-product-price=\"", "\"\n                          data-product-price-min=\"", "\"\n                          data-product-price-max=\"", "\"\n                          data-product-variants-count=\"", "\"\n                          data-product-handle=\"", "\"\n                          data-product-form=\"", "\"\n                          data-product-suggested-use=\"", "\"\n                          data-product-supply-per-bottle=\"", "\"\n                          data-product-key-ingredients=\"", "\"\n                          data-product-certifications=\"", "\"\n                          data-product-allergen-info=\"", "\"\n                          data-product-price-per-serving=\"", "\"\n                          data-product-benefits=\"", "\"\n                          data-product-star-rating=\"", "\"\n                          data-product-review-count=\"", "\"\n                          onChange=\"", "\"\n                          x-bind:checked=\"window.plpCompareComponent?.isProductSelected(", ") || false\"\n                          x-bind:disabled=\"!window.plpCompareComponent?.isProductSelected(", ") && window.plpCompareComponent?.isMaxSelected\"\n                        />\n                        <label\n                          for=\"compare-", "\"\n                          class=\"cursor-pointer text-sm font-bold leading-6 text-p-bark\"\n                          onClick=\"", "\"\n                        >\n                          Compare\n                        </label>\n                      </div>\n                    "])), hit.id, hit.id, hit.title, algoliaShopify.helpers.largeImage(hit), algoliaShopify.helpers.instantsearchLink(hit), algoliaShopify.helpers.displayPrice(hit, hit._distinct), hit.price_min ? algoliaShopify.helpers.formatMoney(hit.price_min) : '', hit.price_max ? algoliaShopify.helpers.formatMoney(hit.price_max) : '', hit.variants ? hit.variants.length : 1, hit.handle, ((_hit$meta23 = hit.meta) === null || _hit$meta23 === void 0 ? void 0 : (_hit$meta23$custom = _hit$meta23.custom) === null || _hit$meta23$custom === void 0 ? void 0 : (_hit$meta23$custom$co = _hit$meta23$custom.compare_product_form) === null || _hit$meta23$custom$co === void 0 ? void 0 : _hit$meta23$custom$co.value) || ((_hit$meta24 = hit.meta) === null || _hit$meta24 === void 0 ? void 0 : (_hit$meta24$custom = _hit$meta24.custom) === null || _hit$meta24$custom === void 0 ? void 0 : _hit$meta24$custom.compare_product_form) || ((_hit$metafields11 = hit.metafields) === null || _hit$metafields11 === void 0 ? void 0 : (_hit$metafields11$cus = _hit$metafields11.custom) === null || _hit$metafields11$cus === void 0 ? void 0 : (_hit$metafields11$cus2 = _hit$metafields11$cus.compare_product_form) === null || _hit$metafields11$cus2 === void 0 ? void 0 : _hit$metafields11$cus2.value) || 'N/A', ((_hit$meta25 = hit.meta) === null || _hit$meta25 === void 0 ? void 0 : (_hit$meta25$custom = _hit$meta25.custom) === null || _hit$meta25$custom === void 0 ? void 0 : (_hit$meta25$custom$co = _hit$meta25$custom.compare_product_suggested_use) === null || _hit$meta25$custom$co === void 0 ? void 0 : _hit$meta25$custom$co.value) || ((_hit$meta26 = hit.meta) === null || _hit$meta26 === void 0 ? void 0 : (_hit$meta26$custom = _hit$meta26.custom) === null || _hit$meta26$custom === void 0 ? void 0 : _hit$meta26$custom.compare_product_suggested_use) || ((_hit$metafields12 = hit.metafields) === null || _hit$metafields12 === void 0 ? void 0 : (_hit$metafields12$cus = _hit$metafields12.custom) === null || _hit$metafields12$cus === void 0 ? void 0 : (_hit$metafields12$cus2 = _hit$metafields12$cus.compare_product_suggested_use) === null || _hit$metafields12$cus2 === void 0 ? void 0 : _hit$metafields12$cus2.value) || 'N/A', ((_hit$meta27 = hit.meta) === null || _hit$meta27 === void 0 ? void 0 : (_hit$meta27$custom = _hit$meta27.custom) === null || _hit$meta27$custom === void 0 ? void 0 : (_hit$meta27$custom$co = _hit$meta27$custom.compare_product_supply_per_bottle) === null || _hit$meta27$custom$co === void 0 ? void 0 : _hit$meta27$custom$co.value) || ((_hit$meta28 = hit.meta) === null || _hit$meta28 === void 0 ? void 0 : (_hit$meta28$custom = _hit$meta28.custom) === null || _hit$meta28$custom === void 0 ? void 0 : _hit$meta28$custom.compare_product_supply_per_bottle) || ((_hit$metafields13 = hit.metafields) === null || _hit$metafields13 === void 0 ? void 0 : (_hit$metafields13$cus = _hit$metafields13.custom) === null || _hit$metafields13$cus === void 0 ? void 0 : (_hit$metafields13$cus2 = _hit$metafields13$cus.compare_product_supply_per_bottle) === null || _hit$metafields13$cus2 === void 0 ? void 0 : _hit$metafields13$cus2.value) || 'N/A', ((_hit$meta29 = hit.meta) === null || _hit$meta29 === void 0 ? void 0 : (_hit$meta29$custom = _hit$meta29.custom) === null || _hit$meta29$custom === void 0 ? void 0 : (_hit$meta29$custom$co = _hit$meta29$custom.compare_product_key_ingredients) === null || _hit$meta29$custom$co === void 0 ? void 0 : _hit$meta29$custom$co.value) || ((_hit$meta30 = hit.meta) === null || _hit$meta30 === void 0 ? void 0 : (_hit$meta30$custom = _hit$meta30.custom) === null || _hit$meta30$custom === void 0 ? void 0 : _hit$meta30$custom.compare_product_key_ingredients) || ((_hit$metafields14 = hit.metafields) === null || _hit$metafields14 === void 0 ? void 0 : (_hit$metafields14$cus = _hit$metafields14.custom) === null || _hit$metafields14$cus === void 0 ? void 0 : (_hit$metafields14$cus2 = _hit$metafields14$cus.compare_product_key_ingredients) === null || _hit$metafields14$cus2 === void 0 ? void 0 : _hit$metafields14$cus2.value) || 'N/A', ((_hit$meta31 = hit.meta) === null || _hit$meta31 === void 0 ? void 0 : (_hit$meta31$custom = _hit$meta31.custom) === null || _hit$meta31$custom === void 0 ? void 0 : (_hit$meta31$custom$co = _hit$meta31$custom.compare_product_certifications) === null || _hit$meta31$custom$co === void 0 ? void 0 : _hit$meta31$custom$co.value) || ((_hit$meta32 = hit.meta) === null || _hit$meta32 === void 0 ? void 0 : (_hit$meta32$custom = _hit$meta32.custom) === null || _hit$meta32$custom === void 0 ? void 0 : _hit$meta32$custom.compare_product_certifications) || ((_hit$metafields15 = hit.metafields) === null || _hit$metafields15 === void 0 ? void 0 : (_hit$metafields15$cus = _hit$metafields15.custom) === null || _hit$metafields15$cus === void 0 ? void 0 : (_hit$metafields15$cus2 = _hit$metafields15$cus.compare_product_certifications) === null || _hit$metafields15$cus2 === void 0 ? void 0 : _hit$metafields15$cus2.value) || 'N/A', ((_hit$meta33 = hit.meta) === null || _hit$meta33 === void 0 ? void 0 : (_hit$meta33$custom = _hit$meta33.custom) === null || _hit$meta33$custom === void 0 ? void 0 : (_hit$meta33$custom$co = _hit$meta33$custom.compare_product_allergen_info) === null || _hit$meta33$custom$co === void 0 ? void 0 : _hit$meta33$custom$co.value) || ((_hit$meta34 = hit.meta) === null || _hit$meta34 === void 0 ? void 0 : (_hit$meta34$custom = _hit$meta34.custom) === null || _hit$meta34$custom === void 0 ? void 0 : _hit$meta34$custom.compare_product_allergen_info) || ((_hit$metafields16 = hit.metafields) === null || _hit$metafields16 === void 0 ? void 0 : (_hit$metafields16$cus = _hit$metafields16.custom) === null || _hit$metafields16$cus === void 0 ? void 0 : (_hit$metafields16$cus2 = _hit$metafields16$cus.compare_product_allergen_info) === null || _hit$metafields16$cus2 === void 0 ? void 0 : _hit$metafields16$cus2.value) || 'N/A', ((_hit$meta35 = hit.meta) === null || _hit$meta35 === void 0 ? void 0 : (_hit$meta35$custom = _hit$meta35.custom) === null || _hit$meta35$custom === void 0 ? void 0 : (_hit$meta35$custom$co = _hit$meta35$custom.compare_product_price_per_serving) === null || _hit$meta35$custom$co === void 0 ? void 0 : _hit$meta35$custom$co.value) || ((_hit$meta36 = hit.meta) === null || _hit$meta36 === void 0 ? void 0 : (_hit$meta36$custom = _hit$meta36.custom) === null || _hit$meta36$custom === void 0 ? void 0 : _hit$meta36$custom.compare_product_price_per_serving) || ((_hit$metafields17 = hit.metafields) === null || _hit$metafields17 === void 0 ? void 0 : (_hit$metafields17$cus = _hit$metafields17.custom) === null || _hit$metafields17$cus === void 0 ? void 0 : (_hit$metafields17$cus2 = _hit$metafields17$cus.compare_product_price_per_serving) === null || _hit$metafields17$cus2 === void 0 ? void 0 : _hit$metafields17$cus2.value) || 'N/A', extractTextFromRichText(((_hit$meta37 = hit.meta) === null || _hit$meta37 === void 0 ? void 0 : (_hit$meta37$custom = _hit$meta37.custom) === null || _hit$meta37$custom === void 0 ? void 0 : (_hit$meta37$custom$co = _hit$meta37$custom.compare_product_benefits) === null || _hit$meta37$custom$co === void 0 ? void 0 : _hit$meta37$custom$co.value) || ((_hit$meta38 = hit.meta) === null || _hit$meta38 === void 0 ? void 0 : (_hit$meta38$custom = _hit$meta38.custom) === null || _hit$meta38$custom === void 0 ? void 0 : _hit$meta38$custom.compare_product_benefits) || ((_hit$metafields18 = hit.metafields) === null || _hit$metafields18 === void 0 ? void 0 : (_hit$metafields18$cus = _hit$metafields18.custom) === null || _hit$metafields18$cus === void 0 ? void 0 : (_hit$metafields18$cus2 = _hit$metafields18$cus.compare_product_benefits) === null || _hit$metafields18$cus2 === void 0 ? void 0 : _hit$metafields18$cus2.value)) || '', ((_hit$meta39 = hit.meta) === null || _hit$meta39 === void 0 ? void 0 : (_hit$meta39$okendo = _hit$meta39.okendo) === null || _hit$meta39$okendo === void 0 ? void 0 : (_hit$meta39$okendo$St = _hit$meta39$okendo.StarRatingSnippet) === null || _hit$meta39$okendo$St === void 0 ? void 0 : _hit$meta39$okendo$St.value) || ((_hit$meta40 = hit.meta) === null || _hit$meta40 === void 0 ? void 0 : (_hit$meta40$okendo = _hit$meta40.okendo) === null || _hit$meta40$okendo === void 0 ? void 0 : _hit$meta40$okendo.StarRatingSnippet) || ((_hit$metafields19 = hit.metafields) === null || _hit$metafields19 === void 0 ? void 0 : (_hit$metafields19$oke = _hit$metafields19.okendo) === null || _hit$metafields19$oke === void 0 ? void 0 : (_hit$metafields19$oke2 = _hit$metafields19$oke.StarRatingSnippet) === null || _hit$metafields19$oke2 === void 0 ? void 0 : _hit$metafields19$oke2.value) || '', ((_hit$meta41 = hit.meta) === null || _hit$meta41 === void 0 ? void 0 : (_hit$meta41$okendo = _hit$meta41.okendo) === null || _hit$meta41$okendo === void 0 ? void 0 : (_hit$meta41$okendo$su = _hit$meta41$okendo.summaryData) === null || _hit$meta41$okendo$su === void 0 ? void 0 : _hit$meta41$okendo$su.reviewCount) || ((_hit$metafields20 = hit.metafields) === null || _hit$metafields20 === void 0 ? void 0 : (_hit$metafields20$oke = _hit$metafields20.okendo) === null || _hit$metafields20$oke === void 0 ? void 0 : (_hit$metafields20$oke2 = _hit$metafields20$oke.summaryData) === null || _hit$metafields20$oke2 === void 0 ? void 0 : _hit$metafields20$oke2.reviewCount) || 0, function (event) {
            event.stopPropagation();
            event.preventDefault();
            aisToggleCompareFromCheckbox(event);
          }, hit.id, hit.id, hit.id, function (event) {
            event.stopPropagation();
          }) : '');
        });
      });
    }
  };
};
var searchComponent = function searchComponent() {
  return {
    showSearchSuggestions: false,
    showSearchSuggestionsMobile: false,
    searchSuggestions: [],
    init: function init() {
      this.fetchTopSearches();
    },
    hideSuggestions: function hideSuggestions() {
      this.showSearchSuggestions = false;
      this.showSearchSuggestionsMobile = false;
    },
    inputClick: function inputClick(event) {
      var _target$value;
      var target = event.target;
      if ((target === null || target === void 0 ? void 0 : (_target$value = target.value) === null || _target$value === void 0 ? void 0 : _target$value.length) < 1) {
        this.showSearchSuggestions = true;
      }
    },
    inputHandler: function inputHandler(event) {
      var inputType = event.inputType,
        target = event.target;
      if (target.value.length === 0) this.showSearchSuggestions = true;
    },
    suggestionResizeHandler: function suggestionResizeHandler() {
      if (!window.isMobile) {
        this.hideSuggestions();
      }
    },
    appendSuggestionCloneToMobileSearch: function appendSuggestionCloneToMobileSearch() {
      var detachedContainer = document.querySelector('.aa-DetachedContainer');
      if (!detachedContainer) {
        return;
      }
      var mobileSearchSuggestions = document.querySelector('.alglolia-search-suggestions-mobile');
      if (mobileSearchSuggestions) {
        return;
      }
      var searchSuggestions = this.$refs.searchSuggestions.innerHTML;
      detachedContainer.insertAdjacentHTML('beforeend', "\n      <div\n        class=\"alglolia-search-suggestions-mobile\"\n        x-data=\"{\n        showSearchSuggestions: true,\n        showSearchSuggestionsMobile: true,\n        searchSuggestionData: [".concat(this.searchSuggestions.map(function (suggestion) {
        return "'".concat(suggestion, "'");
      }), "],\n      }\"\n      @before-autocomplete-load.window=\"showSearchSuggestionsMobile = !(document.querySelector('.aa-DetachedContainer .aa-Input')?.value?.length)\"\n      @empty-mobile-search.window=\"showSearchSuggestionsMobile = true\"\n    >\n      <template x-if=\"showSearchSuggestionsMobile\">\n        <div class=\"relative bg-p-lionsMane p-4 capitalize shadow-lg lg:px-16 lg:py-8\" x-ref=\"searchSuggestions\">\n          <div class=\"m-auto w-full max-w-[1000px]\">\n            <div class=\"mb-4 font-sans font-bold md:text-base\">Popular Search Terms</div>\n            <ul id=\"topresults\" class=\"list-none\">\n              <template x-for=\"suggestion in searchSuggestionData\">\n                <li class=\"inline-block mr-4 mb-4\">\n                  <a :href=\"'/search?q=' + suggestion\" class=\"btn--small btn--solid btn btn--secondary capitalize tracking-normal\" x-text=\"suggestion\"></a>\n                </li>\n              </template>\n            </ul>\n          </div>\n        </div>\n      </template>\n    </div>"));

      // The detached input lives outside this Alpine scope, so its empty state is
      // not picked up by the header's inputHandler. Re-show the popular terms when
      // the user erases the query on mobile.
      var detachedInput = detachedContainer.querySelector('.aa-Input');
      if (detachedInput) {
        detachedInput.addEventListener('input', function (event) {
          if (event.target.value.length === 0) {
            triggerAutoCompleteHooksCustomEvent('empty-mobile-search');
          }
        });
      }

      // Algolia's detached overlay closes via a window-level "interact outside
      // the searchbox" handler that fires on bubbling pointer events. Anything in
      // the container that isn't the input or results panel (our injected terms
      // clone, the form container padding) is treated as an outside tap and closes
      // the overlay before a link can navigate. Stop pointer events from bubbling
      // to that handler for the whole container; the cancel button (a click
      // listener) and link navigation (the click default) stay intact.
      ['mousedown', 'touchstart'].forEach(function (type) {
        detachedContainer.addEventListener(type, function (event) {
          return event.stopPropagation();
        });
      });
    },
    sanitizeSearchTerm: function sanitizeSearchTerm(search) {
      return search.replace(/["'\\\n\r\t\b\f]/g, function (_char) {
        var escapeMap = {
          '"': '\\"',
          "'": "\\'",
          '\\': '\\\\',
          '\n': '\\n',
          '\r': '\\r',
          '\t': '\\t',
          '\b': '\\b',
          '\f': '\\f'
        };
        return escapeMap[_char] || _char;
      });
    },
    fetchTopSearches: function fetchTopSearches() {
      var _window$algoliaShopif5,
        _window$themeTopSearc,
        _window$themeTopSearc2,
        _this = this;
      var apiKey = '6603de15f2cc42b8d6b460ce0f473d86'; // Replace with your Algolia API Key
      var appId = 'J4W35K0ZQZ'; // Replace with your Algolia Application ID
      var _window$algoliaShopif4 = (_window$algoliaShopif5 = window.algoliaShopify) === null || _window$algoliaShopif5 === void 0 ? void 0 : _window$algoliaShopif5.config,
        index_prefix = _window$algoliaShopif4.index_prefix; // Replace with your index name
      var indexName = index_prefix ? "".concat(index_prefix, "products") : 'shopify_products'; // Replace with your index name
      var limit = ((_window$themeTopSearc = window.themeTopSearches) === null || _window$themeTopSearc === void 0 ? void 0 : _window$themeTopSearc.algoliaSearchesCount) || 10; // Number of results to return
      var customSearches = ((_window$themeTopSearc2 = window.themeTopSearches) === null || _window$themeTopSearc2 === void 0 ? void 0 : _window$themeTopSearc2.customSearches) || [];
      var sanitizedCustomSearches = customSearches.map(function (item) {
        return _this.sanitizeSearchTerm(item);
      });
      var url = "https://analytics.us.algolia.com/2/searches?index=".concat(indexName, "&limit=").concat(limit);
      (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var response, data, algoliaSearchSuggestions;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url, {
                method: 'GET',
                headers: {
                  'X-Algolia-API-Key': apiKey,
                  'X-Algolia-Application-Id': appId
                }
              });
            case 3:
              response = _context.sent;
              if (response.ok) {
                _context.next = 6;
                break;
              }
              throw new Error("Error: ".concat(response.status, " ").concat(response.statusText));
            case 6:
              _context.next = 8;
              return response.json();
            case 8:
              data = _context.sent;
              algoliaSearchSuggestions = (0,toConsumableArray/* default */.Z)(data.searches).filter(function (_ref5) {
                var search = _ref5.search;
                return search.trim() !== '';
              }).sort(function (a, b) {
                return b.count - a.count;
              }).map(function (_ref6) {
                var search = _ref6.search;
                return _this.sanitizeSearchTerm(search);
              });
              _this.searchSuggestions = [].concat((0,toConsumableArray/* default */.Z)(sanitizedCustomSearches), (0,toConsumableArray/* default */.Z)(algoliaSearchSuggestions));
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error('Failed to fetch top searches:', _context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }))();
    }
  };
};
// EXTERNAL MODULE: ./src/js/utils/products-and-collections.js
var products_and_collections = __webpack_require__(5072);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/kyh-search.js



/**
 * Know Your Herbs search: product suggestions via Algolia (same index as the
 * header autocomplete app) when available, otherwise Storefront API search
 * (same as the global search drawer in global-search.liquid).
 */

var MIN_QUERY = 2;
var DEBOUNCE_MS = 280;
var HITS_LIMIT = 10;
/** Closed state: pill-shaped field (px). */
var KYH_CARD_PILL_RADIUS = 9999;
function getKyhTopCornerPx() {
  return window.matchMedia('(min-width: 768px)').matches ? 15 : 20;
}
function applyKyhChromeClosed(cardEl, inputEl, shellEl) {
  var p = "".concat(KYH_CARD_PILL_RADIUS, "px");
  var pill = {
    borderTopLeftRadius: p,
    borderTopRightRadius: p,
    borderBottomLeftRadius: p,
    borderBottomRightRadius: p
  };
  if (cardEl) Object.assign(cardEl.style, pill);
  if (inputEl) Object.assign(inputEl.style, pill);
  if (shellEl) {
    ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius'].forEach(function (key) {
      shellEl.style.removeProperty(key);
    });
  }
}

/**
 * Open state: flush seam only — flat bottom on the field, flat top on the list;
 * rounded tops on the field and rounded bottoms on the list (20px mobile / 15px md).
 */
function applyKyhChromeOpen(cardEl, inputEl, shellEl) {
  var top = "".concat(getKyhTopCornerPx(), "px");
  var seam = '0px';
  var cardRadii = {
    borderTopLeftRadius: top,
    borderTopRightRadius: top,
    borderBottomLeftRadius: seam,
    borderBottomRightRadius: seam
  };
  var shellRadii = {
    borderTopLeftRadius: seam,
    borderTopRightRadius: seam,
    borderBottomLeftRadius: top,
    borderBottomRightRadius: top
  };
  if (cardEl) Object.assign(cardEl.style, cardRadii);
  if (inputEl) Object.assign(inputEl.style, cardRadii);
  if (shellEl) Object.assign(shellEl.style, shellRadii);
}
function createKyhChromeController(cardEl, inputEl, shellEl, wrapEl) {
  var expanded = false;
  var refreshForBreakpoint = function refreshForBreakpoint() {
    if (expanded) applyKyhChromeOpen(cardEl, inputEl, shellEl);else applyKyhChromeClosed(cardEl, inputEl, shellEl);
  };
  var mq = window.matchMedia('(min-width: 768px)');
  mq.addEventListener('change', refreshForBreakpoint);
  applyKyhChromeClosed(cardEl, inputEl, shellEl);
  function setExpandedAttr(isExpanded) {
    if (cardEl) cardEl.setAttribute('data-kyh-expanded', isExpanded ? 'true' : 'false');
    if (wrapEl) wrapEl.classList.toggle('kyh-search-dropdown-open', isExpanded);
  }
  function setDropdownOpen(next) {
    expanded = next;
    if (next) {
      setExpandedAttr(true);
      applyKyhChromeOpen(cardEl, inputEl, shellEl);
    } else {
      setExpandedAttr(false);
      applyKyhChromeClosed(cardEl, inputEl, shellEl);
    }
  }
  return {
    setDropdownOpen: setDropdownOpen,
    destroy: function destroy() {
      mq.removeEventListener('change', refreshForBreakpoint);
    }
  };
}

/** Alternate product template for Know Your Herbs results (matches `product.know-your-herbs-results.json`). */
var KYH_PRODUCT_VIEW = 'know-your-herbs-results';
var KYH_SHRINK_MS = 720;
function prefersReducedMotion() {
  var _window$matchMedia, _window, _window$matchMedia$ca;
  return ((_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 ? void 0 : (_window$matchMedia$ca = _window$matchMedia.call(_window, '(prefers-reduced-motion: reduce)')) === null || _window$matchMedia$ca === void 0 ? void 0 : _window$matchMedia$ca.matches) === true;
}
function isKyhResultsProductLink(href) {
  if (!href || href === '#') return false;
  try {
    var u = new URL(href, window.location.origin);
    if (u.origin !== window.location.origin) return false;
    if (!u.pathname.includes('/products/')) return false;
    return u.searchParams.get('view') === KYH_PRODUCT_VIEW;
  } catch (_unused) {
    return false;
  }
}
function runExitShrinkThenNavigate(root, navigate) {
  if (prefersReducedMotion()) {
    navigate();
    return;
  }
  window.requestAnimationFrame(function () {
    root.classList.add('kyh-search--compact');
  });
  window.setTimeout(navigate, KYH_SHRINK_MS);
}
function productUrlWithKyhView(url) {
  if (!url || url === '#') return url;
  try {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('view', KYH_PRODUCT_VIEW);
    if (String(url).startsWith('/')) {
      return "".concat(u.pathname).concat(u.search).concat(u.hash);
    }
    return u.href;
  } catch (_unused2) {
    var sep = String(url).includes('?') ? '&' : '?';
    return "".concat(url).concat(sep, "view=").concat(encodeURIComponent(KYH_PRODUCT_VIEW));
  }
}
function dispatchKyhA11y(root, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  root.dispatchEvent(new CustomEvent("kyh-suggest-".concat(name), {
    bubbles: true,
    detail: detail
  }));
}
function escapeHtml(str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function highlightTitle(text, query) {
  var q = (query || '').trim();
  if (!q || !text) return escapeHtml(text);
  var lower = text.toLowerCase();
  var idx = lower.indexOf(q.toLowerCase());
  if (idx === -1) return escapeHtml(text);
  return escapeHtml(text.slice(0, idx)) + '<strong class="font-semibold">' + escapeHtml(text.slice(idx, idx + q.length)) + '</strong>' + escapeHtml(text.slice(idx + q.length));
}
function applyHighlights(container, query) {
  container.querySelectorAll('.kyh-search-suggest__title').forEach(function (el) {
    var raw = el.textContent || '';
    el.innerHTML = highlightTitle(raw, query);
  });
}
var algoliaSearchScriptPromise = null;
function loadAlgoliaSearchScript() {
  if (window.algoliasearch) return Promise.resolve();
  if (algoliaSearchScriptPromise) return algoliaSearchScriptPromise;
  algoliaSearchScriptPromise = new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/algoliasearch@4.24.0/dist/algoliasearch-lite.umd.js';
    s.integrity = 'sha256-b2n6oSgG4C1stMT/yc/ChGszs9EY/Mhs6oltEjQbFCQ=';
    s.crossOrigin = 'anonymous';
    s.onload = function () {
      return resolve();
    };
    s.onerror = function () {
      return reject(new Error('algoliasearch load failed'));
    };
    document.head.appendChild(s);
  });
  return algoliaSearchScriptPromise;
}
function getAlgoliaSearchFactory() {
  var f = window.algoliasearch;
  if (typeof f === 'function') return f;
  if (f && typeof f["default"] === 'function') return f["default"];
  return null;
}
function searchKyhProducts(_x) {
  return _searchKyhProducts.apply(this, arguments);
}
/** Algolia product hits omit trustscore metafields; load them from Storefront for badge rendering. */
function _searchKyhProducts() {
  _searchKyhProducts = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(query) {
    var _window$algoliaShopif2, _data$products;
    var cfg, factory, appId, apiKey, _window$algoliaShopif3, _window$algoliaShopif4, _window$algoliaShopif5, _results$, client, indexPrefix, indexName, distinct, _yield$client$search, results, hits, data, products;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return loadAlgoliaSearchScript()["catch"](function () {});
        case 2:
          cfg = (_window$algoliaShopif2 = window.algoliaShopify) === null || _window$algoliaShopif2 === void 0 ? void 0 : _window$algoliaShopif2.config;
          factory = getAlgoliaSearchFactory(); // Algolia Shopify app embed uses snake_case (`app_id`, `search_api_key`); other keys are camelCase.
          appId = (cfg === null || cfg === void 0 ? void 0 : cfg.applicationId) || (cfg === null || cfg === void 0 ? void 0 : cfg.appId) || (cfg === null || cfg === void 0 ? void 0 : cfg.app_id);
          apiKey = (cfg === null || cfg === void 0 ? void 0 : cfg.searchOnlyApiKey) || (cfg === null || cfg === void 0 ? void 0 : cfg.searchApiKey) || (cfg === null || cfg === void 0 ? void 0 : cfg.apiKey) || (cfg === null || cfg === void 0 ? void 0 : cfg.search_api_key);
          if (!(factory && appId && apiKey)) {
            _context2.next = 23;
            break;
          }
          _context2.prev = 7;
          client = factory(appId, apiKey);
          indexPrefix = cfg.index_prefix || cfg.indexPrefix || '';
          indexName = indexPrefix ? "".concat(indexPrefix, "products") : 'shopify_products'; // Match header autocomplete: one hit per product, not per variant (Algolia stores variants as records).
          distinct = (_window$algoliaShopif3 = (_window$algoliaShopif4 = window.algoliaShopify) === null || _window$algoliaShopif4 === void 0 ? void 0 : (_window$algoliaShopif5 = _window$algoliaShopif4.instantsearch) === null || _window$algoliaShopif5 === void 0 ? void 0 : _window$algoliaShopif5.distinct) !== null && _window$algoliaShopif3 !== void 0 ? _window$algoliaShopif3 : true;
          _context2.next = 14;
          return client.search([{
            indexName: indexName,
            params: {
              query: query,
              hitsPerPage: HITS_LIMIT,
              clickAnalytics: false,
              distinct: distinct ? 1 : 0
            }
          }]);
        case 14:
          _yield$client$search = _context2.sent;
          results = _yield$client$search.results;
          hits = ((_results$ = results[0]) === null || _results$ === void 0 ? void 0 : _results$.hits) || [];
          if (!hits.length) {
            _context2.next = 19;
            break;
          }
          return _context2.abrupt("return", {
            source: 'algolia',
            hits: hits
          });
        case 19:
          _context2.next = 23;
          break;
        case 21:
          _context2.prev = 21;
          _context2.t0 = _context2["catch"](7);
        case 23:
          _context2.next = 25;
          return (0,products_and_collections/* fetchSearch */.on)(query, null, HITS_LIMIT);
        case 25:
          data = _context2.sent;
          products = (data === null || data === void 0 ? void 0 : (_data$products = data.products) === null || _data$products === void 0 ? void 0 : _data$products.nodes) || [];
          return _context2.abrupt("return", {
            source: 'storefront',
            products: products
          });
        case 28:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 21]]);
  }));
  return _searchKyhProducts.apply(this, arguments);
}
function fetchTrustByProductId(_x2) {
  return _fetchTrustByProductId.apply(this, arguments);
}
/**
 * SuppCo widget validates `anchor.href ===` canonical `https://supp.co/products/...`
 * (see widget.iife.js). Normalize metafield / Algolia URLs so initialization is not skipped.
 */
function _fetchTrustByProductId() {
  _fetchTrustByProductId = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(productIds) {
    var ids, cache, trustById;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          ids = (0,toConsumableArray/* default */.Z)(new Set(productIds.filter(Boolean)));
          if (ids.length) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", new Map());
        case 3:
          _context3.prev = 3;
          _context3.next = 6;
          return (0,products_and_collections/* fetchProducts */.t2)(ids);
        case 6:
          cache = _context3.sent;
          trustById = new Map();
          ids.forEach(function (id) {
            var _product$variants2, _v$trustscore2, _product$trustscore_r2, _v$trustscore_rating2;
            var product = cache[id] || cache["gid://shopify/Product/".concat(id)];
            if (!product) return;
            var v = (_product$variants2 = product.variants) === null || _product$variants2 === void 0 ? void 0 : _product$variants2[0];
            trustById.set(id, {
              trustUrl: v === null || v === void 0 ? void 0 : (_v$trustscore2 = v.trustscore) === null || _v$trustscore2 === void 0 ? void 0 : _v$trustscore2.value,
              trustRating: ((_product$trustscore_r2 = product.trustscore_rating) === null || _product$trustscore_r2 === void 0 ? void 0 : _product$trustscore_r2.value) || (v === null || v === void 0 ? void 0 : (_v$trustscore_rating2 = v.trustscore_rating) === null || _v$trustscore_rating2 === void 0 ? void 0 : _v$trustscore_rating2.value)
            });
          });
          return _context3.abrupt("return", trustById);
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](3);
          return _context3.abrupt("return", new Map());
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 12]]);
  }));
  return _fetchTrustByProductId.apply(this, arguments);
}
function normalizeSuppCoTrustUrl(raw) {
  if (raw == null) return '';
  var s = String(raw).trim();
  if (!s) return '';
  try {
    var u = new URL(s, 'https://supp.co');
    var host = u.hostname.toLowerCase().replace(/^www\./, '');
    if (host !== 'supp.co') return '';
    var path = (u.pathname || '/').replace(/\/+$/, '') || '/';
    var upcMatch = path.match(/^\/products\/upc\/(\d{8,14})$/);
    if (upcMatch) return "https://supp.co/products/upc/".concat(upcMatch[1]);
    var slugMatch = path.match(/^\/products\/([a-zA-Z0-9-]+)$/);
    if (slugMatch && slugMatch[1].length >= 2 && /^[a-zA-Z0-9-]+$/.test(slugMatch[1])) {
      return "https://supp.co/products/".concat(slugMatch[1]);
    }
    return '';
  } catch (_unused3) {
    return '';
  }
}
function rescanSuppCoTrustWidgets() {
  try {
    var _window$SuppCoWidget;
    if (typeof ((_window$SuppCoWidget = window.SuppCoWidget) === null || _window$SuppCoWidget === void 0 ? void 0 : _window$SuppCoWidget.init) === 'function') window.SuppCoWidget.init();
  } catch (_unused4) {
    /* ignore */
  }
}
function trustBadgeShellAttrs(trustUrl) {
  return "href=\"".concat(escapeHtml(trustUrl), "\" class=\"kyh-trust-badge inline-flex shrink-0 items-center gap-1 rounded-md border border-[#9E9E9E] bg-white px-2 py-1 text-xs font-sans no-underline transition-opacity hover:opacity-85 md:gap-1.5 md:rounded-lg md:px-3 md:py-[7px] md:text-base\" target=\"_blank\" rel=\"noopener noreferrer\"");
}
function trustBadgeHtml(enableTrust, trustUrlRaw, trustRating) {
  if (!enableTrust) return '';
  var trustUrl = normalizeSuppCoTrustUrl(trustUrlRaw);
  if (!trustUrl) return '';
  var staticRating = trustRating != null && String(trustRating).trim() !== '' ? String(trustRating).trim() : '';
  var label = "<span class=\"shrink-0 whitespace-nowrap font-sans text-[9px] font-normal leading-none text-[#757575] md:text-[11px]\">TrustScore<sup class=\"kyh-trust-badge__tm\">\u2122</sup></span>";
  var dot = '<span class="h-1.5 w-1.5 shrink-0 rounded-full bg-[#28A745] md:h-2 md:w-2" aria-hidden="true"></span>';
  if (staticRating) {
    var rating = "<span class=\"shrink-0 text-xs font-bold tabular-nums tracking-tight text-[#1a1f1c] md:text-sm\">".concat(escapeHtml(staticRating), "</span>");
    return "<a ".concat(trustBadgeShellAttrs(trustUrl), ">").concat(dot).concat(rating).concat(label, "</a>");
  }
  var pendingRating = '<span class="kyh-trust-badge__rating kyh-trust-badge__rating--pending shrink-0 min-w-[2.5ch] text-center text-xs font-bold tabular-nums tracking-tight text-[#1a1f1c] md:min-w-[2.75ch] md:text-sm" data-kyh-trust-hydrate="1"></span>';
  /** `trust-score-badge` mounts the compact SuppCo shadow (`.supp-badge-number`); avoid `rel` — only `noopener`/`external` are allowed on SuppCo anchors. */
  var hydrate = "<span class=\"kyh-trust-badge__hydrate\" aria-hidden=\"true\"><a href=\"".concat(escapeHtml(trustUrl), "\" class=\"trust-score-badge\">TrustScore</a></span>");
  return "<span class=\"kyh-trust-badge-outer relative inline-flex shrink-0 items-center\">".concat(hydrate, "<a ").concat(trustBadgeShellAttrs(trustUrl), ">").concat(dot).concat(pendingRating).concat(label, "</a></span>");
}
function getTrustWidgetShadowRoot(anchor) {
  var _anchor$getElementsBy, _anchor$getElementsBy2, _innerDiv$shadowRoot;
  var innerDiv = anchor === null || anchor === void 0 ? void 0 : (_anchor$getElementsBy = anchor.getElementsByTagName) === null || _anchor$getElementsBy === void 0 ? void 0 : (_anchor$getElementsBy2 = _anchor$getElementsBy.call(anchor, 'div')) === null || _anchor$getElementsBy2 === void 0 ? void 0 : _anchor$getElementsBy2[0];
  return (_innerDiv$shadowRoot = innerDiv === null || innerDiv === void 0 ? void 0 : innerDiv.shadowRoot) !== null && _innerDiv$shadowRoot !== void 0 ? _innerDiv$shadowRoot : null;
}
function readTrustScoreFromWidgetShadow(shadow) {
  if (!shadow) return '';
  var trustInfoNum = shadow.querySelector('.supp-trust-info-score-number');
  if (trustInfoNum !== null && trustInfoNum !== void 0 && trustInfoNum.textContent) {
    var m = trustInfoNum.textContent.match(/\d+(?:\.\d+)?/);
    if (m) return m[0];
  }
  var badgeNum = shadow.querySelector('.supp-badge-number');
  if (badgeNum !== null && badgeNum !== void 0 && badgeNum.textContent) {
    var _m = badgeNum.textContent.match(/\d+(?:\.\d+)?/);
    if (_m) return _m[0];
  }
  var cardScore = shadow.querySelector('.supp-product-card-score');
  if (cardScore !== null && cardScore !== void 0 && cardScore.textContent) {
    var _m2 = cardScore.textContent.match(/\d+(?:\.\d+)?/);
    if (_m2) return _m2[0];
  }
  var scoreLabel = shadow.querySelector('.supp-trust-info-score-label');
  if (scoreLabel !== null && scoreLabel !== void 0 && scoreLabel.textContent) {
    var _m3 = scoreLabel.textContent.match(/\d+(?:\.\d+)?/);
    if (_m3) return _m3[0];
  }
  return '';
}

/**
 * When `trustscore_rating` is empty: hidden `trust-score-badge` is upgraded by
 * `https://supp.co/widgets/v0/widget.iife.js`; we copy the score from shadow DOM.
 * Call `rescanSuppCoTrustWidgets()` after injecting HTML so `SuppCoWidget.init()` runs.
 */
function initKyhAutocompleteTrustHydration(container) {
  var pendingSpans = container.querySelectorAll('[data-kyh-trust-hydrate]');
  if (!pendingSpans.length) return function () {};
  var pending = [];
  pendingSpans.forEach(function (span) {
    var _outer$querySelector;
    var outer = span.closest('.kyh-trust-badge-outer');
    var hydrateAnchor = outer === null || outer === void 0 ? void 0 : (_outer$querySelector = outer.querySelector) === null || _outer$querySelector === void 0 ? void 0 : _outer$querySelector.call(outer, '.kyh-trust-badge__hydrate a.trust-score-badge');
    if (hydrateAnchor) pending.push({
      span: span,
      hydrateAnchor: hydrateAnchor
    });
  });
  if (!pending.length) return function () {};
  var disconnected = false;
  var timer;
  var HYDRATE_MS = 7000;
  var tryOne = function tryOne(_ref) {
    var span = _ref.span,
      hydrateAnchor = _ref.hydrateAnchor;
    if (!span.classList.contains('kyh-trust-badge__rating--pending')) return true;
    var shadow = getTrustWidgetShadowRoot(hydrateAnchor);
    var score = readTrustScoreFromWidgetShadow(shadow);
    if (!score) return false;
    span.textContent = score;
    span.classList.remove('kyh-trust-badge__rating--pending');
    return true;
  };
  var sweep = function sweep() {
    for (var i = pending.length - 1; i >= 0; i--) {
      if (tryOne(pending[i])) pending.splice(i, 1);
    }
    if (!pending.length) cleanup();
  };
  var obs;
  var cleanup = function cleanup() {
    var _obs;
    if (disconnected) return;
    disconnected = true;
    clearTimeout(timer);
    (_obs = obs) === null || _obs === void 0 ? void 0 : _obs.disconnect();
  };
  obs = new MutationObserver(sweep);
  /** `childList` only: SuppCo injects a host under the anchor; shadow internals do not bubble here. Avoids extra sweeps from attribute/text churn elsewhere in the panel. */
  obs.observe(container, {
    subtree: true,
    childList: true
  });
  sweep();
  timer = window.setTimeout(function () {
    pending.forEach(function (_ref2) {
      var span = _ref2.span;
      if (!span.classList.contains('kyh-trust-badge__rating--pending')) return;
      span.classList.remove('kyh-trust-badge__rating--pending');
      span.classList.add('kyh-trust-badge__rating--empty');
    });
    cleanup();
  }, HYDRATE_MS);
  return cleanup;
}
function renderKyhSearchResultRow(_ref3) {
  var url = _ref3.url,
    thumb = _ref3.thumb,
    title = _ref3.title,
    enableTrust = _ref3.enableTrust,
    trustUrl = _ref3.trustUrl,
    trustRating = _ref3.trustRating,
    sectionId = _ref3.sectionId,
    index = _ref3.index;
  var sid = escapeHtml(String(sectionId));
  var idx = Number(index);
  var badge = trustBadgeHtml(enableTrust, trustUrl, trustRating);
  return "<li id=\"kyh-search-option-".concat(sid, "-").concat(idx, "\" class=\"m-0 first:border-t-0\" data-kyh-search-option role=\"option\" aria-selected=\"false\"><div class=\"flex items-start gap-3 px-5 py-4 transition-colors hover:bg-[#F7F7F7] lg:items-center md:px-6 md:py-4\"><a href=\"").concat(escapeHtml(url), "\" class=\"relative h-14 w-14 shrink-0 overflow-hidden rounded-md bg-[#F0F0F0] no-underline md:h-16 md:w-16\">").concat(thumb, "</a><div class=\"flex min-w-0 flex-1 flex-col-reverse items-start gap-1.5 lg:flex-row lg:items-center lg:justify-between\"><a href=\"").concat(escapeHtml(url), "\" class=\"min-w-0 text-left font-sans text-base font-medium leading-snug text-[#2F3E33] no-underline md:text-[17px]\"><span class=\"kyh-search-suggest__title block break-words line-clamp-2 lg:line-clamp-none lg:truncate\">").concat(escapeHtml(title), "</span></a>").concat(badge, "</div></div></li>");
}
function renderAlgoliaHitRow(hit, enableTrust, sectionId, index, trustByProductId) {
  var _window$algoliaShopif, _hit$meta, _ref4, _ref5, _enriched$trustUrl, _ref6, _enriched$trustRating;
  var helpers = (_window$algoliaShopif = window.algoliaShopify) === null || _window$algoliaShopif === void 0 ? void 0 : _window$algoliaShopif.helpers;
  var rawUrl = helpers ? helpers.instantsearchLink(hit) : hit.url || (hit.handle ? "/products/".concat(hit.handle) : '#');
  var url = productUrlWithKyhView(rawUrl);
  var imageUrl = helpers ? helpers.largeImage(hit) : hit.image || hit.product_image || '';
  var title = hit.title || '';
  var meta = ((_hit$meta = hit.meta) === null || _hit$meta === void 0 ? void 0 : _hit$meta.custom) || {};
  var enriched = trustByProductId === null || trustByProductId === void 0 ? void 0 : trustByProductId.get(hit.id);
  var trustUrl = (_ref4 = (_ref5 = (_enriched$trustUrl = enriched === null || enriched === void 0 ? void 0 : enriched.trustUrl) !== null && _enriched$trustUrl !== void 0 ? _enriched$trustUrl : meta.trustscore) !== null && _ref5 !== void 0 ? _ref5 : meta.trustscore_url) !== null && _ref4 !== void 0 ? _ref4 : hit.trustscore_url;
  var trustRating = (_ref6 = (_enriched$trustRating = enriched === null || enriched === void 0 ? void 0 : enriched.trustRating) !== null && _enriched$trustRating !== void 0 ? _enriched$trustRating : meta.trustscore_rating) !== null && _ref6 !== void 0 ? _ref6 : hit.trustscore_rating;
  var thumb = imageUrl ? "<img src=\"".concat(escapeHtml(imageUrl), "\" class=\"h-full w-full object-cover\" loading=\"lazy\" alt=\"").concat(escapeHtml(title), "\">") : '';
  return renderKyhSearchResultRow({
    url: url,
    thumb: thumb,
    title: title,
    enableTrust: enableTrust,
    trustUrl: trustUrl,
    trustRating: trustRating,
    sectionId: sectionId,
    index: index
  });
}
function renderStorefrontProductRow(product, enableTrust, sectionId, index) {
  var _product$variants, _product$images, _v$trustscore, _product$trustscore_r, _v$trustscore_rating;
  var v = (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants[0];
  var rawUrl = product.onlineStoreUrl || "/products/".concat(product.handle);
  var url = productUrlWithKyhView(rawUrl);
  var img = (_product$images = product.images) === null || _product$images === void 0 ? void 0 : _product$images[0];
  var imageUrl = (img === null || img === void 0 ? void 0 : img.url) || '';
  var title = product.title || '';
  var trustUrl = v === null || v === void 0 ? void 0 : (_v$trustscore = v.trustscore) === null || _v$trustscore === void 0 ? void 0 : _v$trustscore.value;
  var trustRating = ((_product$trustscore_r = product.trustscore_rating) === null || _product$trustscore_r === void 0 ? void 0 : _product$trustscore_r.value) || (v === null || v === void 0 ? void 0 : (_v$trustscore_rating = v.trustscore_rating) === null || _v$trustscore_rating === void 0 ? void 0 : _v$trustscore_rating.value);
  var thumb = imageUrl ? "<img src=\"".concat(escapeHtml(imageUrl), "\" class=\"h-full w-full object-cover\" loading=\"lazy\" alt=\"").concat(escapeHtml((img === null || img === void 0 ? void 0 : img.altText) || title), "\">") : '';
  return renderKyhSearchResultRow({
    url: url,
    thumb: thumb,
    title: title,
    enableTrust: enableTrust,
    trustUrl: trustUrl,
    trustRating: trustRating,
    sectionId: sectionId,
    index: index
  });
}
function renderSuggestHtml(result, enableTrust, sectionId, trustByProductId) {
  if (result.source === 'algolia') {
    var _rows = result.hits.map(function (h, i) {
      return renderAlgoliaHitRow(h, enableTrust, sectionId, i, trustByProductId);
    }).join('');
    return "<div class=\"kyh-search-suggest\" data-count=\"".concat(result.hits.length, "\"><ul id=\"kyh-search-listbox-").concat(escapeHtml(String(sectionId)), "\" class=\"m-0 list-none p-0\" role=\"listbox\" aria-label=\"Product suggestions\">").concat(_rows, "</ul></div>");
  }
  var products = result.products || [];
  var rows = products.map(function (p, i) {
    return renderStorefrontProductRow(p, enableTrust, sectionId, i);
  }).join('');
  return "<div class=\"kyh-search-suggest\" data-count=\"".concat(products.length, "\"><ul id=\"kyh-search-listbox-").concat(escapeHtml(String(sectionId)), "\" class=\"m-0 list-none p-0\" role=\"listbox\" aria-label=\"Product suggestions\">").concat(rows, "</ul></div>");
}
function bindKnowYourHerbsSearch(root) {
  var _cardEl$closest;
  var noResultsTemplate = root.getAttribute('data-no-results') || '';
  var enableTrust = root.getAttribute('data-enable-trustscore') === 'true';
  var input = root.querySelector('[id^="kyh-search-input-"]');
  var resultsShell = root.querySelector('[id^="kyh-search-results-"]');
  var resultsEl = resultsShell === null || resultsShell === void 0 ? void 0 : resultsShell.querySelector('[data-kyh-results-scroll]');
  var helperEl = root.querySelector('[id^="kyh-search-helper-"]');
  var emptyEl = root.querySelector('[id^="kyh-search-empty-"]');
  var cardEl = root.querySelector('[id^="kyh-search-card-"]');
  var wrapEl = cardEl === null || cardEl === void 0 ? void 0 : (_cardEl$closest = cardEl.closest) === null || _cardEl$closest === void 0 ? void 0 : _cardEl$closest.call(cardEl, '[data-kyh-search-chrome]');
  /** Clicks outside this node (field + dropdown) close the panel; the section root is full-bleed hero so background taps must not count as “inside”. */
  var outsideClickBoundary = wrapEl !== null && wrapEl !== void 0 ? wrapEl : root.querySelector('[data-kyh-search-chrome]');
  if (!input || !resultsShell || !resultsEl || !emptyEl) return;
  var sectionId = root.getAttribute('data-section-id') || '';
  var kyhChrome = createKyhChromeController(cardEl, input, resultsShell, wrapEl);
  var abortId = 0;
  var debounceTimer = null;
  var trustHydrateCleanup = null;
  /** After Escape from a suggestion link we refocus the input; skip one `openShell()` so flat-bottom “open” chrome is not reapplied while the list is closed. */
  var suppressFocusOpenOnce = false;
  function stopTrustHydration() {
    var _trustHydrateCleanup;
    (_trustHydrateCleanup = trustHydrateCleanup) === null || _trustHydrateCleanup === void 0 ? void 0 : _trustHydrateCleanup();
    trustHydrateCleanup = null;
  }
  root.addEventListener('kyh-search-request-close', function () {
    closeResults();
  });
  root.addEventListener('kyh-search-activate-option', function (e) {
    var _e$detail, _li$querySelector;
    var idx = (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.index;
    if (typeof idx !== 'number' || idx < 0) return;
    if (resultsShell.classList.contains('hidden')) return;
    var li = resultsEl.querySelector("#kyh-search-option-".concat(sectionId, "-").concat(idx));
    var a = li === null || li === void 0 ? void 0 : (_li$querySelector = li.querySelector) === null || _li$querySelector === void 0 ? void 0 : _li$querySelector.call(li, 'a[href*="/products/"]');
    if (!(a !== null && a !== void 0 && a.href)) return;
    if (root.getAttribute('data-kyh-context') === 'landing' && !isKyhResultsProductLink(a.href)) return;
    a.click();
  });
  root.addEventListener('kyh-search-activate-first', function () {
    if (resultsShell.classList.contains('hidden')) return;
    var first = resultsEl.querySelector('a[href*="/products/"]');
    if (!(first !== null && first !== void 0 && first.href)) return;
    if (root.getAttribute('data-kyh-context') === 'landing' && !isKyhResultsProductLink(first.href)) return;
    first.click();
  });
  root.querySelectorAll('video.kyh-search-video').forEach(function (video) {
    video.addEventListener('ended', function () {
      try {
        video.pause();
        if (video.duration && !isNaN(video.duration)) {
          video.currentTime = Math.max(0, video.duration - 0.05);
        }
      } catch (_unused5) {
        /* ignore */
      }
    });
  });
  function setDropdownShellOpen(open) {
    kyhChrome.setDropdownOpen(open);
  }
  var kyhContext = root.getAttribute('data-kyh-context');
  function closeResults() {
    stopTrustHydration();
    resultsEl.innerHTML = '';
    resultsShell.classList.add('hidden');
    emptyEl.classList.add('hidden');
    emptyEl.textContent = '';
    /** Hide panel before restoring pill radii so we never show full pill under an open list. */
    setDropdownShellOpen(false);
    if (kyhContext === 'results') root.classList.remove('kyh-search--results-expanded');
    if (helperEl && helperEl.textContent.trim()) helperEl.classList.remove('hidden');
    dispatchKyhA11y(root, 'close');
  }
  function openShell() {
    if (helperEl) helperEl.classList.add('hidden');
    dispatchKyhA11y(root, 'open');
    /** Seam geometry first (square joint), then reveal — avoids stacked “pills” on first paint. */
    setDropdownShellOpen(true);
    resultsShell.classList.remove('hidden');
    if (kyhContext === 'results') root.classList.add('kyh-search--results-expanded');
  }

  /** Product results template prefills the title; skip suggestions until the user edits the query. */
  var initialQueryAttr = root.getAttribute('data-initial-query');
  var initialQueryNormalized = initialQueryAttr != null && initialQueryAttr !== '' ? initialQueryAttr.trim() : null;
  function isInitialPrefillQueryActive() {
    return initialQueryNormalized != null && input.value.trim() === initialQueryNormalized;
  }
  function runSearch(_x3) {
    return _runSearch.apply(this, arguments);
  }
  function _runSearch() {
    _runSearch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(q) {
      var trimmed, myId, result, count, trustByProductId;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            trimmed = q.trim();
            if (!isInitialPrefillQueryActive()) {
              _context.next = 4;
              break;
            }
            closeResults();
            return _context.abrupt("return");
          case 4:
            if (!(trimmed.length < MIN_QUERY)) {
              _context.next = 7;
              break;
            }
            closeResults();
            return _context.abrupt("return");
          case 7:
            myId = ++abortId;
            openShell();
            emptyEl.classList.add('hidden');
            stopTrustHydration();
            resultsEl.innerHTML = '<div class="px-6 py-8 text-center font-sans text-sm text-[#5C5C5C]">…</div>';
            dispatchKyhA11y(root, 'loading');
            if (!(myId !== abortId)) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            _context.prev = 15;
            _context.next = 18;
            return searchKyhProducts(trimmed);
          case 18:
            result = _context.sent;
            if (!(myId !== abortId)) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return");
          case 21:
            count = result.source === 'algolia' ? result.hits.length : (result.products || []).length;
            if (count) {
              _context.next = 28;
              break;
            }
            stopTrustHydration();
            resultsEl.innerHTML = "<div class=\"kyh-search-no-results px-6 py-8 text-center font-sans text-[#5C5C5C]\">".concat(escapeHtml(noResultsTemplate), "</div>");
            emptyEl.classList.add('hidden');
            dispatchKyhA11y(root, 'empty', {
              message: noResultsTemplate
            });
            return _context.abrupt("return");
          case 28:
            if (!(result.source === 'algolia' && enableTrust)) {
              _context.next = 34;
              break;
            }
            _context.next = 31;
            return fetchTrustByProductId(result.hits.map(function (h) {
              return h.id;
            }));
          case 31:
            trustByProductId = _context.sent;
            if (!(myId !== abortId)) {
              _context.next = 34;
              break;
            }
            return _context.abrupt("return");
          case 34:
            resultsEl.innerHTML = renderSuggestHtml(result, enableTrust, sectionId, trustByProductId);
            applyHighlights(resultsEl, trimmed);
            dispatchKyhA11y(root, 'rendered', {
              count: count
            });
            stopTrustHydration();
            rescanSuppCoTrustWidgets();
            trustHydrateCleanup = initKyhAutocompleteTrustHydration(resultsEl);
            _context.next = 50;
            break;
          case 42:
            _context.prev = 42;
            _context.t0 = _context["catch"](15);
            if (!(myId !== abortId)) {
              _context.next = 46;
              break;
            }
            return _context.abrupt("return");
          case 46:
            stopTrustHydration();
            resultsEl.innerHTML = "<div class=\"kyh-search-no-results px-6 py-8 text-center font-sans text-[#5C5C5C]\">".concat(escapeHtml(noResultsTemplate), "</div>");
            emptyEl.classList.add('hidden');
            dispatchKyhA11y(root, 'empty', {
              message: noResultsTemplate
            });
          case 50:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[15, 42]]);
    }));
    return _runSearch.apply(this, arguments);
  }
  function scheduleSearch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      runSearch(input.value);
    }, DEBOUNCE_MS);
  }
  input.addEventListener('input', scheduleSearch);
  if (kyhContext === 'landing') {
    root.addEventListener('click', function (e) {
      var _e$target$closest, _e$target;
      var a = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, 'a');
      if (!a || !resultsEl.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.button !== 0) return;
      if (a.target === '_blank') return;
      var href = a.getAttribute('href');
      if (!href || !isKyhResultsProductLink(href)) return;
      e.preventDefault();
      e.stopPropagation();
      closeResults();
      runExitShrinkThenNavigate(root, function () {
        window.location.assign(a.href);
      });
    });
  }
  input.addEventListener('focus', function () {
    if (suppressFocusOpenOnce) {
      suppressFocusOpenOnce = false;
      return;
    }
    if (isInitialPrefillQueryActive()) return;
    if (input.value.trim().length >= MIN_QUERY) openShell();
  });
  document.addEventListener('click', function (e) {
    var inside = outsideClickBoundary ? outsideClickBoundary.contains(e.target) : root.contains(e.target);
    if (!inside) closeResults();
  });

  /** Escape closes the panel when focus is on a suggestion link (not only on the combobox input). */
  resultsShell.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (resultsShell.classList.contains('hidden')) return;
    e.preventDefault();
    e.stopPropagation();
    suppressFocusOpenOnce = true;
    closeResults();
    input.focus();
  });
  if (initialQueryAttr != null && initialQueryAttr !== '') {
    input.value = initialQueryAttr;
  }
}
function initKyhSearch() {
  var roots = document.querySelectorAll('.know-your-herbs-search[data-section-id]');
  if (!roots.length) return;
  loadAlgoliaSearchScript()["catch"](function () {});
  roots.forEach(bindKnowYourHerbsSearch);
}
;// CONCATENATED MODULE: ./src/js/bundles/snippets/kyh-search-combobox.js
/**
 * Alpine state + keyboard model for Know Your Herbs autocomplete (APG combobox + listbox).
 * Imperative search in `kyh-search.js` dispatches events on `.know-your-herbs-search` to stay in sync.
 */
function kyhSearchCombobox() {
  return {
    sectionId: '',
    kyhContext: 'landing',
    resultsOpen: false,
    listboxMounted: false,
    optionCount: 0,
    activeIndex: -1,
    a11yBusy: false,
    a11yStatus: '',
    init: function init() {
      var _this = this;
      var root = this.$el;
      if (!root.classList.contains('know-your-herbs-search')) return;
      this.sectionId = root.getAttribute('data-section-id') || '';
      this.kyhContext = root.getAttribute('data-kyh-context') || 'landing';
      root.addEventListener('kyh-suggest-open', function () {
        _this.resultsOpen = true;
      });
      root.addEventListener('kyh-suggest-close', function () {
        _this.resultsOpen = false;
        _this.listboxMounted = false;
        _this.optionCount = 0;
        _this.activeIndex = -1;
        _this.a11yBusy = false;
        _this.clearKeyboardActive(root);
      });
      root.addEventListener('kyh-suggest-loading', function () {
        _this.a11yBusy = true;
        _this.a11yStatus = 'Searching…';
        _this.listboxMounted = false;
      });
      root.addEventListener('kyh-suggest-rendered', function (e) {
        var _e$detail$count, _e$detail;
        var count = (_e$detail$count = (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.count) !== null && _e$detail$count !== void 0 ? _e$detail$count : 0;
        _this.optionCount = count;
        _this.activeIndex = -1;
        _this.a11yBusy = false;
        _this.listboxMounted = count > 0;
        _this.a11yStatus = count === 0 ? '' : count === 1 ? '1 product found.' : "".concat(count, " products found.");
        _this.clearKeyboardActive(root);
        _this.$nextTick(function () {
          _this.decorateOptions(root);
        });
      });
      root.addEventListener('kyh-suggest-empty', function (e) {
        var _e$detail2;
        _this.optionCount = 0;
        _this.activeIndex = -1;
        _this.a11yBusy = false;
        _this.listboxMounted = false;
        _this.a11yStatus = ((_e$detail2 = e.detail) === null || _e$detail2 === void 0 ? void 0 : _e$detail2.message) || 'No products found.';
        _this.clearKeyboardActive(root);
      });
    },
    get ariaControlsTarget() {
      if (!this.resultsOpen) return '';
      if (this.listboxMounted) return "kyh-search-listbox-".concat(this.sectionId);
      return "kyh-search-results-".concat(this.sectionId);
    },
    get activeDescendant() {
      if (!this.listboxMounted || this.activeIndex < 0 || this.activeIndex >= this.optionCount) return '';
      return "kyh-search-option-".concat(this.sectionId, "-").concat(this.activeIndex);
    },
    decorateOptions: function decorateOptions(root) {
      var _this2 = this;
      root.querySelectorAll('[data-kyh-search-option]').forEach(function (li, i) {
        if (!li.id) li.id = "kyh-search-option-".concat(_this2.sectionId, "-").concat(i);
        li.setAttribute('aria-selected', 'false');
      });
    },
    clearKeyboardActive: function clearKeyboardActive(root) {
      root.querySelectorAll('[data-kyh-search-option].kyh-search-option--keyboard-active').forEach(function (el) {
        el.classList.remove('kyh-search-option--keyboard-active');
        el.setAttribute('aria-selected', 'false');
      });
    },
    updateActiveVisual: function updateActiveVisual(root) {
      var _this3 = this;
      this.clearKeyboardActive(root);
      var options = root.querySelectorAll('[data-kyh-search-option]');
      options.forEach(function (li, i) {
        if (i === _this3.activeIndex) {
          li.classList.add('kyh-search-option--keyboard-active');
          li.setAttribute('aria-selected', 'true');
          try {
            li.scrollIntoView({
              block: 'nearest'
            });
          } catch (_unused) {
            /* ignore */
          }
        } else {
          li.setAttribute('aria-selected', 'false');
        }
      });
    },
    onComboboxBlur: function onComboboxBlur() {
      this.activeIndex = -1;
      this.clearKeyboardActive(this.$el);
    },
    onComboboxKeydown: function onComboboxKeydown(e) {
      var root = this.$el;
      var key = e.key;
      if (key === 'Escape') {
        e.stopPropagation();
        root.dispatchEvent(new CustomEvent('kyh-search-request-close', {
          bubbles: true
        }));
        e.target.blur();
        return;
      }
      var shell = root.querySelector('[id^="kyh-search-results-"]');
      var panelVisible = shell && !shell.classList.contains('hidden');
      var navigable = panelVisible && this.listboxMounted && this.optionCount > 0;
      if (navigable && (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End')) {
        e.preventDefault();
        if (key === 'ArrowDown') {
          if (this.activeIndex < 0) this.activeIndex = 0;else this.activeIndex = Math.min(this.optionCount - 1, this.activeIndex + 1);
        } else if (key === 'ArrowUp') {
          if (this.activeIndex <= 0) {
            this.activeIndex = -1;
            this.clearKeyboardActive(root);
            return;
          }
          this.activeIndex -= 1;
        } else if (key === 'Home') {
          this.activeIndex = 0;
        } else if (key === 'End') {
          this.activeIndex = this.optionCount - 1;
        }
        this.updateActiveVisual(root);
        return;
      }
      if (key === 'Enter') {
        if (navigable && this.activeIndex >= 0) {
          e.preventDefault();
          root.dispatchEvent(new CustomEvent('kyh-search-activate-option', {
            bubbles: true,
            detail: {
              index: this.activeIndex
            }
          }));
          return;
        }
        if (this.a11yBusy) return;
        if (this.kyhContext === 'landing' && panelVisible && this.listboxMounted && this.optionCount > 0) {
          e.preventDefault();
          root.dispatchEvent(new CustomEvent('kyh-search-activate-first', {
            bubbles: true
          }));
        }
      }
    }
  };
}
// EXTERNAL MODULE: ./src/js/bundles/snippets/compare-shared.js
var compare_shared = __webpack_require__(9750);
;// CONCATENATED MODULE: ./src/js/bundles/snippets/plp-compare.js


var plpCompareComponent = function plpCompareComponent() {
  var base = (0,compare_shared/* createCompareBase */.qe)();
  base.compareSwiper = null;
  base.init = function () {
    var _this = this;
    this.checkPageChange();
    this.loadFromStorage();
    this.$nextTick(function () {
      _this.initCompareSwiper();
      _this.updateAlpineReactivity();
    });
    this.$watch('selectedProducts', function () {
      _this.saveToStorage();
      _this.announceCount();
      _this.$nextTick(function () {
        _this.initCompareSwiper();
      });
      _this.updateAlpineReactivity();
    });
    this.setupPageNavigationListener();

    // Make component globally accessible for Algolia search checkbox sync
    window.plpCompareComponent = this;
  };

  // Sync Algolia checkbox states
  base.updateAlpineReactivity = function () {
    var _this2 = this;
    var checkboxes = document.querySelectorAll('input[type="checkbox"][data-product-id]');
    checkboxes.forEach(function (checkbox) {
      var productId = parseInt(checkbox.dataset.productId);
      var isSelected = _this2.selectedProducts.some(function (p) {
        return p.id === productId;
      });
      checkbox.checked = isSelected;
      checkbox.disabled = !isSelected && _this2.isMaxSelected;
    });
  };
  base.openCompareModal = function () {
    if (!this.canCompare) return;
    this.showCompareModal = true;
    var focusModal = function focusModal() {
      var modal = document.querySelector('[data-compare-modal]');
      if (modal) modal.focus();
    };
    setTimeout(focusModal, 100);
  };
  base.initCompareSwiper = function () {
    if (this.compareSwiper) {
      this.compareSwiper.destroy(true, true);
      this.compareSwiper = null;
    }
    var compareSwiperEl = document.querySelector('.compare-products-swiper');
    if (compareSwiperEl) {
      this.compareSwiper = new core/* default */.Z(compareSwiperEl, compare_shared/* compareProductsSwiperConfig */.tJ);
    }
  };
  base.destroy = function () {
    if (this.compareSwiper) {
      this.compareSwiper.destroy(true, true);
      this.compareSwiper = null;
    }
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
      this.beforeUnloadHandler = null;
    }
    if (this.pageShowHandler) {
      window.removeEventListener('pageshow', this.pageShowHandler);
      this.pageShowHandler = null;
    }
    if (window.plpCompareComponent === this) {
      window.plpCompareComponent = null;
    }
  };
  return base;
};

;// CONCATENATED MODULE: ./src/js/utils/lazy-load.js

function lazy_load_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function lazy_load_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? lazy_load_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : lazy_load_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @module lazy-load
 * Core utility functions for lazy loading and code splitting.
 *
 * These utilities enable on-demand loading of modules and components,
 * improving initial page load performance by deferring unused JS.
 */

/**
 * Observes DOM elements matching a CSS selector and triggers a callback
 * when the **first** matching element enters the viewport.
 *
 * Uses IntersectionObserver to defer resource loading until an element is
 * (or is about to be) visible. The callback fires **once** — on the first
 * intersection — then the observer is fully disconnected (no memory leaks).
 *
 * **Edge cases handled:**
 * - No matching elements → returns `null`, callback never fires.
 * - Multiple matching elements → callback fires once (for whichever enters
 *   the viewport first), then all elements are unobserved via `disconnect()`.
 *
 * **⚠ display:none limitation:**
 * IntersectionObserver ignores elements with zero dimensions (e.g. elements
 * hidden via `display: none`, `x-cloak`, or `x-show="false"`).  The callback
 * will **never fire** for such elements.  For hidden elements — especially
 * Alpine.js components with `x-cloak` / `x-show` — use {@link loadIfExists}
 * instead.
 *
 * @param {string} selector - CSS selector for elements to observe.
 *   Must target **visible** elements (non-zero dimensions).
 * @param {Function} callback - Function invoked when a matching element enters the viewport.
 *   Typically triggers a dynamic `import()`.
 * @param {IntersectionObserverInit} [options={}] - IntersectionObserver options override.
 *   Defaults: `rootMargin: '100px'`, `threshold: 0.1`.
 * @returns {IntersectionObserver|null} The observer instance (useful for testing / manual cleanup),
 *   or `null` if no elements matched the selector.
 *
 * @example <caption>Non-Alpine module, viewport-based loading</caption>
 * // The `.customer-testimonials` elements are visible Swiper containers, so
 * // IntersectionObserver can detect when they approach the viewport.  The JS
 * // (and its Swiper dependency) is only fetched at that point.
 * //
 * // Import paths below are relative to theme.js (src/js/bundles/layout/).
 * // Add a webpackChunkName magic comment for readable chunk filenames.
 *
 * import { observeElement } from '~js/utils/lazy-load';
 *
 * observeElement('.customer-testimonials', () => {
 *   import('../sections/testimonials-carousel').then(({ testimonialsCarousel }) => {
 *     testimonialsCarousel();
 *   });
 * });
 *
 * @example <caption>Alpine.js component, viewport-based loading</caption>
 * // Only works when the target element is VISIBLE (no x-cloak / x-show
 * // hiding it).  If the element uses x-cloak, use loadIfExists instead
 * // (see loadIfExists docs for the full Alpine pattern).
 * //
 * // Import paths below are relative to theme.js (src/js/bundles/layout/).
 * // Add a webpackChunkName magic comment for readable chunk filenames.
 *
 * import { observeElement } from '~js/utils/lazy-load';
 *
 * // 1. Register a stub BEFORE Alpine.start() so Alpine doesn't throw:
 * Alpine.data('myComponent', () => ({}));
 *
 * // 2. Set up the observer (can be before or after Alpine.start()):
 * observeElement('.my-component-section', () => {
 *   import('../sections/my-component').then(({ default: myComponent }) => {
 *     Alpine.data('myComponent', myComponent);
 *     document.querySelectorAll('[x-data^="myComponent"]').forEach((el) => {
 *       Alpine.destroyTree(el);
 *       Alpine.initTree(el);
 *     });
 *   });
 * });
 */
var observeElement = function observeElement(selector, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var elements = document.querySelectorAll(selector);
  if (!elements.length) return null;
  var observer = new IntersectionObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        if (entry.isIntersecting) {
          callback();
          observer.disconnect();
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, lazy_load_objectSpread({
    rootMargin: '100px',
    threshold: 0.1
  }, options));
  elements.forEach(function (el) {
    return observer.observe(el);
  });
  return observer;
};

/**
 * Conditionally loads a module only when a matching DOM element exists on the page.
 *
 * Performs a **single** DOM check at call time. If at least one element matches
 * the selector, `importFn` is invoked. Otherwise nothing loads and a resolved
 * Promise with `null` is returned, keeping the API consistent (always a Promise).
 *
 * **Edge cases handled:**
 * - No matching elements → returns `Promise.resolve(null)`, `importFn` never called.
 * - Multiple matching elements → `importFn` is called once (it is up to the loaded
 *   module to query the DOM for all instances).
 *
 * **Alpine.js components with x-cloak / x-show:**
 * Elements hidden via `display: none` are invisible to IntersectionObserver,
 * so `observeElement` cannot be used for them.  Use `loadIfExists` instead —
 * the chunk loads immediately but only on pages where the section exists.
 *
 * To lazy-load an Alpine component that is server-rendered with `x-data`:
 *
 * 1. Register a **stub** via `Alpine.data()` **before** `Alpine.start()` so
 *    that Alpine does not throw on the unknown component.  The stub should
 *    include enough data to keep reactive expressions (e.g. `x-show`) in a
 *    safe state.
 * 2. After the real module arrives, re-register the component with
 *    `Alpine.data()`, then call `Alpine.destroyTree(el)` followed by
 *    `Alpine.initTree(el)` on every matching element so that the real
 *    `init()` method runs.
 *
 * @param {string} selector - CSS selector to check for existence in the DOM.
 * @param {Function} importFn - Function that returns a Promise (typically a dynamic `import()`).
 * @returns {Promise<*>} The result of `importFn()`, or `Promise.resolve(null)` if no element matched.
 *
 * @example <caption>Non-Alpine module</caption>
 * // Load testimonials module only on pages that have the section.
 * //
 * // Import paths below are relative to theme.js (src/js/bundles/layout/).
 * // Add a webpackChunkName magic comment for readable chunk filenames.
 *
 * import { loadIfExists } from '~js/utils/lazy-load';
 *
 * loadIfExists('.customer-testimonials', () =>
 *   import('../sections/testimonials-carousel').then(({ testimonialsCarousel }) => {
 *     testimonialsCarousel();
 *   }),
 * );
 *
 * @example <caption>Alpine.js component with x-cloak (display:none)</caption>
 * // productExplorer has x-cloak and x-show, so its element is display:none
 * // until Alpine processes it — IntersectionObserver would never fire.
 * // loadIfExists is the right choice: the chunk loads immediately but only
 * // on pages where the section actually exists in the DOM.
 * //
 * // Import paths below are relative to theme.js (src/js/bundles/layout/).
 * // Add a webpackChunkName magic comment for readable chunk filenames.
 *
 * import { loadIfExists } from '~js/utils/lazy-load';
 *
 * // Step 1 — register a minimal stub BEFORE Alpine.start():
 * // (carouselData: [] keeps x-show="… && carouselData.length > 0" falsy
 * //  so the section stays hidden until the real implementation loads)
 * Alpine.data('productExplorer', () => ({ carouselData: [] }));
 *
 * // Step 2 — lazy-load the real implementation:
 * loadIfExists('.product-explorer', () =>
 *   import('../sections/product-explorer').then(({ default: productExplorerInit }) => {
 *     Alpine.data('productExplorer', productExplorerInit);
 *     document.querySelectorAll('[x-data^="productExplorer"]').forEach((el) => {
 *       Alpine.destroyTree(el);
 *       Alpine.initTree(el);
 *     });
 *   }),
 * );
 */
var loadIfExists = function loadIfExists(selector, importFn) {
  if (document.querySelector(selector)) {
    return importFn();
  }
  return Promise.resolve(null);
};
// EXTERNAL MODULE: ./src/js/utils/pdp-components.js
var pdp_components = __webpack_require__(9442);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(885);
;// CONCATENATED MODULE: ./src/js/utils/cart-components.js

var cartComponentsPromise;

/**
 * Cart component selectors that need Alpine.initTree() after async registration.
 * These are x-data components that Alpine.start() will skip because they aren't
 * registered yet at that point.
 */
var CART_COMPONENT_SELECTORS = ['[x-data="cartComponent"]', '[x-data="lineItemComponent"]', '[x-data^="recommendedProducts"]'].join(', ');

/**
 * Merges all own properties (including getters/setters) from `source` into `target`.
 *
 * Unlike Object.assign, this copies getters/setters as descriptors instead of
 * invoking them. This prevents errors when a getter depends on state that isn't
 * available yet (e.g. `this.cartData.items` when `cartData` is null).
 *
 * Regular (non-accessor) properties are set via direct assignment so that
 * Alpine's reactive proxy traps fire correctly.
 */
function mergeStoreDescriptors(target, source) {
  var descriptors = Object.getOwnPropertyDescriptors(source);
  for (var _i = 0, _Object$entries = Object.entries(descriptors); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      descriptor = _Object$entries$_i[1];
    if ('get' in descriptor || 'set' in descriptor) {
      // Accessor property — define it so the getter/setter is preserved,
      // not evaluated immediately like Object.assign would do.
      Object.defineProperty(target, key, descriptor);
    } else {
      // Data property — assign through proxy so Alpine tracks reactivity.
      target[key] = descriptor.value;
    }
  }
}

/**
 * Loads and registers all cart-related Alpine components and stores asynchronously.
 *
 * Strategy:
 * - Store stubs must be registered BEFORE Alpine.start() (done in theme.js)
 * - This function loads the real modules, merges store data into the stubs,
 *   registers Alpine.data() components, and calls Alpine.initTree() on cart DOM elements.
 *
 * @param {object} Alpine - Alpine.js instance
 * @returns {Promise<void>}
 */
function loadCartComponents(Alpine) {
  var alpine = Alpine || window.Alpine;
  if (!alpine) {
    throw new Error('Alpine is not available. Ensure window.Alpine is set before loading cart components.');
  }
  if (cartComponentsPromise) return cartComponentsPromise;
  cartComponentsPromise = Promise.all([Promise.all(/* import() | cart */[__webpack_require__.e(604), __webpack_require__.e(511)]).then(__webpack_require__.bind(__webpack_require__, 1625)), Promise.all(/* import() | cart */[__webpack_require__.e(604), __webpack_require__.e(511)]).then(__webpack_require__.bind(__webpack_require__, 3519)), Promise.all(/* import() | cart */[__webpack_require__.e(604), __webpack_require__.e(511)]).then(__webpack_require__.bind(__webpack_require__, 3998)), Promise.all(/* import() | cart */[__webpack_require__.e(604), __webpack_require__.e(511)]).then(__webpack_require__.bind(__webpack_require__, 6887)), Promise.all(/* import() | cart */[__webpack_require__.e(604), __webpack_require__.e(511)]).then(__webpack_require__.bind(__webpack_require__, 8630))]).then(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 5),
      _ref2$ = _ref2[0],
      cartStore = _ref2$.cartStore,
      cartComponent = _ref2$.cartComponent,
      lineItemComponent = _ref2[1]["default"],
      recommendedProducts = _ref2[2]["default"],
      quickBuyModal = _ref2[3].quickBuyModal,
      _ref2$2 = _ref2[4],
      rebuyCartHandler = _ref2$2.rebuyCartHandler,
      rebuyCartState = _ref2$2.rebuyCartState;
    // Register Alpine.data() components (not registered before Alpine.start())
    alpine.data('cartComponent', cartComponent);
    alpine.data('lineItemComponent', lineItemComponent);
    alpine.data('recommendedProducts', recommendedProducts);

    // Merge real store implementations into the stub stores.
    // Uses descriptor-based merge to avoid invoking getters (which would crash
    // because cartData is still null at this point — init() hasn't run yet).
    mergeStoreDescriptors(alpine.store('cart'), cartStore());
    window.cartStore = alpine.store('cart');
    mergeStoreDescriptors(alpine.store('rebuyCart'), rebuyCartState());

    // Save dialog ref set during Alpine.start() via x-init="quickBuyModal.set_dialog($el)"
    // before merge overwrites it with null from the factory default.
    var qbmStore = alpine.store('quickBuyModal');
    var existingDialog = qbmStore.dialog;
    mergeStoreDescriptors(qbmStore, quickBuyModal());
    if (existingDialog) {
      qbmStore.dialog = existingDialog;
    }

    // Alpine calls init() only on first store registration. Since stubs were
    // registered first (without init), we must call init() manually after merge
    // so that stores fetch data and attach event listeners.
    alpine.store('cart').init();
    alpine.store('rebuyCart').init();

    // Initialize handlers
    rebuyCartHandler().init();

    // Initialize cart DOM elements that Alpine.start() skipped
    document.querySelectorAll(CART_COMPONENT_SELECTORS).forEach(function (el) {
      alpine.initTree(el);
    });
  });
  return cartComponentsPromise;
}
;// CONCATENATED MODULE: ./src/js/bundles/snippets/product-card.js

var productCard = function productCard(productId) {
  return {
    loading: false,
    error: '',
    productId: productId,
    get shopifyData() {
      if (!this.productId) return null;
      if (this.loading) return null;
      return products_and_collections/* productsData */.Zc[this.productId];
    },
    get link() {
      var _this$shopifyData;
      if (!this.shopifyData) return '/';
      return "".concat(window.Shopify.routes.root, "products/").concat((_this$shopifyData = this.shopifyData) === null || _this$shopifyData === void 0 ? void 0 : _this$shopifyData.handle);
    },
    get images() {
      var _this$shopifyData2;
      return ((_this$shopifyData2 = this.shopifyData) === null || _this$shopifyData2 === void 0 ? void 0 : _this$shopifyData2.images) || [];
    },
    get description() {
      var _this$shopifyData3;
      return (_this$shopifyData3 = this.shopifyData) === null || _this$shopifyData3 === void 0 ? void 0 : _this$shopifyData3.description;
    },
    get productReviewCount() {
      var _this$shopifyData4, _this$shopifyData4$ra;
      var rating = (_this$shopifyData4 = this.shopifyData) === null || _this$shopifyData4 === void 0 ? void 0 : (_this$shopifyData4$ra = _this$shopifyData4.ratingCount) === null || _this$shopifyData4$ra === void 0 ? void 0 : _this$shopifyData4$ra.value;
      var ratingNormalized = Number(rating) || 0;
      return "".concat(ratingNormalized, " Review").concat(ratingNormalized === 1 ? '' : 's');
    },
    get qualifiersParsed() {
      var qualifiers = this.shopifyData.qualifiers;
      if (!(qualifiers !== null && qualifiers !== void 0 && qualifiers.value)) return '';
      try {
        return JSON.parse(qualifiers.value).join(' ');
      } catch (e) {
        return '';
      }
    },
    get title() {
      var _this$shopifyData5;
      var description = this.shopifyData.description;
      if (description !== null && description !== void 0 && description.value) return description.value;
      return "".concat(this.qualifiersParsed, " ").concat((_this$shopifyData5 = this.shopifyData) === null || _this$shopifyData5 === void 0 ? void 0 : _this$shopifyData5.type.value);
    },
    get starRating() {
      var _this$shopifyData6;
      return (_this$shopifyData6 = this.shopifyData) === null || _this$shopifyData6 === void 0 ? void 0 : _this$shopifyData6.starRatingSnippet;
    },
    get legacyTitle() {
      var _this$shopifyData7;
      return (_this$shopifyData7 = this.shopifyData) === null || _this$shopifyData7 === void 0 ? void 0 : _this$shopifyData7.title;
    },
    get legacyTitleHtml() {
      var _this$shopifyData8;
      var t = (_this$shopifyData8 = this.shopifyData) === null || _this$shopifyData8 === void 0 ? void 0 : _this$shopifyData8.title;
      if (!t) return '';
      return t.replace(/([®™©])/g, '<sup class="trademark">$1</sup>');
    },
    get extractProductId() {
      // Split the string by the '/' character and get the last part
      var gid = this.productId;
      var parts = gid.split('/');
      return parts[parts.length - 1];
    },
    get okendoRating() {
      return 'shopify-' + this.extractProductId;
    },
    get price() {
      var _this$shopifyData9;
      return (_this$shopifyData9 = this.shopifyData) === null || _this$shopifyData9 === void 0 ? void 0 : _this$shopifyData9.priceRangeFormatted;
    },
    get priceRegular() {
      var _this$shopifyData10;
      return (_this$shopifyData10 = this.shopifyData) === null || _this$shopifyData10 === void 0 ? void 0 : _this$shopifyData10.compareAtPriceRangeFormatted;
    },
    get hasReducedPrice() {
      var priceRegular = this.priceRegular,
        price = this.price;
      return priceRegular && priceRegular !== price;
    },
    get pricingText() {
      return "reduced price: ".concat(this.price, ", regular price: ").concat(this.priceRegular);
    },
    get pricingExtraText() {
      var tags = this.shopifyData.tags;
      var tag = tags.find(function (tag) {
        return tag.startsWith('Off:');
      });
      if (!tag) return '';
      var pct = tag.replace('Off:', '');
      return "Extra ".concat(pct, "% off on Checkout");
    },
    get quickBuyTitle() {
      var _shopifyData$seasonal;
      var shopifyData = this.shopifyData;
      if (shopifyData.availableForSale) {
        return 'Add To Bag';
      }
      if (shopifyData.tags.includes('Coming Soon') || ((_shopifyData$seasonal = shopifyData.seasonalCore) === null || _shopifyData$seasonal === void 0 ? void 0 : _shopifyData$seasonal.value) === 'Core') {
        return 'Notify Me';
      }
      return 'Sold Out';
    },
    get isSoldOut() {
      return this.quickBuyTitle === 'Sold Out';
    },
    get variantsCount() {
      var _this$shopifyData11;
      return "".concat((_this$shopifyData11 = this.shopifyData) === null || _this$shopifyData11 === void 0 ? void 0 : _this$shopifyData11.variants.length, " variant(s)");
    },
    init: function init() {
      var _this = this;
      if (!this.shopifyData) {
        this.loading = true;
        (0,products_and_collections/* fetchProducts */.t2)([this.productId]).then(function () {
          _this.loading = false;
        })["catch"](function (e) {
          _this.error = "Error: ".concat(e.message || 'Unknown error');
        });
      }
    }
  };
};
/* harmony default export */ const product_card = (productCard);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.js
var autoplay_autoplay = __webpack_require__(9127);
;// CONCATENATED MODULE: ./src/js/bundles/sections/promo-bar-carousel.js

var promoBarCarousel = function promoBarCarousel() {
  var sliders = document.querySelectorAll('.promo-bar-carousel');
  sliders.forEach(function (slider) {
    var promoBar = slider.closest('.header-promo-bar');
    if (!promoBar) return;
    var autoplay = slider.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(slider.dataset.autoplayDelay) || 5000;
    var prevButton = promoBar.querySelector('.promo-bar-prev');
    var nextButton = promoBar.querySelector('.promo-bar-next');
    var swiperOptions = {
      modules: [navigation/* default */.Z],
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      loop: true,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 0
    };
    if (autoplay) {
      swiperOptions.modules.push(autoplay_autoplay/* default */.Z);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }
    new core/* default */.Z(slider, swiperOptions);
  });
};
// EXTERNAL MODULE: ./node_modules/swiper/modules/mousewheel/mousewheel.js
var mousewheel = __webpack_require__(8372);
;// CONCATENATED MODULE: ./src/js/bundles/sections/product-explorer.js



function product_explorer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function product_explorer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? product_explorer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : product_explorer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var product_explorer_swiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  watchSlidesProgress: true,
  slideVisibleClass: 'swiper-slide-visible',
  modules: [navigation/* default */.Z, mousewheel/* default */.Z, a11y/* default */.Z, keyboard/* default */.Z],
  keyboard: {
    enabled: false,
    onlyInViewport: false
  },
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
    disabledClass: 'swiper-button-hidden'
  },
  a11y: {
    enabled: true,
    prevSlideMessage: '',
    nextSlideMessage: '',
    firstSlideMessage: '',
    lastSlideMessage: ''
  },
  mousewheel: {
    forceToAxis: true
  },
  on: {
    init: updateSlideTabIndexes,
    slideChange: updateSlideTabIndexes,
    resize: updateSlideTabIndexes
  },
  breakpoints: {
    320: {
      slidesPerView: 1.3787,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    },
    640: {
      spaceBetween: 32,
      slidesPerView: 2.5,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    },
    1024: {
      spaceBetween: 32,
      slidesPerView: 3,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    },
    1280: {
      spaceBetween: 32,
      slidesPerView: 4,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    }
  }
};
function updateSlideTabIndexes(swiper) {
  var _swiper$navigation3;
  Array.from(swiper.slides).forEach(function (slide, index) {
    var isVisible = slide.classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible');
    var titleLink = slide.querySelector('h3 a');
    var addToBagBtn = slide.querySelector('button[data-gh-label="add_to_bag"]');
    if (titleLink) {
      titleLink.setAttribute('tabindex', isVisible ? '0' : '-1');
      titleLink.removeEventListener('keydown', titleLink._arrowNavHandler);
      if (isVisible) {
        var handler = function handler(e) {
          if (e.key === 'ArrowRight') {
            var _swiper$navigation, _swiper$navigation$ne;
            var next = findNextVisibleTitle(swiper, index);
            if (next) next.focus();else (_swiper$navigation = swiper.navigation) === null || _swiper$navigation === void 0 ? void 0 : (_swiper$navigation$ne = _swiper$navigation.nextEl) === null || _swiper$navigation$ne === void 0 ? void 0 : _swiper$navigation$ne.focus();
          } else if (e.key === 'ArrowLeft') {
            var _swiper$navigation2, _swiper$navigation2$p;
            var prev = findPrevVisibleTitle(swiper, index);
            if (prev) prev.focus();else (_swiper$navigation2 = swiper.navigation) === null || _swiper$navigation2 === void 0 ? void 0 : (_swiper$navigation2$p = _swiper$navigation2.prevEl) === null || _swiper$navigation2$p === void 0 ? void 0 : _swiper$navigation2$p.focus();
          }
        };
        titleLink._arrowNavHandler = handler;
        titleLink.addEventListener('keydown', handler);
      }
    }
    if (addToBagBtn) {
      addToBagBtn.setAttribute('tabindex', isVisible ? '0' : '-1');
    }
  });

  // ✅ Announce visible slide range for screen reader
  var visibleSlides = Array.from(swiper.slides).filter(function (slide) {
    return slide.classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible');
  });
  var firstVisible = Array.from(swiper.slides).indexOf(visibleSlides[0]) + 1;
  var lastVisible = Array.from(swiper.slides).indexOf(visibleSlides[visibleSlides.length - 1]) + 1;
  var totalSlides = swiper.slides.length;
  var statusText = "You are viewing ".concat(firstVisible, " to ").concat(lastVisible, " of ").concat(totalSlides, " slides");
  var alpineRoot = swiper.el.closest('[x-data]');
  var slideStatusEl = alpineRoot === null || alpineRoot === void 0 ? void 0 : alpineRoot.querySelector('[x-ref="slideStatus"]');
  if (slideStatusEl) {
    slideStatusEl.textContent = statusText;
  }

  // ✅ Safari VoiceOver fix
  var firstVisibleSlide = Array.from(swiper.slides).find(function (slide) {
    return slide.classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible');
  });
  var titleLink = firstVisibleSlide === null || firstVisibleSlide === void 0 ? void 0 : firstVisibleSlide.querySelector('h3 a');
  if (titleLink && document.activeElement === ((_swiper$navigation3 = swiper.navigation) === null || _swiper$navigation3 === void 0 ? void 0 : _swiper$navigation3.nextEl)) {
    setTimeout(function () {
      titleLink.focus();
    }, 10);
  }
}
function findNextVisibleTitle(swiper, currentIndex) {
  var slides = Array.from(swiper.slides);
  for (var i = currentIndex + 1; i < slides.length; i++) {
    if (slides[i].classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible')) {
      return slides[i].querySelector('h3 a');
    }
  }
  return null;
}
function findPrevVisibleTitle(swiper, currentIndex) {
  var slides = Array.from(swiper.slides);
  for (var i = currentIndex - 1; i >= 0; i--) {
    if (slides[i].classList.contains(swiper.params.slideVisibleClass || 'swiper-slide-visible')) {
      return slides[i].querySelector('h3 a');
    }
  }
  return null;
}
var productExplorer = function productExplorer(numSlides) {
  return {
    numSlides: numSlides || 16,
    selectedIdx: 0,
    carouselData: [],
    get selectedProducts() {
      var _foundCarousel$result;
      var foundCarousel = this.carouselData[this.selectedIdx];
      var firstNumProducts = (foundCarousel === null || foundCarousel === void 0 ? void 0 : (_foundCarousel$result = foundCarousel.results) === null || _foundCarousel$result === void 0 ? void 0 : _foundCarousel$result.slice(0, this.numSlides)) || [];
      return firstNumProducts;
    },
    get selectedCollectionHandle() {
      var _this$carouselData$th;
      return (_this$carouselData$th = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th === void 0 ? void 0 : _this$carouselData$th.handle;
    },
    get selectedCollectionTitle() {
      var _this$carouselData$th2;
      return (_this$carouselData$th2 = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th2 === void 0 ? void 0 : _this$carouselData$th2.title;
    },
    get selectedCollectionCount() {
      var _this$carouselData$th3;
      return (_this$carouselData$th3 = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th3 === void 0 ? void 0 : _this$carouselData$th3.count;
    },
    get selectedCollectionUrl() {
      var _this$carouselData$th4;
      return (_this$carouselData$th4 = this.carouselData[this.selectedIdx]) === null || _this$carouselData$th4 === void 0 ? void 0 : _this$carouselData$th4.url;
    },
    // TODO: consider not using Searchspring
    /**
     * Fetch carousel data from Searchspring API.
     * - Currently only supports fetching either collections data or recommendations, not both
     * - This could be extended to support some tabs being collections and others being
     *   product recommendations.
     */
    getCarouselData: function getCarouselData() {
      var _this = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var carouselData, mapSSData, productRequests;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              carouselData = [];
              /**
               * Map the swiper element to an object containing data about the carousel.
               */
              mapSSData = function mapSSData(swiper) {
                var type = swiper.dataset.type;
                return product_explorer_objectSpread(product_explorer_objectSpread({
                  type: type,
                  results: []
                }, type === 'products_by_collection' && {
                  handle: swiper.dataset.collectionHandle,
                  title: swiper.dataset.collectionTitle,
                  url: swiper.dataset.collectionUrl,
                  count: swiper.dataset.collectionCount
                }), type === 'product_recommendations' && {
                  intent: swiper.dataset.recommendationsIntent,
                  productId: swiper.dataset.recommendationsProductId
                });
              };
              carouselData = Array.from(_this.swiperContentEls).map(mapSSData);
              productRequests = carouselData.map(function (entry) {
                return entry.type === 'products_by_collection' ? (0,products_and_collections/* fetchCollection */.lA)(entry.handle, null, _this.numSlides) : entry.type === 'product_recommendations' ? (0,products_and_collections/* fetchRecommendedProducts */.hd)(entry.intent, "gid://shopify/Product/".concat(entry.productId)) : null;
              });
              _context.next = 6;
              return Promise.all(productRequests).then(function (responses) {
                return responses.forEach(function (response, idx) {
                  var _response$products;
                  carouselData[idx].results = response === null || response === void 0 ? void 0 : (_response$products = response.products) === null || _response$products === void 0 ? void 0 : _response$products.nodes;
                });
              });
            case 6:
              return _context.abrupt("return", carouselData);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    buildSwipers: function buildSwipers() {
      if (this.swiperContentEls) {
        this.swiperContentInstances = Array.from(this.swiperContentEls).map(function (swiperEl) {
          var customA11y = {
            prevSlideMessage: swiperEl.dataset.prevSlideMsg || 'Previous slide',
            nextSlideMessage: swiperEl.dataset.nextSlideMsg || 'Next slide',
            firstSlideMessage: swiperEl.dataset.firstSlideMsg || 'This is the first slide',
            lastSlideMessage: swiperEl.dataset.lastSlideMsg || 'This is the last slide'
          };
          var instance = new core/* default */.Z(swiperEl, product_explorer_objectSpread(product_explorer_objectSpread({}, product_explorer_swiperConfig), {}, {
            a11y: product_explorer_objectSpread(product_explorer_objectSpread({}, product_explorer_swiperConfig.a11y), customA11y)
          }));
          // Set tabindexes initially
          updateSlideTabIndexes(instance);
          // Update tabindexes on every slide change
          instance.on('slideChange', function () {
            return updateSlideTabIndexes(instance);
          });
          // Also update on resize (in case visible slides change)
          instance.on('resize', function () {
            return updateSlideTabIndexes(instance);
          });
          return instance;
        });
      }
    },
    init: function init() {
      var _this2 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _window, okeWidgetApi;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _window = window, okeWidgetApi = _window.okeWidgetApi;
              _this2.swiperContentEls = _this2.$el.querySelectorAll('.swiper');
              _this2.collectionCountSpan = _this2.$el.querySelector('#collection_count');
              _context2.next = 5;
              return _this2.getCarouselData();
            case 5:
              _this2.carouselData = _context2.sent;
              _this2.buildSwipers();
              okeWidgetApi === null || okeWidgetApi === void 0 ? void 0 : okeWidgetApi.initAllWidgets(); // eslint-disable-line no-undef

              _this2.$watch('selectedIdx', function (newIndex) {
                var swiperInstance = _this2.swiperContentInstances[newIndex];
                // update since swiper recommends it after you hide/show it
                // source: https://swiperjs.com/swiper-api#method-swiper-update
                swiperInstance.update();
                okeWidgetApi === null || okeWidgetApi === void 0 ? void 0 : okeWidgetApi.initAllWidgets(); // eslint-disable-line no-undef
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  };
};
/* harmony default export */ const product_explorer = (productExplorer);
;// CONCATENATED MODULE: ./src/js/bundles/sections/where-is-my-herbId.js

var herbFinder = function herbFinder() {
  document.addEventListener('DOMContentLoaded', function () {
    // eslint-disable-next-line no-unused-vars
    var herbFinderSwiper = new core/* default */.Z('.herb-finder__instructionContainer', {
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12
        },
        375: {
          slidesPerView: 1.56,
          spaceBetween: 16
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        700: {
          slidesPerView: 2.5,
          spaceBetween: 32
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 32
        }
      },
      on: {
        afterInit: function afterInit() {
          var herbWrappers = document.querySelectorAll('.herb-finder__wrapper');
          herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
            herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'md:gap-8');
          });
        }
      }
    });
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/ingredient-list.js

var initIngredientList = function initIngredientList() {
  var init = function init() {
    document.querySelectorAll('.ingredient__container').forEach(function (container) {
      new core/* default */.Z(container, {
        slidesPerView: 'auto',
        modules: [navigation/* default */.Z],
        navigation: {
          prevEl: container.querySelector('.swiper-button-prev'),
          nextEl: container.querySelector('.swiper-button-next'),
          disabledClass: 'swiper-button-hidden'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 12
          },
          375: {
            slidesPerView: 2.2437,
            spaceBetween: 16
          },
          500: {
            slidesPerView: 2.8,
            spaceBetween: 16
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 32
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 32
          }
        },
        on: {
          afterInit: function afterInit() {
            var herbWrappers = document.querySelectorAll('.ingredient__wrapper');
            herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
              herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
            });
          }
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/product-grid.js

var initProductGrid = function initProductGrid() {
  var init = function init() {
    document.querySelectorAll('.product-grid__container').forEach(function (container) {
      new core/* default */.Z(container, {
        slidesPerView: 'auto',
        modules: [navigation/* default */.Z],
        navigation: {
          prevEl: container.querySelector('.swiper-button-prev'),
          nextEl: container.querySelector('.swiper-button-next'),
          disabledClass: 'swiper-button-hidden'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 12
          },
          375: {
            slidesPerView: 1.3007,
            spaceBetween: 16
          },
          500: {
            slidesPerView: 2.8,
            spaceBetween: 16
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 32
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 32
          }
        },
        on: {
          afterInit: function afterInit() {
            var herbWrappers = document.querySelectorAll('.product-grid__wrapper');
            herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
              herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
            });
          }
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/featureProduct.js
/* eslint-disable prettier/prettier */

var initFeaturedProduct = function initFeaturedProduct() {
  new core/* default */.Z('.product__container', {
    slidesPerView: 'auto',
    breakpoints: {
      375: {
        slidesPerView: 1.3496,
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 32
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32
      }
    },
    on: {
      afterInit: function afterInit() {
        var herbWrappers = document.querySelectorAll('.product__wrapper');
        herbWrappers === null || herbWrappers === void 0 ? void 0 : herbWrappers.forEach(function (herbWrapper) {
          herbWrapper === null || herbWrapper === void 0 ? void 0 : herbWrapper.classList.remove('gap-4', 'lg:gap-8');
        });
      }
    }
  });
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/kyh-rebuy-products-carousel.js



function kyh_rebuy_products_carousel_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = kyh_rebuy_products_carousel_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function kyh_rebuy_products_carousel_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return kyh_rebuy_products_carousel_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kyh_rebuy_products_carousel_arrayLikeToArray(o, minLen); }
function kyh_rebuy_products_carousel_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var tagCache = new Map();
var decorateVersions = new WeakMap();
var decorateTimers = new WeakMap();
var observedContainers = new WeakSet();
function getHandle(block) {
  var _block$querySelector, _href$match$, _href$match;
  var href = (_block$querySelector = block.querySelector('.rebuy-product-title-link, .rebuy-product-image')) === null || _block$querySelector === void 0 ? void 0 : _block$querySelector.getAttribute('href');
  return (_href$match$ = href === null || href === void 0 ? void 0 : (_href$match = href.match(/\/products\/([^/?#]+)/)) === null || _href$match === void 0 ? void 0 : _href$match[1]) !== null && _href$match$ !== void 0 ? _href$match$ : null;
}
function fetchTag(handle) {
  if (!tagCache.has(handle)) {
    tagCache.set(handle, fetch("/products/".concat(handle, "?view=rebuy-tag"), {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (data) {
      return (data === null || data === void 0 ? void 0 : data.rebuy_tag) || '';
    })["catch"](function () {
      return '';
    }));
  }
  return tagCache.get(handle);
}
function getBlockTag(_x) {
  return _getBlockTag.apply(this, arguments);
}
function _getBlockTag() {
  _getBlockTag = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(block) {
    var handle, tag;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          handle = getHandle(block);
          if (!handle) {
            _context.next = 7;
            break;
          }
          _context.next = 4;
          return fetchTag(handle);
        case 4:
          _context.t0 = _context.sent;
          _context.next = 8;
          break;
        case 7:
          _context.t0 = '';
        case 8:
          tag = _context.t0;
          return _context.abrupt("return", {
            block: block,
            tag: (tag || '').trim()
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getBlockTag.apply(this, arguments);
}
function addTagPlaceholder(block, tag) {
  var el = block.querySelector(':scope > .rebuy-tag');
  if (!el) {
    el = document.createElement('div');
    el.className = 'rebuy-tag';
    block.prepend(el);
  }
  el.textContent = tag;
}
function decorateContainer(_x2, _x3) {
  return _decorateContainer.apply(this, arguments);
}
function _decorateContainer() {
  _decorateContainer = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(container, version) {
    var _container$closest;
    var blocks, results, hasAnyTag, heading;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          blocks = (0,toConsumableArray/* default */.Z)(container.querySelectorAll('.rebuy-product-block'));
          if (blocks.length) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          _context2.next = 5;
          return Promise.all(blocks.map(getBlockTag));
        case 5:
          results = _context2.sent;
          if (!(decorateVersions.get(container) !== version)) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return");
        case 8:
          console.log('[KYH Rebuy Tags]', results.map(function (_ref) {
            var block = _ref.block,
              tag = _ref.tag;
            return {
              handle: getHandle(block),
              tag: tag || '(none)'
            };
          }));
          hasAnyTag = results.some(function (_ref2) {
            var tag = _ref2.tag;
            return tag;
          });
          heading = (_container$closest = container.closest('.kyh-rebuy-products-carousel')) === null || _container$closest === void 0 ? void 0 : _container$closest.querySelector(':scope > div > h2');
          if (hasAnyTag) {
            _context2.next = 16;
            break;
          }
          container.classList.add('kyh-rebuy-products-carousel--no-tags');
          container.querySelectorAll('.rebuy-tag').forEach(function (el) {
            return el.remove();
          });
          if (heading) {
            heading.style.removeProperty('--kyh-heading-mb-desktop');
            heading.style.removeProperty('--kyh-heading-mb-mobile');
          }
          return _context2.abrupt("return");
        case 16:
          container.classList.remove('kyh-rebuy-products-carousel--no-tags');
          if (heading) {
            heading.style.setProperty('--kyh-heading-mb-desktop', '24px');
            heading.style.setProperty('--kyh-heading-mb-mobile', '12px');
          }
          results.forEach(function (_ref3) {
            var block = _ref3.block,
              tag = _ref3.tag;
            return addTagPlaceholder(block, tag);
          });
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _decorateContainer.apply(this, arguments);
}
function scheduleDecorateContainer(container) {
  clearTimeout(decorateTimers.get(container));
  var version = (decorateVersions.get(container) || 0) + 1;
  decorateVersions.set(container, version);
  var timer = setTimeout(function () {
    decorateTimers["delete"](container);
    decorateContainer(container, version);
  }, 50);
  decorateTimers.set(container, timer);
}
function observeContainer(container) {
  if (observedContainers.has(container)) return;
  observedContainers.add(container);
  scheduleDecorateContainer(container);
  new MutationObserver(function (mutations) {
    var _iterator = kyh_rebuy_products_carousel_createForOfIteratorHelper(mutations),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var addedNodes = _step.value.addedNodes;
        var _iterator2 = kyh_rebuy_products_carousel_createForOfIteratorHelper(addedNodes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var node = _step2.value;
            if (!(node instanceof HTMLElement)) continue;
            if (node.matches('.rebuy-product-block') || node.querySelector('.rebuy-product-block')) {
              scheduleDecorateContainer(container);
              return;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }).observe(container, {
    childList: true,
    subtree: true
  });
}
function initKyhRebuyProductsCarousel() {
  document.querySelectorAll('[data-kyh-rebuy-products-carousel]').forEach(observeContainer);
}
;// CONCATENATED MODULE: ./src/js/bundles/sections/impact-report-header.js
var ROTATE_INTERVAL = 5000;
var FADE_DURATION = 400;
var EXPLORE_MS = 300;
function impactReportHeader() {
  return {
    dropdownOpen: false,
    exploreMenuOpen: false,
    megaMenuOpen: false,
    exploreShowBorder: true,
    exploreShowGradient: true,
    titles: [],
    activeIndex: 0,
    titleVisible: true,
    _interval: null,
    _exploreTimer: null,
    init: function init() {
      try {
        this.titles = JSON.parse(this.$el.dataset.titles || '[]');
      } catch (_unused) {
        this.titles = [];
      }
      if (this.titles.length > 1) {
        this._startRotation();
      }
    },
    get currentTitle() {
      return this.titles[this.activeIndex] || '';
    },
    _clearExploreTimers: function _clearExploreTimers() {
      if (this._exploreTimer != null) {
        clearTimeout(this._exploreTimer);
        this._exploreTimer = null;
      }
    },
    _startRotation: function _startRotation() {
      var _this = this;
      this._interval = setInterval(function () {
        _this.titleVisible = false;
        setTimeout(function () {
          _this.activeIndex = (_this.activeIndex + 1) % _this.titles.length;
          _this.titleVisible = true;
        }, FADE_DURATION);
      }, ROTATE_INTERVAL);
    },
    resetExploreMenu: function resetExploreMenu() {
      this._clearExploreTimers();
      this.exploreMenuOpen = false;
      this.exploreShowBorder = true;
      this.exploreShowGradient = true;
    },
    openExploreMenu: function openExploreMenu() {
      var _this2 = this;
      if (this.dropdownOpen) this.close();
      if (this.megaMenuOpen) this.megaMenuOpen = false;
      this._clearExploreTimers();
      this.exploreMenuOpen = true;
      this.exploreShowGradient = false;
      this.exploreShowBorder = true;
      this.$nextTick(function () {
        _this2.exploreShowBorder = false;
        _this2._exploreTimer = setTimeout(function () {
          _this2.exploreShowGradient = true;
          _this2._exploreTimer = null;
        }, EXPLORE_MS);
      });
    },
    closeExploreMenu: function closeExploreMenu() {
      var _this3 = this;
      if (!this.exploreMenuOpen) return;
      this._clearExploreTimers();
      this.exploreShowGradient = false;
      this._exploreTimer = setTimeout(function () {
        _this3.exploreShowBorder = true;
        _this3.exploreMenuOpen = false;
        _this3.exploreShowGradient = true;
        _this3._exploreTimer = null;
      }, EXPLORE_MS);
    },
    toggleExploreMenu: function toggleExploreMenu() {
      this.exploreMenuOpen ? this.closeExploreMenu() : this.openExploreMenu();
    },
    openMegaMenu: function openMegaMenu() {
      var _this4 = this;
      if (this.dropdownOpen) this.close();
      if (this.exploreMenuOpen) this.resetExploreMenu();
      this.megaMenuOpen = true;
      this.$nextTick(function () {
        var _this4$$refs$megaClos;
        (_this4$$refs$megaClos = _this4.$refs.megaClose) === null || _this4$$refs$megaClos === void 0 ? void 0 : _this4$$refs$megaClos.focus();
      });
    },
    closeMegaMenu: function closeMegaMenu() {
      var _this5 = this;
      this.megaMenuOpen = false;
      this.$nextTick(function () {
        var _this5$$refs$megaTrig;
        (_this5$$refs$megaTrig = _this5.$refs.megaTrigger) === null || _this5$$refs$megaTrig === void 0 ? void 0 : _this5$$refs$megaTrig.focus();
      });
    },
    toggleMegaMenu: function toggleMegaMenu() {
      this.megaMenuOpen ? this.closeMegaMenu() : this.openMegaMenu();
    },
    toggle: function toggle() {
      var _this6 = this;
      var opening = !this.dropdownOpen;
      if (opening) {
        if (this.exploreMenuOpen) this.resetExploreMenu();
        if (this.megaMenuOpen) this.megaMenuOpen = false;
      }
      this.dropdownOpen = !this.dropdownOpen;
      if (opening) {
        this.$nextTick(function () {
          var _this6$$refs$panel, _this6$$refs$panel$qu;
          (_this6$$refs$panel = _this6.$refs.panel) === null || _this6$$refs$panel === void 0 ? void 0 : (_this6$$refs$panel$qu = _this6$$refs$panel.querySelector('button')) === null || _this6$$refs$panel$qu === void 0 ? void 0 : _this6$$refs$panel$qu.focus();
        });
      }
    },
    close: function close() {
      var _this7 = this;
      if (!this.dropdownOpen) return;
      this.dropdownOpen = false;
      this.$nextTick(function () {
        var _this7$$refs$trigger;
        (_this7$$refs$trigger = _this7.$refs.trigger) === null || _this7$$refs$trigger === void 0 ? void 0 : _this7$$refs$trigger.focus();
      });
    },
    destroy: function destroy() {
      clearInterval(this._interval);
      this._clearExploreTimers();
    }
  };
}
;// CONCATENATED MODULE: ./src/js/bundles/snippets/global-status-banner.js
/**
 * Global status banner behaviour.
 *
 * The markup and the message text live in snippets/global-status-banner.liquid and are populated
 * while the document is still parsing. This module owns focus and the fallback announcement only,
 * so the message is spoken exactly once:
 *  - primary: move focus to the message. A focus move is the only announcement that is reliable
 *    after a navigation (a polite live-region update lands in the queue behind the screen reader's
 *    own page-load speech and gets dropped). It also parks the VoiceOver cursor on the message, so
 *    the toast is findable rather than something the visitor has to hunt for.
 *  - fallback: write to the assertive sr-only region, but only when no focus attempt landed.
 *
 * Two timing lessons from testing this on Safari/macOS with VoiceOver:
 *  - Focus must wait for `load`. Focusing earlier got the message announced TWICE: VoiceOver
 *    re-announces the focused node when the page settles under it, and the theme mutates text
 *    nodes document-wide 500ms after load (the deferred trademark-superscript pass in theme.js).
 *  - A focus move does NOT stop VoiceOver's "Automatically speak the web page" read-through. That
 *    is a VoiceOver preference with no page-side lever, and it reads the banner a further time as
 *    ordinary page content because the banner sits at the top of <body>.
 */

var BANNER_ID = 'global-status-banner';
var TEXT_ID = 'global-status-banner-text';

// Third-party scripts (Attentive, Klaviyo, Rebuy, BugHerd) can claim focus around load. One short
// retry only: a late focus move would yank a screen reader user who has started navigating.
var FOCUS_RETRY_DELAY = 300;
var FALLBACK_ANNOUNCE_DELAY = 700;
var LIVE_REGION_REGISTER_DELAY = 150;

// Built on demand, never shipped in the markup: an empty aria-live div is exposed to the a11y tree
// and VoiceOver reads it as "empty group" on every page it appears on.
var announceViaLiveRegion = function announceViaLiveRegion(message) {
  var liveRegion = document.createElement('div');
  liveRegion.className = 'sr-only';
  liveRegion.setAttribute('aria-live', 'assertive');
  liveRegion.setAttribute('aria-atomic', 'true');
  document.body.appendChild(liveRegion);

  // Populate a beat after insertion so the region is registered before it changes.
  window.setTimeout(function () {
    liveRegion.textContent = message;
  }, LIVE_REGION_REGISTER_DELAY);
};
var init = function init() {
  var banner = document.getElementById(BANNER_ID);
  if (!banner || banner.dataset.statusActive !== 'true') return;
  var target = document.getElementById(TEXT_ID);
  var message = target === null || target === void 0 ? void 0 : target.textContent.trim();
  if (!message) return;
  var announcedByFocus = false;
  var userInteracted = false;
  var markInteracted = function markInteracted() {
    userInteracted = true;
  };
  ['keydown', 'pointerdown', 'wheel', 'touchstart'].forEach(function (type) {
    window.addEventListener(type, markInteracted, {
      once: true,
      capture: true,
      passive: true
    });
  });
  var focusMessage = function focusMessage() {
    if (announcedByFocus || banner.hidden) return;

    // The only thing we refuse to interrupt is the visitor. Anything else holding focus at this
    // point was put there by a script (Klaviyo, Attentive, Rebuy), and the confirmation of an
    // action the visitor just took outranks it — so we do take focus back from those.
    if (userInteracted) return;
    if (document.activeElement === target) {
      // Re-focusing an already-focused node fires no event, so it is announced already.
      announcedByFocus = true;
      return;
    }
    target.focus({
      preventScroll: true
    });
    announcedByFocus = document.activeElement === target;
  };
  var announce = function announce() {
    window.requestAnimationFrame(focusMessage);
    window.setTimeout(focusMessage, FOCUS_RETRY_DELAY);
    window.setTimeout(function () {
      if (announcedByFocus) return;
      announceViaLiveRegion(message);
    }, FALLBACK_ANNOUNCE_DELAY);
  };

  // Wait for `load`: see the timing note at the top of this file. The banner is already visible by
  // then — it is server-rendered content, so nothing is hidden from sighted users while we wait.
  if (document.readyState === 'complete') {
    announce();
    return;
  }
  window.addEventListener('load', announce, {
    once: true
  });
};
var setup = function setup() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
    return;
  }
  init();
};
/* harmony default export */ const global_status_banner = ({
  setup: setup
});
;// CONCATENATED MODULE: ./src/js/bundles/snippets/account-menu.js

var account_menu_dom = {
  accountLink: 'data-account-nav-link'
};
var account_menu_setup = function setup() {
  var href = window.location.href;
  if (!href.includes('/tools/recurring') && !href.includes('/account')) {
    return;
  }
  var links = document.querySelectorAll("[".concat(account_menu_dom.accountLink, "]")) || [];
  var activeLink = (0,toConsumableArray/* default */.Z)(links).reverse().find(function (link) {
    var linkURL = link.getAttribute(account_menu_dom.accountLink);
    if (href.includes(linkURL)) {
      return true;
    }
    return false;
  }) || false;
  (0,toConsumableArray/* default */.Z)(links).forEach(function (link) {
    var linkAnchor = link.querySelector('a');
    if (linkAnchor) {
      linkAnchor.removeAttribute('aria-current');
    }
  });
  activeLink && activeLink.classList.add('active');
  if (activeLink) {
    var activeLinkAnchor = activeLink.querySelector('a');
    if (activeLinkAnchor) {
      activeLinkAnchor.setAttribute('aria-current', 'page');
    }
  }

  // Set selected option in the default HTML select based on current URL
  var selectElement = document.getElementById('accountNav');
  if (selectElement) {
    var selectOptions = selectElement.querySelectorAll('option') || [];
    var found = false;
    (0,toConsumableArray/* default */.Z)(selectOptions).reverse().forEach(function (option) {
      if (href.includes(option.value) && found === false) {
        option.setAttribute('selected', 'selected');
        found = true;
      }
    });
  }

  /* BACKUP: CUSTOM SELECT IMPLEMENTATION (COMMENTED OUT FOR ADA COMPLIANCE)
  // CUSTOM SELECT
  let numOfParentOptions, parentSelElmnt, selectDiv, pseudoSelectDiv, pseudoOptionDiv;
  const parentSelectContainers = document.getElementsByClassName('gh-custom-select');
  const pSelContLen = parentSelectContainers.length;
  for (let i = 0; i < pSelContLen; i++) {
    parentSelElmnt = parentSelectContainers[i].getElementsByTagName('select')[0];
    numOfParentOptions = parentSelElmnt.length;
    selectDiv = document.createElement('div');
    selectDiv.setAttribute('class', 'select-selected');
    const selectedText = parentSelElmnt.options[parentSelElmnt.selectedIndex].innerHTML;
    selectDiv.innerHTML = selectedText;
    parentSelectContainers[i].appendChild(selectDiv);
    pseudoSelectDiv = document.createElement('div');
    pseudoSelectDiv.setAttribute('class', 'select-items');
    for (let j = 0; j < numOfParentOptions; j++) {
      const pseudoOptionHref = parentSelElmnt.options[j].value;
      const pseudoOptionTitle = parentSelElmnt.options[j].innerHTML;
      const pseudoOptionClasses = parentSelElmnt.options[j].className;
      if (pseudoOptionTitle !== selectedText) {
        pseudoOptionDiv = document.createElement('div');
        pseudoOptionDiv.innerHTML = `<a class="${pseudoOptionClasses}" href="${pseudoOptionHref}">${pseudoOptionTitle}</a>`;
        pseudoSelectDiv.appendChild(pseudoOptionDiv);
      }
    }
    parentSelectContainers[i].appendChild(pseudoSelectDiv);
    selectDiv.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('active');
      this.classList.toggle('select-arrow-active');
    });
  }
  // launches the spinner overlay and navigates to href
  pseudoSelectDiv.addEventListener('click', function (e) {
    e.target.parentElement.parentElement.classList.remove('active');
    const navSpinner = document.getElementById('rc__overlay');
    navSpinner.style.display = 'block';
    navSpinner.addEventListener('click', function () {
      navSpinner.style.display = 'none';
    });
    if (e.target.tagName === 'DIV') {
      window.location.replace(e.target.firstChild.href);
    } else {
      window.location.replace(e.target.href);
    }
    e.preventDefault();
  });
   function closeAllSelect(elmnt) {
    let i;
    const arrNo = [];
    const x = document.getElementsByClassName('select-items');
    const y = document.getElementsByClassName('select-selected');
    const xl = x.length;
    const yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) { // eslint-disable-line
        arrNo.push(i);
      } else {
        x[i].classList.remove('active');
        y[i].classList.remove('select-arrow-active');
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('select-hide');
      }
    }
  }
  document.addEventListener('click', closeAllSelect);
  // END CUSTOM SELECT CODE
  */
};

/* harmony default export */ const account_menu = ({
  setup: account_menu_setup
});
;// CONCATENATED MODULE: ./src/js/bundles/layout/theme.js


/*
 * Basic file with global javascript.
 * Files imported here will be available on every page.
 */








 // tailwind
 // subscription account nav

/** Global Scripts */















/** Collection Scripts */
// import productsBrowser from '../sections/products-browser';
// import productsBrowserFacetsWrapper from '../snippets/products-browser-facets-wrapper.js';
// import productsBrowserFacet from '../snippets/products-browser-facet.js';
// import productsBrowserFacetSlider from '../snippets/products-browser-facet-slider.js';
// import productsBrowserSort from '../snippets/products-browser-sort';
// subscribeSave is lazy-loaded on intersection (see observer setup below).



/** Components */








// create an event listener here
document.addEventListener('cart-updated', function (_ref) {
  var detail = _ref.detail;
  var cartCountSelector = document.querySelector('.notification-badge');
  cartCountSelector.innerHTML = detail.cart.item_count;
});

/** Global Components */
module_esm/* default.plugin */.Z.plugin(dist_module_esm/* default */.Z);
module_esm/* default.data */.Z.data('navDesktop', navDesktopComponent);
module_esm/* default.data */.Z.data('navMobile', navMobileComponent);
module_esm/* default.data */.Z.data('drawerV2', drawer_v2);
module_esm/* default.data */.Z.data('responsiveImageV2', responsive_image_v2);
module_esm/* default.data */.Z.data('searchComponent', searchComponent);
module_esm/* default.data */.Z.data('productCard', product_card);
module_esm/* default.data */.Z.data('kyhSearchCombobox', kyhSearchCombobox);

/** Collection Components */
// Alpine.data('productsBrowser', productsBrowser);
// Alpine.data('productsBrowserFacet', productsBrowserFacet);
// Alpine.data('productsBrowserFacetSlider', productsBrowserFacetSlider);
// Alpine.data('productsBrowserFacetsWrapper', productsBrowserFacetsWrapper);
// Alpine.data('productsBrowserSort', productsBrowserSort);
module_esm/* default.data */.Z.data('subscribeSave', function () {
  return {
    products: [],
    allProducts: [],
    isLoading: true,
    error: null,
    hasLoaded: false,
    selectedBenefit: 'all',
    get availableBenefits() {
      return [];
    },
    init: function init() {},
    refresh: function refresh() {},
    filterByBenefit: function filterByBenefit() {}
  };
});
module_esm/* default.data */.Z.data('plpCompareComponent', plpCompareComponent);
module_esm/* default.data */.Z.data('compareLoadProductData', compare_shared/* loadProductData */.zp);
// Compare modal expects "loadProductData" - register alias for PLP (PDP registers it via loadPdpPageComponents)
module_esm/* default.data */.Z.data('loadProductData', compare_shared/* loadProductData */.zp);

/** Account creation success banner — markup and gating live in snippets/global-status-banner.liquid */

global_status_banner.setup();

/** Account Nav  */


document.addEventListener('DOMContentLoaded', function () {
  account_menu.setup();
});

/** Blogs & Articles  */
module_esm/* default.data */.Z.data('blogsSection', function () {
  return {
    loading: true,
    blogCategories: [],
    articles: [],
    showAllCategories: false,
    showResults: false,
    searchResults: [],
    searchTerm: '',
    init: function init() {},
    search: function search() {},
    isActiveRoute: function isActiveRoute() {
      return false;
    }
  };
});
loadIfExists('[x-data="blogsSection"]', function () {
  return __webpack_require__.e(/* import() | blog-section */ 314).then(__webpack_require__.bind(__webpack_require__, 3908)).then(function (_ref2) {
    var blogsSection = _ref2["default"];
    module_esm/* default.data */.Z.data('blogsSection', blogsSection);
    document.querySelectorAll('[x-data^="blogsSection"]').forEach(function (el) {
      module_esm/* default.destroyTree */.Z.destroyTree(el);
      module_esm/* default.initTree */.Z.initTree(el);
    });
  });
});

/** Extra Components */
module_esm/* default.data */.Z.data('productExplorer', product_explorer);
module_esm/* default.data */.Z.data('impactReportHeader', impactReportHeader);
var navStoreInstance = navStore();
module_esm/* default.store */.Z.store('nav', navStoreInstance);

/** Cart store stubs — prevents Alpine errors before async cart modules load.
 *  Real implementations are merged in via loadCartComponents(). */
module_esm/* default.store */.Z.store('cart', {
  cartData: null,
  normalizedCartQty: 0,
  lineItemsNormalized: []
});
module_esm/* default.store */.Z.store('rebuyCart', {
  itemCount: 0
});
module_esm/* default.store */.Z.store('quickBuyModal', {
  isVisible: false,
  dialog: null,
  set_dialog: function set_dialog(dialog) {
    this.dialog = dialog;
  },
  loadModal: function loadModal() {},
  hide: function hide() {},
  show: function show() {}
});

// No global compare store needed - components handle their own state

module_esm/* default.plugin */.Z.plugin(x_on_shopify);
evaluateScreenSize();
stickyHeader();
algoliaHandler().init();
initKyhSearch();
promoBarCarousel();
herbFinder();
initIngredientList();
initProductGrid();
loadIfExists('.landing-page__newsletter-form, .footer__newsletterForm', function () {
  return __webpack_require__.e(/* import() | landing-page-newsletter */ 738).then(__webpack_require__.bind(__webpack_require__, 7503)).then(function (_ref3) {
    var changePlaceholderText = _ref3.changePlaceholderText;
    changePlaceholderText();
  });
});
initFeaturedProduct();
initKyhRebuyProductsCarousel();

/*
  Observe the Email sign-up popup coming from the Attentive app
  to make it appear behind the Rebuy Cart.
*/
(0,dom/* observeAttentiveOverlay */.Vx)();

// Lazy-load subscribe/save Alpine component only when section is in or near viewport.
observeElement('[data-subscribe-save-section]', function () {
  __webpack_require__.e(/* import() | subscribe-save */ 26).then(__webpack_require__.bind(__webpack_require__, 6993)).then(function (_ref4) {
    var subscribeSave = _ref4["default"];
    module_esm/* default.data */.Z.data('subscribeSave', subscribeSave);
    document.querySelectorAll('[x-data^="subscribeSave("]').forEach(function (el) {
      module_esm/* default.destroyTree */.Z.destroyTree(el);
      module_esm/* default.initTree */.Z.initTree(el);
    });
  });
});

// Lazy-load carousel components only when they scroll near the viewport.
// Swiper JS + CSS are already loaded statically (imports at top of this file),
// so carousels only need their own init chunk fetched on intersection.
var carouselObserverOptions = {
  rootMargin: '300px'
};
observeElement('.product-list-grid-section', function () {
  Promise.all(/* import() | product-grid-carousel */[__webpack_require__.e(604), __webpack_require__.e(549)]).then(__webpack_require__.bind(__webpack_require__, 591)).then(function (_ref5) {
    var productGridCarousel = _ref5.productGridCarousel;
    productGridCarousel();
  });
}, {
  rootMargin: '500px'
});
observeElement('.customer-testimonials', function () {
  Promise.all(/* import() | testimonials-carousel */[__webpack_require__.e(604), __webpack_require__.e(683)]).then(__webpack_require__.bind(__webpack_require__, 8270)).then(function (_ref6) {
    var testimonialsCarousel = _ref6.testimonialsCarousel;
    testimonialsCarousel();
  });
}, carouselObserverOptions);
observeElement('.blog-list-grid', function () {
  Promise.all(/* import() | blog-grid-carousel */[__webpack_require__.e(604), __webpack_require__.e(301)]).then(__webpack_require__.bind(__webpack_require__, 5599)).then(function (_ref7) {
    var blogGridCarousel = _ref7.blogGridCarousel;
    blogGridCarousel();
  });
}, carouselObserverOptions);
observeElement('.review_carousel__container', function () {
  __webpack_require__.e(/* import() | reviews-carousel */ 635).then(__webpack_require__.bind(__webpack_require__, 5267)).then(function (_ref8) {
    var initTestimonialCarousel = _ref8.initTestimonialCarousel;
    initTestimonialCarousel();
  });
}, carouselObserverOptions);
observeElement('.image-carousel__container', function () {
  __webpack_require__.e(/* import() | image-carousel */ 268).then(__webpack_require__.bind(__webpack_require__, 5189)).then(function (_ref9) {
    var initImageCarousel = _ref9.initImageCarousel;
    initImageCarousel();
  });
}, carouselObserverOptions);
observeElement('.desktop-steps', function () {
  Promise.all(/* import() | content-with-steps */[__webpack_require__.e(604), __webpack_require__.e(653)]).then(__webpack_require__.bind(__webpack_require__, 6734)).then(function (_ref10) {
    var desktopStepsSlider = _ref10.desktopStepsSlider;
    desktopStepsSlider();
  });
}, carouselObserverOptions);
observeElement('.thumbnail__container', function () {
  __webpack_require__.e(/* import() | thumbnail-content */ 988).then(__webpack_require__.bind(__webpack_require__, 3981)).then(function (_ref11) {
    var initThumbnailSwiper = _ref11.initThumbnailSwiper;
    initThumbnailSwiper();
  });
}, carouselObserverOptions);
window.Alpine = module_esm/* default */.Z;
var isProductPage = window.CURRENT_TEMPLATE === 'product';
(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
  var _yield$import, kyhIngredientsPdp;
  return regenerator_default().wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!isProductPage) {
          _context.next = 3;
          break;
        }
        _context.next = 3;
        return (0,pdp_components.loadPdpPageComponents)(module_esm/* default */.Z);
      case 3:
        if (!document.querySelector('.kyh-ingredients-pdp')) {
          _context.next = 9;
          break;
        }
        _context.next = 6;
        return Promise.all(/* import() | kyh-ingredients-pdp */[__webpack_require__.e(604), __webpack_require__.e(702)]).then(__webpack_require__.bind(__webpack_require__, 3634));
      case 6:
        _yield$import = _context.sent;
        kyhIngredientsPdp = _yield$import["default"];
        module_esm/* default.data */.Z.data('kyhIngredientsPdp', kyhIngredientsPdp);
      case 9:
        module_esm/* default.start */.Z.start();

        // Defer cart chunk to a separate macrotask so the browser can paint and
        // become interactive before cart JS parses and executes.
        // Cart UI is hidden until user interaction, so the delay is imperceptible.
        setTimeout(function () {
          return loadCartComponents(module_esm/* default */.Z);
        }, 100);
      case 11:
      case "end":
        return _context.stop();
    }
  }, _callee);
}))();

// Load KYH Product Card SuppCo widget customization when section exists on the page.
// Uses loadIfExists (not observeElement) because the SuppCo widget renders asynchronously
// and we must attach the MutationObserver before it finishes.
loadIfExists('.know-your-herbs-product-card', function () {
  return __webpack_require__.e(/* import() | kyh-product-card */ 599).then(__webpack_require__.bind(__webpack_require__, 4189)).then(function (_ref13) {
    var initKyhProductCard = _ref13.initKyhProductCard;
    initKyhProductCard();
  });
});

// Wrap ®, ™, © symbols in <sup> after 1 s so they appear as proper superscripts.
setTimeout(function () {
  return __webpack_require__.e(/* import() */ 243).then(__webpack_require__.bind(__webpack_require__, 8243)).then(function (_ref14) {
    var wrapTrademarkSymbols = _ref14.wrapTrademarkSymbols;
    return wrapTrademarkSymbols();
  });
}, 500);

// // BUGHERD
if (window.location.hostname !== '127.0.0.1' && !window.Shopify.designMode && window.Shopify.theme.role !== 'main') {
  var script = document.createElement('script');
  script.src = 'https://www.bugherd.com/sidebarv2.js?apikey=czwfalkp21nfn9k6j07x4q';
  document.head.append(script);
}

/***/ }),

/***/ 9750:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qe": () => (/* binding */ createCompareBase),
/* harmony export */   "tJ": () => (/* binding */ compareProductsSwiperConfig),
/* harmony export */   "zp": () => (/* binding */ loadProductData)
/* harmony export */ });
/* unused harmony exports STORAGE_KEY, STORAGE_PAGE_KEY, MAX_COMPARE_ITEMS */
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2167);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5861);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4687);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2799);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8372);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var STORAGE_KEY = 'nms.compare.items';
var STORAGE_PAGE_KEY = 'nms.compare.page';
var MAX_COMPARE_ITEMS = 4;

// Swiper config for compare products popup (shared between PLP and PDP)
var compareProductsSwiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  watchSlidesProgress: true,
  slideVisibleClass: 'swiper-slide-visible',
  autoHeight: false,
  modules: [swiper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, swiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z],
  enabled: true,
  a11y: {
    enabled: true,
    prevSlideMessage: 'Previous compared product',
    nextSlideMessage: 'Next compared product',
    firstSlideMessage: 'This is the first compared product',
    lastSlideMessage: 'This is the last compared product'
  },
  mousewheel: {
    forceToAxis: true
  },
  breakpoints: {
    320: {
      slidesPerView: 2.5,
      spaceBetween: 30,
      enabled: true
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 20,
      enabled: true
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 24,
      enabled: true
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 40,
      enabled: true
    }
  }
};

// Product data loader for comparison modal - following quick-buy-modal pattern
var loadProductData = function loadProductData(handle) {
  return {
    loading: true,
    productHtml: '',
    init: function init() {
      var _this = this;
      return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!handle) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.fetchProductSection(handle);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchProductSection: function fetchProductSection(handle) {
      var _this2 = this;
      return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
        var _yield$import, loadPdpCoreComponents, pdpCoreReady, response, productHtml;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _this2.loading = true;

              // Load PDP components (heroProduct, heroProductAdd, buybox) so the fetched HTML initializes
              // with One Time / Subscription options - required for non-PDP pages (e.g. PLP compare modal)
              _context2.next = 4;
              return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9442));
            case 4:
              _yield$import = _context2.sent;
              loadPdpCoreComponents = _yield$import.loadPdpCoreComponents;
              pdpCoreReady = loadPdpCoreComponents(window.Alpine);
              _context2.next = 9;
              return fetch("/products/".concat(handle, "?section_id=quick-buy-product"));
            case 9:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 12;
                break;
              }
              throw new Error('Product not found');
            case 12:
              _context2.next = 14;
              return response.text();
            case 14:
              productHtml = _context2.sent;
              _context2.next = 17;
              return pdpCoreReady;
            case 17:
              _this2.productHtml = productHtml;
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](0);
              _this2.productHtml = '';
            case 23:
              _context2.prev = 23;
              _this2.loading = false;
              return _context2.finish(23);
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 20, 23, 26]]);
      }))();
    }
  };
};

/**
 * Creates the shared base object for compare components (PLP & PDP).
 * Returns a plain object with state, getters, and shared methods.
 * Callers add context-specific properties (init, destroy, swiper init, etc.).
 */
function createCompareBase() {
  return {
    // Shared state
    selectedProducts: [],
    showCompareModal: false,
    addingToCart: null,
    // Computed
    get selectedCount() {
      return this.selectedProducts.length;
    },
    get canCompare() {
      return this.selectedProducts.length >= 2;
    },
    get isMaxSelected() {
      return this.selectedProducts.length >= MAX_COMPARE_ITEMS;
    },
    get compareTitle() {
      return "Compare Products (".concat(this.selectedCount, ")");
    },
    get compareSlots() {
      var slots = [];
      for (var i = 0; i < MAX_COMPARE_ITEMS; i++) {
        slots.push({
          product: this.selectedProducts[i] || null
        });
      }
      return slots;
    },
    // Shared methods
    isProductSelected: function isProductSelected(productId) {
      return this.selectedProducts.some(function (p) {
        return p.id === productId;
      });
    },
    checkPageChange: function checkPageChange() {
      var currentPage = window.location.pathname;
      var storedPage = sessionStorage.getItem(STORAGE_PAGE_KEY);
      if (storedPage && storedPage !== currentPage) {
        this.clearStorage();
        this.selectedProducts = [];
      }
    },
    setupPageNavigationListener: function setupPageNavigationListener() {
      var _this3 = this;
      sessionStorage.setItem(STORAGE_PAGE_KEY, window.location.pathname);
      this.beforeUnloadHandler = function () {
        sessionStorage.setItem('nms.compare.navigating', 'true');
      };
      this.pageShowHandler = function () {
        var isNavigating = sessionStorage.getItem('nms.compare.navigating');
        if (isNavigating === 'true') {
          sessionStorage.removeItem('nms.compare.navigating');
          _this3.checkPageChange();
        }
      };
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
      window.addEventListener('pageshow', this.pageShowHandler);
    },
    loadFromStorage: function loadFromStorage() {
      try {
        var stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
          this.selectedProducts = JSON.parse(stored);
        }
      } catch (error) {
        this.selectedProducts = [];
      }
    },
    saveToStorage: function saveToStorage() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.selectedProducts));
        sessionStorage.setItem(STORAGE_PAGE_KEY, window.location.pathname);
      } catch (error) {
        // Failed to save compare products to storage
      }
    },
    toggleProduct: function toggleProduct(productData) {
      var existingIndex = this.selectedProducts.findIndex(function (p) {
        return p.id === productData.id;
      });
      if (existingIndex > -1) {
        this.selectedProducts.splice(existingIndex, 1);
      } else if (!this.isMaxSelected) {
        var displayPrice = productData.price;
        if (productData.variantsCount && parseInt(productData.variantsCount) > 1) {
          var priceMin = productData.priceMin;
          var priceMax = productData.priceMax;
          if (priceMin && priceMax && priceMin !== priceMax) {
            displayPrice = "".concat(priceMin, " - ").concat(priceMax);
          }
        }
        this.selectedProducts.push(_objectSpread(_objectSpread({}, productData), {}, {
          price: displayPrice
        }));
      }
      this.saveToStorage();
      this.announceCount();
    },
    removeProduct: function removeProduct(productId) {
      var index = this.selectedProducts.findIndex(function (p) {
        return p.id === productId;
      });
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
        this.saveToStorage();
        if (this.showCompareModal && this.selectedProducts.length === 0) {
          this.closeCompareModal();
        }
      }
    },
    clearStorage: function clearStorage() {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_PAGE_KEY);
      } catch (error) {
        // Failed to clear storage
      }
    },
    clearAll: function clearAll() {
      this.selectedProducts = [];
      this.clearStorage();
      if (this.showCompareModal) {
        this.closeCompareModal();
      }
    },
    closeCompareModal: function closeCompareModal() {
      this.showCompareModal = false;
    },
    announceCount: function announceCount() {
      var ariaLive = document.querySelector('[data-compare-count-live]');
      if (ariaLive) {
        ariaLive.textContent = "".concat(this.selectedCount, " products selected for comparison");
      }
    },
    addToCart: function addToCart(productHandle) {
      var _this4 = this;
      return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3() {
        var response, productData, availableVariant, addResponse, errorData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.addingToCart = productHandle;
              _context3.prev = 1;
              _context3.next = 4;
              return fetch("".concat(window.Shopify.routes.root, "products/").concat(productHandle, ".js"));
            case 4:
              response = _context3.sent;
              if (response.ok) {
                _context3.next = 7;
                break;
              }
              throw new Error('Failed to fetch product data');
            case 7:
              _context3.next = 9;
              return response.json();
            case 9:
              productData = _context3.sent;
              availableVariant = productData.variants.find(function (variant) {
                return variant.available;
              });
              if (availableVariant) {
                _context3.next = 13;
                break;
              }
              throw new Error('Product is out of stock');
            case 13:
              _context3.next = 15;
              return fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: [{
                    id: availableVariant.id,
                    quantity: 1
                  }]
                })
              });
            case 15:
              addResponse = _context3.sent;
              if (addResponse.ok) {
                _context3.next = 21;
                break;
              }
              _context3.next = 19;
              return addResponse.json();
            case 19:
              errorData = _context3.sent;
              throw new Error(errorData.message || errorData.description || 'Failed to add to cart');
            case 21:
              if (!(_this4.$store && _this4.$store.cart)) {
                _context3.next = 26;
                break;
              }
              _context3.next = 24;
              return _this4.$store.cart.fetchCart();
            case 24:
              _context3.next = 29;
              break;
            case 26:
              if (!(window.Alpine && window.Alpine.store('cart'))) {
                _context3.next = 29;
                break;
              }
              _context3.next = 29;
              return window.Alpine.store('cart').fetchCart();
            case 29:
              _context3.next = 35;
              break;
            case 31:
              _context3.prev = 31;
              _context3.t0 = _context3["catch"](1);
              // eslint-disable-next-line no-console
              console.error('Error adding to cart:', _context3.t0);
              alert(_context3.t0.message || 'Failed to add product to cart');
            case 35:
              _context3.prev = 35;
              _this4.addingToCart = null;
              return _context3.finish(35);
            case 38:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 31, 35, 38]]);
      }))();
    }
  };
}

/***/ }),

/***/ 2090:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vx": () => (/* binding */ observeAttentiveOverlay),
/* harmony export */   "pn": () => (/* binding */ disableScrollForInputDrawer),
/* harmony export */   "ye": () => (/* binding */ enableScrollForInputDrawer)
/* harmony export */ });
var scrollPosition = 0;
function disableScrollForInputDrawer() {
  scrollPosition = window.scrollY; // Save the current scroll position

  // Lock the body scroll by setting position fixed and top
  document.body.style.position = 'fixed';
  document.body.style.top = "-".concat(scrollPosition, "px");
  document.body.style.width = '100%'; // Prevent horizontal scrollbar
}

function enableScrollForInputDrawer() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollPosition); // Restore the scroll position

  scrollPosition = 0; // Reset scroll position
}

function observeAttentiveOverlay() {
  var attentiveObserver = new MutationObserver(function () {
    var attentiveOverlay = document.getElementById('attentive_overlay');
    if (attentiveOverlay) {
      attentiveOverlay.style.setProperty('z-index', '99999999');
      attentiveObserver.disconnect(); // Stop observing
    }
  });

  // Start observing
  attentiveObserver.observe(document.body, {
    childList: true
  });
}

/***/ }),

/***/ 2575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ot": () => (/* binding */ createDebouncer),
/* harmony export */   "WY": () => (/* binding */ request),
/* harmony export */   "YC": () => (/* binding */ sortAlpha),
/* harmony export */   "Zq": () => (/* binding */ arrayChunk),
/* harmony export */   "a": () => (/* binding */ pDefer),
/* harmony export */   "yJ": () => (/* binding */ convertToCamelCase)
/* harmony export */ });
/* unused harmony export remToPixel */
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1002);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9611);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5861);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4687);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);




function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), (0,_babel_runtime_helpers_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) k++; groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args[args.length - 1]) && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

var remToPixel = function remToPixel(rem) {
  var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
  var pixels = rem * rootFontSize;
  return pixels;
};
var createDebouncer = function createDebouncer(wait) {
  return function (fn) {
    var i = 0;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var currentI = ++i;
      wait(function () {
        if (currentI === i) {
          fn.apply(void 0, args);
        }
      });
    };
  };
};

// https://stackoverflow.com/questions/8495687/split-array-into-chunks#comment84212474_8495740
var arrayChunk = function arrayChunk(array, chunkSize) {
  return Array(Math.ceil(array.length / chunkSize)).fill().map(function (_, index) {
    return index * chunkSize;
  }).map(function (begin) {
    return array.slice(begin, begin + chunkSize);
  });
};
var request = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee(url, params) {
    var res, responseError;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(url, params);
        case 2:
          res = _context.sent;
          if (res.ok) {
            _context.next = 9;
            break;
          }
          _context.next = 6;
          return res.json();
        case 6:
          responseError = _context.sent;
          console.error("NETWORK RESPONSE ERROR -- ".concat(responseError.status, ": "), responseError);
          throw responseError;
        case 9:
          return _context.abrupt("return", res.json());
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function request(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var convertToCamelCase = function convertToCamelCase(string) {
  if (!string) {
    return '';
  }
  return string.replace( /*#__PURE__*/_wrapRegExp(/.\b(\w)/g, {
    word: 1
  }), function (_, $1) {
    return $1.toUpperCase();
  }).replace(/[\s:'"]/g, '').replace( /*#__PURE__*/_wrapRegExp(/^((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/, {
    rest: 1
  }), function (_, $1) {
    return $1.toLowerCase();
  });
};

// https://github.com/sindresorhus/p-defer/blob/0abf7f56337a450cbff45074dd8c83f8ace4726c/index.js
var pDefer = function pDefer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};
var sortAlpha = function sortAlpha(arry, key) {
  return arry.sort(function (a, b) {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};

/***/ }),

/***/ 9442:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "loadPdpCoreComponents": () => (/* binding */ loadPdpCoreComponents),
/* harmony export */   "loadPdpPageComponents": () => (/* binding */ loadPdpPageComponents)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(885);

var pdpCorePromise;
var pdpPagePromise;

/**
 * Loads and registers the minimal Alpine components required for product purchase flows.
 * Needed for:
 * - Product page (PDP)
 * - Quick Buy modal (renders product section HTML with heroProduct/heroProductAdd)
 */
function loadPdpCoreComponents(Alpine) {
  var alpine = Alpine || window.Alpine;
  if (!alpine) {
    throw new Error('Alpine is not available. Ensure window.Alpine is set before loading PDP components.');
  }
  if (pdpCorePromise) return pdpCorePromise;
  pdpCorePromise = Promise.all([__webpack_require__.e(/* import() | pdp-core */ 684).then(__webpack_require__.bind(__webpack_require__, 2729)), __webpack_require__.e(/* import() | pdp-core */ 684).then(__webpack_require__.bind(__webpack_require__, 6590)), __webpack_require__.e(/* import() | pdp-core */ 684).then(__webpack_require__.bind(__webpack_require__, 9781)), __webpack_require__.e(/* import() | pdp-core */ 684).then(__webpack_require__.bind(__webpack_require__, 2150))]).then(function (_ref) {
    var _ref2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, 4),
      heroProduct = _ref2[0]["default"],
      heroProductAdd = _ref2[1]["default"],
      productData = _ref2[2].productData,
      productTrustScore = _ref2[3].productTrustScore;
    alpine.data('heroProduct', heroProduct);
    alpine.data('heroProductAdd', heroProductAdd);
    alpine.data('productData', productData);
    alpine.data('productTrustScore', productTrustScore);
  });
  return pdpCorePromise;
}

/**
 * Loads and registers PDP-only Alpine components (gallery, modal, accordions, PDP compare,
 * and the `product-media-carousel` theme block).
 * Must be executed BEFORE Alpine.start() on product pages to avoid "Unknown component" issues.
 */
function loadPdpPageComponents(Alpine) {
  var alpine = Alpine || window.Alpine;
  if (!alpine) {
    throw new Error('Alpine is not available. Ensure window.Alpine is set before loading PDP components.');
  }
  if (pdpPagePromise) return pdpPagePromise;
  pdpPagePromise = loadPdpCoreComponents(alpine).then(function () {
    return Promise.all([Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 5246)), Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 3801)), Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 1842)), Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 1745)), Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 9426)), Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 5850)), Promise.all(/* import() | pdp */[__webpack_require__.e(604), __webpack_require__.e(600)]).then(__webpack_require__.bind(__webpack_require__, 7540))]).then(function (_ref3) {
      var _ref4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref3, 7),
        heroProductGallery = _ref4[0]["default"],
        heroProductGalleryModal = _ref4[1]["default"],
        heroProductInfo = _ref4[2]["default"],
        heroProductAccordion = _ref4[3]["default"],
        _ref4$ = _ref4[4],
        pdpCompareComponent = _ref4$.pdpCompareComponent,
        loadProductData = _ref4$.loadProductData,
        productMediaCarousel = _ref4[5]["default"],
        infoAccordion = _ref4[6]["default"];
      alpine.data('heroProductGallery', heroProductGallery);
      alpine.data('heroProductGalleryModal', heroProductGalleryModal);
      alpine.data('heroProductInfo', heroProductInfo);
      alpine.data('heroProductAccordion', heroProductAccordion);
      alpine.data('pdpCompareComponent', pdpCompareComponent);
      alpine.data('loadProductData', loadProductData);
      alpine.data('productMediaCarousel', productMediaCarousel);
      alpine.data('infoAccordion', infoAccordion);
    });
  });
  return pdpPagePromise;
}

/***/ }),

/***/ 5072:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NO": () => (/* binding */ formatPriceRange),
/* harmony export */   "T4": () => (/* binding */ formatPrice),
/* harmony export */   "Zc": () => (/* binding */ productsData),
/* harmony export */   "hd": () => (/* binding */ fetchRecommendedProducts),
/* harmony export */   "lA": () => (/* binding */ fetchCollection),
/* harmony export */   "on": () => (/* binding */ fetchSearch),
/* harmony export */   "t2": () => (/* binding */ fetchProducts)
/* harmony export */ });
/* unused harmony exports variantsData, fetchColorMetaobjects */
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2167);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2982);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5861);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4687);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2575);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var _window = window,
  STOREFRONT_ACCESS_TOKEN = _window.STOREFRONT_ACCESS_TOKEN;

// https://github.com/sindresorhus/p-defer/blob/0abf7f56337a450cbff45074dd8c83f8ace4726c/index.js
var pDefer = function pDefer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};
var STOREFRONT_PRODUCT_QUERY = /* GraphQL */"\n  fragment ProductFields on Product {\n    id\n    title\n    description\n    handle\n    tags\n    onlineStoreUrl\n    availableForSale\n    productType\n    options {\n      id\n      name\n      values\n    }\n    priceRange {\n      maxVariantPrice {\n        amount\n        currencyCode\n      }\n      minVariantPrice {\n        amount\n        currencyCode\n      }\n    }\n\n    compareAtPriceRange {\n      maxVariantPrice {\n        amount\n        currencyCode\n      }\n      minVariantPrice {\n        amount\n        currencyCode\n      }\n    }\n\n    category: metafield(namespace: \"custom\", key: \"category\") {\n      value\n    }\n\n    color: metafield(namespace: \"custom\", key: \"color\") {\n      value\n    }\n\n    trustscore_rating: metafield(namespace: \"custom\", key: \"trustscore_rating\") {\n      value\n    }\n\n    images(first: 2) {\n      nodes {\n        id\n        altText\n        url\n      }\n    }\n\n    variants(first: 250) {\n      nodes {\n        id\n        sku\n        quantityAvailable\n        availableForSale\n        title\n\n        price {\n          amount\n          currencyCode\n        }\n\n        compareAtPrice {\n          amount\n          currencyCode\n        }\n\n        selectedOptions {\n          name\n          value\n        }\n\n        image {\n          url\n        }\n\n        trustscore: metafield(namespace: \"custom\", key: \"trustscore\") {\n          value\n        }\n\n        trustscore_rating: metafield(namespace: \"custom\", key: \"trustscore_rating\") {\n          value\n        }\n\n        metafield(namespace: \"custom\", key: \"color_swatch\") {\n          reference {\n            ... on Metaobject {\n              color_name: field(key: \"name\") {\n                value\n              }\n              color_code: field(key: \"color_code\") {\n                value\n              }\n              color_gradient: field(key: \"color_gradient\") {\n                value\n              }\n              color_image: field(key: \"image\") {\n                reference {\n                  ... on MediaImage {\n                    image {\n                      url\n                      altText\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        sellingPlanAllocations(first: 10) {\n          nodes {\n            priceAdjustments {\n              compareAtPrice {\n                amount\n                currencyCode\n              }\n              price {\n                amount\n                currencyCode\n              }\n            }\n            sellingPlan {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n\n    sellingPlanGroups(first: 10) {\n      nodes {\n        name\n        sellingPlans(first: 10) {\n          nodes {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n";
var STOREFRONT_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCT_QUERY, "\n  query Products(\n    $country: CountryCode!\n    $id1: ID!\n    $include2: Boolean!\n    $id2: ID\n    $include3: Boolean!\n    $id3: ID\n    $include4: Boolean!\n    $id4: ID\n    $include5: Boolean!\n    $id5: ID\n    $include6: Boolean!\n    $id6: ID\n    $include7: Boolean!\n    $id7: ID\n    $include8: Boolean!\n    $id8: ID\n    $include9: Boolean!\n    $id9: ID\n    $include10: Boolean!\n    $id10: ID\n  ) @inContext(country: $country) {\n    p1: product(id: $id1) {\n      ...ProductFields\n    }\n    p2: product(id: $id2) @include(if: $include2) {\n      ...ProductFields\n    }\n    p3: product(id: $id3) @include(if: $include3) {\n      ...ProductFields\n    }\n    p4: product(id: $id4) @include(if: $include4) {\n      ...ProductFields\n    }\n    p5: product(id: $id5) @include(if: $include5) {\n      ...ProductFields\n    }\n    p6: product(id: $id6) @include(if: $include6) {\n      ...ProductFields\n    }\n    p7: product(id: $id7) @include(if: $include7) {\n      ...ProductFields\n    }\n    p8: product(id: $id8) @include(if: $include8) {\n      ...ProductFields\n    }\n    p9: product(id: $id9) @include(if: $include9) {\n      ...ProductFields\n    }\n    p10: product(id: $id10) @include(if: $include10) {\n      ...ProductFields\n    }\n  }\n");
var productsData = {};
var variantsData = {};
var productsToFetch = new Set();
var productsInProgress = {};
var fetchDataBackground = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(ids, query, dataObject, inProgressDataObject, processItemFunction) {
    var chunks;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(ids.size === 0)) {
            _context2.next = 3;
            break;
          }
          // eslint-disable-next-line no-console
          console.warn('No data to fetch');
          return _context2.abrupt("return");
        case 3:
          chunks = (0,___WEBPACK_IMPORTED_MODULE_3__/* .arrayChunk */ .Zq)((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ids), 10);
          _context2.next = 6;
          return Promise.all(chunks.map( /*#__PURE__*/function () {
            var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(chunk) {
              var variables, data, error, res, _yield$res$json, d, errors;
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    variables = new Array(10).fill().reduce(function (acc, _, index) {
                      var id = chunk[index];
                      acc["id".concat(index + 1)] = id;
                      acc["include".concat(index + 1)] = !!id;
                      return acc;
                    }, {});
                    variables.country = Shopify.country;
                    _context.prev = 2;
                    _context.next = 5;
                    return fetch("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
                      },
                      body: JSON.stringify({
                        query: query,
                        variables: variables
                      })
                    });
                  case 5:
                    res = _context.sent;
                    _context.next = 8;
                    return res.json();
                  case 8:
                    _yield$res$json = _context.sent;
                    d = _yield$res$json.data;
                    errors = _yield$res$json.errors;
                    data = d;
                    if (!errors) {
                      _context.next = 14;
                      break;
                    }
                    throw new Error("Failed to fetch: ".concat(errors.map(function (error) {
                      return error.message;
                    }).join(', ')));
                  case 14:
                    _context.next = 20;
                    break;
                  case 16:
                    _context.prev = 16;
                    _context.t0 = _context["catch"](2);
                    // eslint-disable-next-line no-console
                    console.error(error);
                    error = _context.t0;
                  case 20:
                    if (!error) {
                      Object.values(data).filter(Boolean).forEach(processItemFunction);
                    }
                    chunk.forEach(function (id) {
                      var product = dataObject[id];
                      if (product) {
                        inProgressDataObject[id].resolve(product);
                      } else {
                        var err = error || new Error("".concat(id, " not found"));
                        inProgressDataObject[id].reject(err);
                      }
                      delete inProgressDataObject[id];
                    });
                  case 22:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[2, 16]]);
            }));
            return function (_x6) {
              return _ref2.apply(this, arguments);
            };
          }()));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchDataBackground(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var fetchData = /*#__PURE__*/function () {
  var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(ids, prefix, idsToFetchSet, dataObject, inProgressDataObject, fetchBackgroundFunction) {
    var normalizedIds, idsToFetch, idsInProgress;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          normalizedIds = ids.map(function (id) {
            if (typeof id === 'string' && id.startsWith(prefix)) {
              return id;
            }
            if (typeof id === 'number' || typeof id === 'string' && /^\d+$/.test(id)) {
              return "".concat(prefix).concat(id);
            }
          }).filter(Boolean);
          idsToFetch = normalizedIds.filter(function (id) {
            return !dataObject[id] && !inProgressDataObject[id];
          });
          idsToFetch.forEach(function (id) {
            idsToFetchSet.add(id);
            inProgressDataObject[id] = pDefer();
          });
          idsInProgress = normalizedIds.filter(function (id) {
            return inProgressDataObject[id];
          });
          if (idsToFetch.length > 0) {
            fetchBackgroundFunction();
          }
          if (!(idsInProgress.length > 0)) {
            _context3.next = 8;
            break;
          }
          _context3.next = 8;
          return Promise.all(idsInProgress.map(function (id) {
            return inProgressDataObject[id].promise;
          }));
        case 8:
          return _context3.abrupt("return", dataObject);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchData(_x7, _x8, _x9, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();
var priceFormatters = {};
var getPriceFormatter = function getPriceFormatter(currency) {
  if (!priceFormatters[currency]) {
    priceFormatters[currency] = new Intl.NumberFormat(Shopify.locale, {
      style: 'currency',
      currency: currency
    });
  }
  return priceFormatters[currency];
};
var formatPrice = function formatPrice(price) {
  var ignoreZeros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (ignoreZeros && Number(price.amount) === 0) {
    return '';
  }
  var priceFormatter = getPriceFormatter(price.currencyCode);
  return priceFormatter.format(price.amount);
};
var formatPriceRange = function formatPriceRange(min, max) {
  var ignoreZeros = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (min.amount === max.amount) {
    return formatPrice(min, ignoreZeros);
  }
  var priceFormatter = getPriceFormatter(min.currencyCode);
  if (priceFormatter.formatRange) {
    return priceFormatter.formatRange(min.amount, max.amount);
  }
  return "".concat(priceFormatter.format(min.amount), " - ").concat(priceFormatter.format(max.amount));
};
var formatProductPrices = function formatProductPrices(product) {
  var _product$sellingPlanG, _product$sellingPlanG2;
  product.priceRangeFormatted = formatPriceRange(product.priceRange.minVariantPrice, product.priceRange.maxVariantPrice);
  product.compareAtPriceRangeFormatted = formatPriceRange(product.compareAtPriceRange.minVariantPrice, product.compareAtPriceRange.maxVariantPrice, true);
  product.variants.forEach(function (variant) {
    var _variant$sellingPlanA, _variant$sellingPlanA2;
    variant.priceFormatted = formatPrice(variant.price);
    if (variant.compareAtPrice) {
      variant.compareAtPriceFormatted = formatPrice(variant.compareAtPrice, true);
    }

    // Add subscription pricing from selling plan allocations
    if (((_variant$sellingPlanA = variant.sellingPlanAllocations) === null || _variant$sellingPlanA === void 0 ? void 0 : (_variant$sellingPlanA2 = _variant$sellingPlanA.nodes) === null || _variant$sellingPlanA2 === void 0 ? void 0 : _variant$sellingPlanA2.length) > 0) {
      var _firstAllocation$pric;
      var firstAllocation = variant.sellingPlanAllocations.nodes[0];
      if ((_firstAllocation$pric = firstAllocation.priceAdjustments) !== null && _firstAllocation$pric !== void 0 && _firstAllocation$pric.price) {
        variant.sellingPlanAllocationsPrice = formatPrice(firstAllocation.priceAdjustments.price);
      }
    }
  });

  // Add selling plan groups processing
  if (((_product$sellingPlanG = product.sellingPlanGroups) === null || _product$sellingPlanG === void 0 ? void 0 : (_product$sellingPlanG2 = _product$sellingPlanG.nodes) === null || _product$sellingPlanG2 === void 0 ? void 0 : _product$sellingPlanG2.length) > 0) {
    product.sellingPlanGroups = product.sellingPlanGroups.nodes.map(function (group) {
      return _objectSpread(_objectSpread({}, group), {}, {
        selling_plans: group.sellingPlans.nodes
      });
    });
  }
};
var fetchProductsBackground = /*#__PURE__*/function () {
  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4() {
    var productsToFetchSet;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          productsToFetchSet = productsToFetch;
          productsToFetch = new Set();
          return _context4.abrupt("return", fetchDataBackground(productsToFetchSet, STOREFRONT_PRODUCTS_QUERY, productsData, productsInProgress, function (product) {
            product.variants = product.variants.nodes;
            formatProductPrices(product);
            product.images = product.images.nodes;
            productsData[product.id] = product;
            productsData[product.id.replace('gid://shopify/Product/', '')] = product;
            // product.variants.forEach((variant) => {
            //   variant.product = product;
            //   variantsData[variant.id] = variant;
            //   variantsData[variant.id.replace('gid://shopify/ProductVariant/', '')] = variant;
            // });
          }));
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function fetchProductsBackground() {
    return _ref4.apply(this, arguments);
  };
}();
var fetchProductsBackgroundDebounced = (0,___WEBPACK_IMPORTED_MODULE_3__/* .createDebouncer */ .Ot)(function (cb) {
  return setTimeout(cb, 0);
})(fetchProductsBackground);
var fetchProducts = /*#__PURE__*/function () {
  var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee5(ids) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", fetchData(ids, 'gid://shopify/Product/', productsToFetch, productsData, productsInProgress, fetchProductsBackgroundDebounced));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function fetchProducts(_x13) {
    return _ref5.apply(this, arguments);
  };
}();
var STOREFRONT_PRODUCTS_AND_FILTERS = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCT_QUERY, "\n\n  fragment FilterFields on Filter {\n    id\n    label\n    type\n    values {\n      id\n      label\n      count\n      input\n    }\n  }\n\n  fragment PageInfoFields on PageInfo {\n    hasPreviousPage\n    hasNextPage\n    endCursor\n  }\n");
var FETCH_COLLECTION_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCTS_AND_FILTERS, "\n\n  query Collection(\n    $handle: String\n    $afterCursor: String\n    $noOfProducts: Int!\n    $filtersArray: [ProductFilter!]\n    $sortField: ProductCollectionSortKeys\n    $reverse: Boolean\n  ) {\n    collection(handle: $handle) {\n      handle\n      products(\n        first: $noOfProducts\n        after: $afterCursor\n        filters: $filtersArray\n        sortKey: $sortField\n        reverse: $reverse\n      ) {\n        nodes {\n          ...ProductFields\n        }\n        filters {\n          ...FilterFields\n        }\n        pageInfo {\n          ...PageInfoFields\n        }\n      }\n      metafields(identifiers: { key: \"collection_cards\", namespace: \"custom\" }) {\n        references(first: 10) {\n          nodes {\n            ... on Metaobject {\n              id\n              cta_link: field(key: \"cta_link\") {\n                reference {\n                  ... on Page {\n                    handle\n                    onlineStoreUrl\n                  }\n                }\n              }\n              cta_text: field(key: \"cta_text\") {\n                value\n              }\n              block_position: field(key: \"block_position\") {\n                value\n              }\n              asset: field(key: \"asset\") {\n                reference {\n                  ... on MediaImage {\n                    image {\n                      url\n                      width\n                      height\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n");
var FETCH_SEARCH_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCTS_AND_FILTERS, "\n\n  query Search(\n    $query: String!\n    $afterCursor: String\n    $noOfProducts: Int!\n    $filtersArray: [ProductFilter!]\n    $sortField: SearchSortKeys\n    $reverse: Boolean\n  ) {\n    products: search(\n      query: $query\n      first: $noOfProducts\n      after: $afterCursor\n      productFilters: $filtersArray\n      sortKey: $sortField\n      reverse: $reverse\n      types: [PRODUCT]\n      prefix: LAST\n    ) {\n      nodes {\n        ...ProductFields\n      }\n      productFilters {\n        ...FilterFields\n      }\n      pageInfo {\n        ...PageInfoFields\n      }\n      totalCount\n    }\n  }\n");
var FETCH_RECOMMENDED_PRODUCTS_QUERY = /* GraphQL */"\n  ".concat(STOREFRONT_PRODUCT_QUERY, "\n\n  query ProductRecommendations($intent: ProductRecommendationIntent, $productId: ID!) {\n    productRecommendations(intent: $intent, productId: $productId) {\n      ...ProductFields\n    }\n  }\n");
var FETCH_SWATCHES_VALUES_QUERY = "\nquery {\n  metaobjects(type: \"color_metaobject\", first: 20) {\n    nodes {\n      color_name: field(key: \"name\") {\n        value\n      }\n      color_code: field(key: \"color_code\") {\n        value\n      }\n      color_gradient: field(key: \"color_gradient\") {\n        value\n      }\n      color_image: field(key: \"image\") {\n        reference {\n          ... on MediaImage {\n            image {\n              url\n              altText\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n";
var fetchColorMetaobjectsQuery = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(query) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: query
            })
          });
        case 2:
          response = _context6.sent;
          data = response.data;
          return _context6.abrupt("return", data.metaobjects);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function fetchColorMetaobjectsQuery(_x14) {
    return _ref6.apply(this, arguments);
  };
}()));
var fetchProductsWithQuery = /*#__PURE__*/function () {
  var _ref7 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee7(query, variables, getObjectWithProducts) {
    var _objectWithProducts$p;
    var normalize,
      response,
      data,
      objectWithProducts,
      products,
      _args7 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          normalize = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : function () {};
          _context7.next = 3;
          return (0,___WEBPACK_IMPORTED_MODULE_3__/* .request */ .WY)("https://".concat(Shopify.shop, "/api/2023-07/graphql.json"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({
              query: query,
              variables: variables
            })
          });
        case 3:
          response = _context7.sent;
          data = response.data;
          objectWithProducts = getObjectWithProducts(data);
          normalize(objectWithProducts);
          products = (objectWithProducts === null || objectWithProducts === void 0 ? void 0 : (_objectWithProducts$p = objectWithProducts.products) === null || _objectWithProducts$p === void 0 ? void 0 : _objectWithProducts$p.nodes) || [];
          products.forEach(function (product) {
            product.variants = product.variants.nodes;
            formatProductPrices(product);
            product.images = product.images.nodes;
            productsData[product.id] = product;
            productsData[product.id.replace('gid://shopify/Product/', '')] = product;
          });
          return _context7.abrupt("return", objectWithProducts);
        case 10:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function fetchProductsWithQuery(_x15, _x16, _x17) {
    return _ref7.apply(this, arguments);
  };
}();
var fetchCollection = /*#__PURE__*/function () {
  var _ref8 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee8(collectionHandle) {
    var afterCursor,
      noOfProducts,
      filtersArray,
      sortField,
      reverse,
      _args8 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          afterCursor = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
          noOfProducts = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : 12;
          filtersArray = _args8.length > 3 ? _args8[3] : undefined;
          sortField = _args8.length > 4 ? _args8[4] : undefined;
          reverse = _args8.length > 5 ? _args8[5] : undefined;
          return _context8.abrupt("return", fetchProductsWithQuery(FETCH_COLLECTION_PRODUCTS_QUERY, {
            handle: collectionHandle,
            afterCursor: afterCursor,
            noOfProducts: noOfProducts,
            filtersArray: filtersArray,
            sortField: sortField,
            reverse: reverse
          }, function (data) {
            return data.collection;
          }));
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchCollection(_x18) {
    return _ref8.apply(this, arguments);
  };
}();
var fetchSearch = /*#__PURE__*/function () {
  var _ref9 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee9(query) {
    var afterCursor,
      noOfProducts,
      filtersArray,
      sortField,
      reverse,
      _args9 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          afterCursor = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
          noOfProducts = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 12;
          filtersArray = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : [];
          sortField = _args9.length > 4 && _args9[4] !== undefined ? _args9[4] : 'RELEVANCE';
          reverse = _args9.length > 5 && _args9[5] !== undefined ? _args9[5] : false;
          return _context9.abrupt("return", fetchProductsWithQuery(FETCH_SEARCH_PRODUCTS_QUERY, {
            query: query,
            afterCursor: afterCursor,
            noOfProducts: noOfProducts,
            filtersArray: filtersArray,
            sortField: sortField,
            reverse: reverse
          }, function (data) {
            return data;
          }, function (search) {
            search.products.filters = search.products.productFilters;
            delete search.products.productFilters;
          }));
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function fetchSearch(_x19) {
    return _ref9.apply(this, arguments);
  };
}();
var fetchRecommendedProducts = /*#__PURE__*/function () {
  var _ref10 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee10(intent, productId) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", fetchProductsWithQuery(FETCH_RECOMMENDED_PRODUCTS_QUERY, {
            intent: intent,
            productId: productId
          }, function (data) {
            return {
              products: {
                nodes: data.productRecommendations || []
              }
            };
          }));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function fetchRecommendedProducts(_x20, _x21) {
    return _ref10.apply(this, arguments);
  };
}();
var fetchColorMetaobjects = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", fetchColorMetaobjectsQuery(FETCH_SWATCHES_VALUES_QUERY));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function fetchColorMetaobjects() {
    return _ref11.apply(this, arguments);
  };
}()));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "./assets/bundle." + ({"26":"subscribe-save","268":"image-carousel","301":"blog-grid-carousel","314":"blog-section","511":"cart","549":"product-grid-carousel","599":"kyh-product-card","600":"pdp","635":"reviews-carousel","653":"content-with-steps","683":"testimonials-carousel","684":"pdp-core","702":"kyh-ingredients-pdp","738":"landing-page-newsletter","988":"thumbnail-content"}[chunkId] || chunkId) + "" + {"26":"c744c4f24d29593a4189","243":"cc11e8ff4a00fbf82d1f","268":"197987482fed1cff8b70","301":"e9a0b768ad42e9fe7f68","314":"d936bfa860afc0e2dfcb","511":"49a2f9bcefcc4a4e3a5e","549":"00ef404559e911aff788","599":"81714d86a1f180772e58","600":"54d30d5d561b4f901e2f","635":"32222d47b7ebbd051b92","653":"0f8edf78f94f39fda278","683":"efaffdbc753ced3734b4","684":"3d20522e54e72f608a79","702":"35f070fe25b7134ce0da","738":"08b642ae41fcb8679898","988":"62d60dfff81feb58ad17"}[chunkId] + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "Anatta-Shopify-Development:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript)
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					var i = scripts.length - 1;
/******/ 					while (i > -1 && !scriptUrl) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl + "../";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			505: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkAnatta_Shopify_Development"] = self["webpackChunkAnatta_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [604,147,216], () => (__webpack_require__(4846)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;